/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateSettingInput = {
  company: string,
  parentId: string,
  settingId: string,
  value?: string | null,
};

export type Setting = {
  __typename: "Setting",
  company: string,
  parentId: string,
  settingId: string,
  value?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type GenerateReportInput = {
  type: string,
  params?: string | null,
};

export type GenerateReportResponse = {
  __typename: "GenerateReportResponse",
  result?: string | null,
};

export type CreateCompanyPaymentProcessorInput = {
  company: string,
  id?: string | null,
  name?: string | null,
  description?: string | null,
  active?: boolean | null,
  formValues?: Array< FieldValueInput | null > | null,
};

export type FieldValueInput = {
  name: string,
  type: string,
  value?: string | null,
};

export type ModelCompanyPaymentProcessorConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  active?: ModelBooleanInput | null,
  and?: Array< ModelCompanyPaymentProcessorConditionInput | null > | null,
  or?: Array< ModelCompanyPaymentProcessorConditionInput | null > | null,
  not?: ModelCompanyPaymentProcessorConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type CompanyPaymentProcessor = {
  __typename: "CompanyPaymentProcessor",
  company: string,
  id: string,
  name?: string | null,
  description?: string | null,
  active?: boolean | null,
  formValues?:  Array<FieldValue | null > | null,
  createdAt: string,
  updatedAt: string,
  processor?: PaymentProcessor | null,
};

export type FieldValue = {
  __typename: "FieldValue",
  name: string,
  type: string,
  value?: string | null,
};

export type PaymentProcessor = {
  __typename: "PaymentProcessor",
  id: string,
  name?: string | null,
  description?: string | null,
  active?: boolean | null,
  logo?: string | null,
  formFields?:  Array<FieldDefinition | null > | null,
  countries?: Array< string | null > | null,
  website?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type FieldDefinition = {
  __typename: "FieldDefinition",
  name: string,
  type: string,
  required: boolean,
  tooltip?: string | null,
};

export type UpdateCompanyPaymentProcessorInput = {
  company: string,
  id: string,
  name?: string | null,
  description?: string | null,
  active?: boolean | null,
  formValues?: Array< FieldValueInput | null > | null,
};

export type DeleteCompanyPaymentProcessorInput = {
  company: string,
  id: string,
};

export type DeleteLogInput = {
  company: string,
  id: string,
};

export type ModelLogConditionInput = {
  parentId?: ModelIDInput | null,
  event?: ModelStringInput | null,
  source?: ModelStringInput | null,
  destination?: ModelStringInput | null,
  description?: ModelStringInput | null,
  data?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelLogConditionInput | null > | null,
  or?: Array< ModelLogConditionInput | null > | null,
  not?: ModelLogConditionInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type Log = {
  __typename: "Log",
  company: string,
  id: string,
  parentId: string,
  event: string,
  source?: string | null,
  destination?: string | null,
  description?: string | null,
  data?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type InitOrderInput = {
  company: string,
  locationId: string,
  origin: OrderOriginEnum,
  customer: OrderCustomerInput,
  ref?: string | null,
  startTime?: string | null,
  endTime?: string | null,
  contactNumber?: string | null,
  deliveryFee?: number | null,
  deliveryTime?: string | null,
  deliveryAddress?: PhysicalAddressInput | null,
  billingAddress?: PhysicalAddressInput | null,
  notes?: string | null,
  deliveryType: DeliveryTypeEnum,
  type: OrderTypeEnum,
  products: Array< ProductInput | null >,
  paymentType: string,
  currency: string,
  deposit: number,
  total: number,
  subTotal: number,
  discountTotal: number,
  coupons?: Array< string | null > | null,
};

export enum OrderOriginEnum {
  INTERNAL = "INTERNAL",
  CUSTOMER = "CUSTOMER",
}


export type OrderCustomerInput = {
  id?: string | null,
  password?: string | null,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  phoneNumber?: string | null,
};

export type PhysicalAddressInput = {
  text?: string | null,
  name?: string | null,
  address1?: string | null,
  address2?: string | null,
  address3?: string | null,
  zip?: string | null,
  city?: string | null,
  region?: string | null,
  country?: string | null,
  coordinates?: CoordinatesInput | null,
};

export type CoordinatesInput = {
  lat: number,
  lon: number,
};

export enum DeliveryTypeEnum {
  COLLECTION = "COLLECTION",
  DELIVERY = "DELIVERY",
}


export enum OrderTypeEnum {
  RENTAL = "RENTAL",
  SALE = "SALE",
}


export type ProductInput = {
  productId: string,
  name?: string | null,
  resourceId?: string | null,
  coupons?: Array< string | null > | null,
  quantity: number,
  total?: number | null,
  subTotal?: number | null,
  discountTotal?: number | null,
};

export type InitOrderResponse = {
  __typename: "InitOrderResponse",
  order?: Order | null,
  payment?: Payment | null,
};

export type Order = {
  __typename: "Order",
  company: string,
  id: string,
  type?: OrderTypeEnum | null,
  status?: OrderStatusEnum | null,
  ref: string,
  locationId?: string | null,
  customerId: string,
  customerEmail?: string | null,
  customerFirstName?: string | null,
  customerLastName?: string | null,
  owner: string,
  categoryId?: string | null,
  startTime?: string | null,
  endTime?: string | null,
  contactNumber?: string | null,
  deliveryType?: DeliveryTypeEnum | null,
  billingAddress?: PhysicalAddress | null,
  deliveryAddress?: PhysicalAddress | null,
  deliveryTime?: string | null,
  returnedTime?: string | null,
  confirmedTime?: string | null,
  deliveredTime?: string | null,
  total?: number | null,
  deposit?: number | null,
  subTotal?: number | null,
  discountTotal?: number | null,
  deliveryFee?: number | null,
  reason?: string | null,
  notes?: string | null,
  createdAt: string,
  completedAt?: string | null,
  attributes?:  Array<Attribute | null > | null,
  updatedAt: string,
  customer?: Customer | null,
  payments?: ModelPaymentConnection | null,
  products?: ModelOrderProductConnection | null,
  coupons?: ModelOrderCouponConnection | null,
  stockItems?: ModelOrderStockItemConnection | null,
  logs?: ModelLogConnection | null,
};

export enum OrderStatusEnum {
  PENDING_PAYMENT = "PENDING_PAYMENT",
  CONFIRMED = "CONFIRMED",
  DELIVERED = "DELIVERED",
  RETURNED = "RETURNED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}


export type PhysicalAddress = {
  __typename: "PhysicalAddress",
  text?: string | null,
  name?: string | null,
  address1?: string | null,
  address2?: string | null,
  address3?: string | null,
  zip?: string | null,
  city?: string | null,
  region?: string | null,
  country?: string | null,
  coordinates?: Coordinates | null,
};

export type Coordinates = {
  __typename: "Coordinates",
  lat: number,
  lon: number,
};

export type Attribute = {
  __typename: "Attribute",
  name?: string | null,
  type?: string | null,
  value?: string | null,
};

export type Customer = {
  __typename: "Customer",
  company: string,
  id: string,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  physicalAddress?: PhysicalAddress | null,
  billingAddress?: PhysicalAddress | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelPaymentConnection = {
  __typename: "ModelPaymentConnection",
  items?:  Array<Payment | null > | null,
  nextToken?: string | null,
};

export type Payment = {
  __typename: "Payment",
  company: string,
  id: string,
  customerId: string,
  orderId: string,
  status: PaymentStatusEnum,
  currency: string,
  originalCurrency?: string | null,
  conversionRate?: number | null,
  totalGross: number,
  totalFee?: number | null,
  totalNet?: number | null,
  processorId: string,
  extPaymentId?: string | null,
  processorData?: string | null,
  createdAt: string,
  reason?: string | null,
  updatedAt: string,
  customer?: Customer | null,
  processor?: CompanyPaymentProcessor | null,
};

export enum PaymentStatusEnum {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  PENDING = "PENDING",
}


export type ModelOrderProductConnection = {
  __typename: "ModelOrderProductConnection",
  items?:  Array<OrderProduct | null > | null,
  nextToken?: string | null,
};

export type OrderProduct = {
  __typename: "OrderProduct",
  company: string,
  id: string,
  orderId: string,
  productId: string,
  owner: string,
  productInfo: OrderProductInfo,
  orderType: OrderTypeEnum,
  startTime?: string | null,
  endTime?: string | null,
  qty: number,
  total: number,
  subTotal: number,
  discountTotal: number,
  createdAt: string,
  updatedAt: string,
  order?: Order | null,
  product?: Product | null,
};

export type OrderProductInfo = {
  __typename: "OrderProductInfo",
  name: string,
  categoryId?: string | null,
  description?: string | null,
  dimensions?: Dimensions | null,
  imageUrl?: string | null,
  price: number,
};

export type Dimensions = {
  __typename: "Dimensions",
  height?: number | null,
  width?: number | null,
  weight?: number | null,
  length?: number | null,
};

export type Product = {
  __typename: "Product",
  company: string,
  id: string,
  comloc: string,
  sku: string,
  type: ProductTypeEnum,
  name: string,
  slug: string,
  excerpt?: string | null,
  mediaId: string,
  description?: string | null,
  attributes?:  Array<Attribute | null > | null,
  status?: ProductStatusEnum | null,
  price?: number | null,
  deposit?: number | null,
  cost?: number | null,
  dimensions?: Dimensions | null,
  qtyOnHand: number,
  qtyAvailable: number,
  qtyReserved: number,
  createdAt: string,
  updatedAt: string,
  version: number,
  settings?: ModelSettingConnection | null,
  bundleProducts?: ModelBundleProductConnection | null,
  features?: ModelFeatureConnection | null,
  stockItems?: ModelStockItemConnection | null,
  categories?: ModelProductCategoryConnection | null,
  upsellProducts?: ModelUpsellProductConnection | null,
  crossSellProducts?: ModelCrossSellProductConnection | null,
  image?: Media | null,
  media?: ModelMediaItemConnection | null,
  customPrice?: ModelProductPriceConnection | null,
};

export enum ProductTypeEnum {
  ITEM = "ITEM",
  RETAIL_ITEM = "RETAIL_ITEM",
  RENTAL_ITEM = "RENTAL_ITEM",
  BUNDLE_ITEM = "BUNDLE_ITEM",
  BUNDLE_RETAIL_ITEM = "BUNDLE_RETAIL_ITEM",
  BUNDLE_RENTAL_ITEM = "BUNDLE_RENTAL_ITEM",
  PVT_ITEM = "PVT_ITEM",
}


export enum ProductStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}


export type ModelSettingConnection = {
  __typename: "ModelSettingConnection",
  items?:  Array<Setting | null > | null,
  nextToken?: string | null,
};

export type ModelBundleProductConnection = {
  __typename: "ModelBundleProductConnection",
  items?:  Array<BundleProduct | null > | null,
  nextToken?: string | null,
};

export type BundleProduct = {
  __typename: "BundleProduct",
  company: string,
  id: string,
  parentId: string,
  productId: string,
  createdAt: string,
  updatedAt: string,
  product?: Product | null,
};

export type ModelFeatureConnection = {
  __typename: "ModelFeatureConnection",
  items?:  Array<Feature | null > | null,
  nextToken?: string | null,
};

export type Feature = {
  __typename: "Feature",
  company: string,
  id: string,
  parentId: string,
  categoryId?: string | null,
  text: string,
  description?: string | null,
  imageUrl?: string | null,
  seq?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelStockItemConnection = {
  __typename: "ModelStockItemConnection",
  items?:  Array<StockItem | null > | null,
  nextToken?: string | null,
};

export type StockItem = {
  __typename: "StockItem",
  company: string,
  id: string,
  location: string,
  serialNumber: string,
  status?: StockItemStatusEnum | null,
  productId: string,
  createdAt: string,
  updatedAt: string,
  product?: Product | null,
};

export enum StockItemStatusEnum {
  ACTIVE = "ACTIVE",
  AVAILABLE = "AVAILABLE",
  UNAVAILABLE = "UNAVAILABLE",
  IN_ORDER = "IN_ORDER",
  INACTIVE = "INACTIVE",
}


export type ModelProductCategoryConnection = {
  __typename: "ModelProductCategoryConnection",
  items?:  Array<ProductCategory | null > | null,
  nextToken?: string | null,
};

export type ProductCategory = {
  __typename: "ProductCategory",
  company: string,
  id: string,
  categoryId: string,
  productId: string,
  seq: string,
  createdAt: string,
  updatedAt: string,
  product?: Product | null,
  category?: Category | null,
};

export type Category = {
  __typename: "Category",
  company: string,
  id: string,
  name: string,
  description?: string | null,
  slug?: string | null,
  imageUrl?: string | null,
  parentId?: string | null,
  seq?: number | null,
  hidden?: boolean | null,
  createdAt: string,
  updatedAt: string,
  products?: ModelProductCategoryConnection | null,
  children?: ModelCategoryConnection | null,
};

export type ModelCategoryConnection = {
  __typename: "ModelCategoryConnection",
  items?:  Array<Category | null > | null,
  nextToken?: string | null,
};

export type ModelUpsellProductConnection = {
  __typename: "ModelUpsellProductConnection",
  items?:  Array<UpsellProduct | null > | null,
  nextToken?: string | null,
};

export type UpsellProduct = {
  __typename: "UpsellProduct",
  company: string,
  id: string,
  parentId: string,
  productId: string,
  seq?: number | null,
  createdAt: string,
  updatedAt: string,
  parent?: Product | null,
  product?: Product | null,
};

export type ModelCrossSellProductConnection = {
  __typename: "ModelCrossSellProductConnection",
  items?:  Array<CrossSellProduct | null > | null,
  nextToken?: string | null,
};

export type CrossSellProduct = {
  __typename: "CrossSellProduct",
  company: string,
  id: string,
  parentId: string,
  productId: string,
  seq?: number | null,
  createdAt: string,
  updatedAt: string,
  parent?: Product | null,
  product?: Product | null,
};

export type Media = {
  __typename: "Media",
  company: string,
  id: string,
  url: string,
  name?: string | null,
  attributes?:  Array<Attribute | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelMediaItemConnection = {
  __typename: "ModelMediaItemConnection",
  items?:  Array<MediaItem | null > | null,
  nextToken?: string | null,
};

export type MediaItem = {
  __typename: "MediaItem",
  company: string,
  id: string,
  mediaId: string,
  parentId: string,
  default?: boolean | null,
  createdAt: string,
  updatedAt: string,
  media?: Media | null,
};

export type ModelProductPriceConnection = {
  __typename: "ModelProductPriceConnection",
  items?:  Array<ProductPrice | null > | null,
  nextToken?: string | null,
};

export type ProductPrice = {
  __typename: "ProductPrice",
  company: string,
  id: string,
  productId: string,
  startTime?: string | null,
  endTime?: string | null,
  price?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelOrderCouponConnection = {
  __typename: "ModelOrderCouponConnection",
  items?:  Array<OrderCoupon | null > | null,
  nextToken?: string | null,
};

export type OrderCoupon = {
  __typename: "OrderCoupon",
  company: string,
  id: string,
  orderId: string,
  couponId: string,
  owner: string,
  coupon?: Coupon | null,
  discountTotal: number,
  createdAt: string,
  updatedAt: string,
  order?: Order | null,
};

export type Coupon = {
  __typename: "Coupon",
  company: string,
  id: string,
  description?: string | null,
  type: CouponTypeEnum,
  status: CouponStatusEnum,
  expireAt: string,
  startTime: string,
  value: number,
  settings?:  Array<Setting | null > | null,
  qtyAvailable: number,
  qtyReserved: number,
  qtyUsed: number,
  minSpend?: number | null,
  maxSpend?: number | null,
  createdAt: string,
  updatedAt: string,
  version: number,
  products?: ModelCouponProductConnection | null,
};

export enum CouponTypeEnum {
  PERCENTAGE = "PERCENTAGE",
  FIXED = "FIXED",
}


export enum CouponStatusEnum {
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
  EXPIRED = "EXPIRED",
}


export type ModelCouponProductConnection = {
  __typename: "ModelCouponProductConnection",
  items?:  Array<CouponProduct | null > | null,
  nextToken?: string | null,
};

export type CouponProduct = {
  __typename: "CouponProduct",
  company: string,
  id: string,
  couponId: string,
  productId: string,
  createdAt: string,
  updatedAt: string,
};

export type ModelOrderStockItemConnection = {
  __typename: "ModelOrderStockItemConnection",
  items?:  Array<OrderStockItem | null > | null,
  nextToken?: string | null,
};

export type OrderStockItem = {
  __typename: "OrderStockItem",
  company: string,
  id: string,
  orderId: string,
  stockItemId: string,
  orderType: OrderTypeEnum,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type ModelLogConnection = {
  __typename: "ModelLogConnection",
  items?:  Array<Log | null > | null,
  nextToken?: string | null,
};

export type EditOrderInput = {
  order: UpdateOrderInput,
  origin: OrderOriginEnum,
  reason?: string | null,
  options?: string | null,
};

export type UpdateOrderInput = {
  company: string,
  id: string,
  type?: OrderTypeEnum | null,
  status?: OrderStatusEnum | null,
  ref?: string | null,
  locationId?: string | null,
  customerId?: string | null,
  customerEmail?: string | null,
  customerFirstName?: string | null,
  customerLastName?: string | null,
  owner?: string | null,
  categoryId?: string | null,
  startTime?: string | null,
  endTime?: string | null,
  contactNumber?: string | null,
  deliveryType?: DeliveryTypeEnum | null,
  deliveryAddress?: PhysicalAddressInput | null,
  deliveryTime?: string | null,
  returnedTime?: string | null,
  confirmedTime?: string | null,
  deliveredTime?: string | null,
  total?: number | null,
  deposit?: number | null,
  subTotal?: number | null,
  discountTotal?: number | null,
  deliveryFee?: number | null,
  reason?: string | null,
  notes?: string | null,
  createdAt?: string | null,
  completedAt?: string | null,
};

export type CreateCompanyInput = {
  id?: string | null,
  status?: CompanyStatusEnum | null,
  plan: string,
  email: string,
  timeZone: string,
  locale?: string | null,
  country: string,
  currency?: string | null,
  billingDetails?: BillingDetailsInput | null,
  cards?: string | null,
};

export enum CompanyStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  TRIAL = "TRIAL",
  DEMO = "DEMO",
}


export type BillingDetailsInput = {
  processor: string,
  currency: string,
  nextPaymentDate: string,
  nextPaymentAmount: number,
};

export type ModelCompanyConditionInput = {
  status?: ModelCompanyStatusEnumInput | null,
  plan?: ModelStringInput | null,
  email?: ModelStringInput | null,
  timeZone?: ModelStringInput | null,
  locale?: ModelStringInput | null,
  country?: ModelStringInput | null,
  currency?: ModelStringInput | null,
  cards?: ModelStringInput | null,
  and?: Array< ModelCompanyConditionInput | null > | null,
  or?: Array< ModelCompanyConditionInput | null > | null,
  not?: ModelCompanyConditionInput | null,
};

export type ModelCompanyStatusEnumInput = {
  eq?: CompanyStatusEnum | null,
  ne?: CompanyStatusEnum | null,
};

export type Company = {
  __typename: "Company",
  id: string,
  status?: CompanyStatusEnum | null,
  plan: string,
  email: string,
  timeZone: string,
  locale?: string | null,
  country: string,
  currency?: string | null,
  billingDetails?: BillingDetails | null,
  cards?: string | null,
  settings?:  Array<Setting | null > | null,
  createdAt: string,
  updatedAt: string,
  accountPayments?: ModelAccountPaymentConnection | null,
};

export type BillingDetails = {
  __typename: "BillingDetails",
  processor: string,
  currency: string,
  nextPaymentDate: string,
  nextPaymentAmount: number,
};

export type ModelAccountPaymentConnection = {
  __typename: "ModelAccountPaymentConnection",
  items?:  Array<AccountPayment | null > | null,
  nextToken?: string | null,
};

export type AccountPayment = {
  __typename: "AccountPayment",
  company: string,
  id: string,
  plan: string,
  status: PaymentStatusEnum,
  currency: string,
  totalGross: number,
  totalFee: number,
  totalNet: number,
  processor?: string | null,
  processorData?: string | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateCompanyInput = {
  id: string,
  status?: CompanyStatusEnum | null,
  plan?: string | null,
  email?: string | null,
  timeZone?: string | null,
  locale?: string | null,
  country?: string | null,
  currency?: string | null,
  billingDetails?: BillingDetailsInput | null,
  cards?: string | null,
};

export type DeleteCompanyInput = {
  id: string,
};

export type CreateLocationInput = {
  company: string,
  id?: string | null,
  createdAt?: string | null,
  name: string,
  description?: string | null,
  type: LocationTypeEnum,
  email?: string | null,
  phoneNumber?: string | null,
  physicalAddress?: PhysicalAddressInput | null,
};

export enum LocationTypeEnum {
  COLLECTION_ONLY = "COLLECTION_ONLY",
  STOCK_ONLY = "STOCK_ONLY",
  STOCK_AND_COLLECTION = "STOCK_AND_COLLECTION",
}


export type ModelLocationConditionInput = {
  createdAt?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  type?: ModelLocationTypeEnumInput | null,
  email?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  and?: Array< ModelLocationConditionInput | null > | null,
  or?: Array< ModelLocationConditionInput | null > | null,
  not?: ModelLocationConditionInput | null,
};

export type ModelLocationTypeEnumInput = {
  eq?: LocationTypeEnum | null,
  ne?: LocationTypeEnum | null,
};

export type Location = {
  __typename: "Location",
  company: string,
  id: string,
  createdAt: string,
  name: string,
  description?: string | null,
  type: LocationTypeEnum,
  email?: string | null,
  phoneNumber?: string | null,
  physicalAddress?: PhysicalAddress | null,
  updatedAt: string,
  settings?: ModelSettingConnection | null,
};

export type UpdateLocationInput = {
  company: string,
  id: string,
  createdAt?: string | null,
  name?: string | null,
  description?: string | null,
  type?: LocationTypeEnum | null,
  email?: string | null,
  phoneNumber?: string | null,
  physicalAddress?: PhysicalAddressInput | null,
};

export type DeleteLocationInput = {
  company: string,
  id: string,
};

export type ModelSettingConditionInput = {
  value?: ModelStringInput | null,
  and?: Array< ModelSettingConditionInput | null > | null,
  or?: Array< ModelSettingConditionInput | null > | null,
  not?: ModelSettingConditionInput | null,
};

export type UpdateSettingInput = {
  company: string,
  parentId: string,
  settingId: string,
  value?: string | null,
};

export type DeleteSettingInput = {
  company: string,
  parentId: string,
  settingId: string,
};

export type CreateAccountPaymentInput = {
  company: string,
  id?: string | null,
  plan: string,
  status: PaymentStatusEnum,
  currency: string,
  totalGross: number,
  totalFee: number,
  totalNet: number,
  processor?: string | null,
  processorData?: string | null,
  createdAt?: string | null,
};

export type ModelAccountPaymentConditionInput = {
  plan?: ModelStringInput | null,
  status?: ModelPaymentStatusEnumInput | null,
  currency?: ModelStringInput | null,
  totalGross?: ModelFloatInput | null,
  totalFee?: ModelFloatInput | null,
  totalNet?: ModelFloatInput | null,
  processor?: ModelStringInput | null,
  processorData?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelAccountPaymentConditionInput | null > | null,
  or?: Array< ModelAccountPaymentConditionInput | null > | null,
  not?: ModelAccountPaymentConditionInput | null,
};

export type ModelPaymentStatusEnumInput = {
  eq?: PaymentStatusEnum | null,
  ne?: PaymentStatusEnum | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type UpdateAccountPaymentInput = {
  company: string,
  id: string,
  plan?: string | null,
  status?: PaymentStatusEnum | null,
  currency?: string | null,
  totalGross?: number | null,
  totalFee?: number | null,
  totalNet?: number | null,
  processor?: string | null,
  processorData?: string | null,
  createdAt?: string | null,
};

export type DeleteAccountPaymentInput = {
  company: string,
  id: string,
};

export type CreateCustomerInput = {
  company: string,
  id?: string | null,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  physicalAddress?: PhysicalAddressInput | null,
  billingAddress?: PhysicalAddressInput | null,
};

export type ModelCustomerConditionInput = {
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  and?: Array< ModelCustomerConditionInput | null > | null,
  or?: Array< ModelCustomerConditionInput | null > | null,
  not?: ModelCustomerConditionInput | null,
};

export type UpdateCustomerInput = {
  company: string,
  id: string,
  email?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  physicalAddress?: PhysicalAddressInput | null,
  billingAddress?: PhysicalAddressInput | null,
};

export type DeleteCustomerInput = {
  company: string,
  id: string,
};

export type CreatePaymentInput = {
  company: string,
  id?: string | null,
  customerId: string,
  orderId: string,
  status: PaymentStatusEnum,
  currency: string,
  originalCurrency?: string | null,
  conversionRate?: number | null,
  totalGross: number,
  totalFee?: number | null,
  totalNet?: number | null,
  processorId: string,
  extPaymentId?: string | null,
  processorData?: string | null,
  createdAt?: string | null,
  reason?: string | null,
};

export type ModelPaymentConditionInput = {
  orderId?: ModelIDInput | null,
  status?: ModelPaymentStatusEnumInput | null,
  currency?: ModelStringInput | null,
  originalCurrency?: ModelStringInput | null,
  conversionRate?: ModelFloatInput | null,
  totalGross?: ModelFloatInput | null,
  totalFee?: ModelFloatInput | null,
  totalNet?: ModelFloatInput | null,
  processorId?: ModelIDInput | null,
  extPaymentId?: ModelIDInput | null,
  processorData?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  reason?: ModelStringInput | null,
  and?: Array< ModelPaymentConditionInput | null > | null,
  or?: Array< ModelPaymentConditionInput | null > | null,
  not?: ModelPaymentConditionInput | null,
};

export type UpdatePaymentInput = {
  company: string,
  id: string,
  customerId?: string | null,
  orderId?: string | null,
  status?: PaymentStatusEnum | null,
  currency?: string | null,
  originalCurrency?: string | null,
  conversionRate?: number | null,
  totalGross?: number | null,
  totalFee?: number | null,
  totalNet?: number | null,
  processorId?: string | null,
  extPaymentId?: string | null,
  processorData?: string | null,
  createdAt?: string | null,
  reason?: string | null,
};

export type DeletePaymentInput = {
  company: string,
  id: string,
};

export type CreatePaymentProcessorInput = {
  id?: string | null,
  name?: string | null,
  description?: string | null,
  active?: boolean | null,
  logo?: string | null,
  formFields?: Array< FieldDefinitionInput | null > | null,
  countries?: Array< string | null > | null,
  website?: string | null,
};

export type FieldDefinitionInput = {
  name: string,
  type: string,
  required: boolean,
  tooltip?: string | null,
};

export type ModelPaymentProcessorConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  active?: ModelBooleanInput | null,
  logo?: ModelStringInput | null,
  countries?: ModelStringInput | null,
  website?: ModelStringInput | null,
  and?: Array< ModelPaymentProcessorConditionInput | null > | null,
  or?: Array< ModelPaymentProcessorConditionInput | null > | null,
  not?: ModelPaymentProcessorConditionInput | null,
};

export type UpdatePaymentProcessorInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  active?: boolean | null,
  logo?: string | null,
  formFields?: Array< FieldDefinitionInput | null > | null,
  countries?: Array< string | null > | null,
  website?: string | null,
};

export type DeletePaymentProcessorInput = {
  id: string,
};

export type CreateSequenceInput = {
  company: string,
  id?: string | null,
};

export type ModelSequenceConditionInput = {
  version?: ModelIntInput | null,
  and?: Array< ModelSequenceConditionInput | null > | null,
  or?: Array< ModelSequenceConditionInput | null > | null,
  not?: ModelSequenceConditionInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type Sequence = {
  __typename: "Sequence",
  company: string,
  id: string,
  version: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateSequenceInput = {
  company: string,
  id: string,
  version?: number | null,
  expectedVersion: number,
};

export type DeleteSequenceInput = {
  company: string,
  id: string,
  expectedVersion: number,
};

export type CreateOrderInput = {
  company: string,
  id: string,
  type?: OrderTypeEnum | null,
  status?: OrderStatusEnum | null,
  locationId?: string | null,
  customerId: string,
  customerEmail?: string | null,
  customerFirstName?: string | null,
  customerLastName?: string | null,
  owner: string,
  ref?: string | null,
  startTime?: string | null,
  endTime?: string | null,
  contactNumber?: string | null,
  deliveryType?: DeliveryTypeEnum | null,
  deliveryAddress?: PhysicalAddressInput | null,
  billingAddress?: PhysicalAddressInput | null,
  deliveryTime?: string | null,
  deliveredTime?: string | null,
  returnedTime?: string | null,
  deliveryFee?: number | null,
  total?: number | null,
  deposit?: number | null,
  subTotal?: number | null,
  discountTotal?: number | null,
  notes?: string | null,
  createdAt: string,
  completedAt: string,
};

export type ModelOrderConditionInput = {
  type?: ModelOrderTypeEnumInput | null,
  status?: ModelOrderStatusEnumInput | null,
  ref?: ModelStringInput | null,
  locationId?: ModelIDInput | null,
  customerId?: ModelIDInput | null,
  customerEmail?: ModelStringInput | null,
  customerFirstName?: ModelStringInput | null,
  customerLastName?: ModelStringInput | null,
  categoryId?: ModelIDInput | null,
  startTime?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  contactNumber?: ModelStringInput | null,
  deliveryType?: ModelDeliveryTypeEnumInput | null,
  deliveryTime?: ModelStringInput | null,
  returnedTime?: ModelStringInput | null,
  confirmedTime?: ModelStringInput | null,
  deliveredTime?: ModelStringInput | null,
  total?: ModelFloatInput | null,
  deposit?: ModelFloatInput | null,
  subTotal?: ModelFloatInput | null,
  discountTotal?: ModelFloatInput | null,
  deliveryFee?: ModelFloatInput | null,
  reason?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  completedAt?: ModelStringInput | null,
  and?: Array< ModelOrderConditionInput | null > | null,
  or?: Array< ModelOrderConditionInput | null > | null,
  not?: ModelOrderConditionInput | null,
};

export type ModelOrderTypeEnumInput = {
  eq?: OrderTypeEnum | null,
  ne?: OrderTypeEnum | null,
};

export type ModelOrderStatusEnumInput = {
  eq?: OrderStatusEnum | null,
  ne?: OrderStatusEnum | null,
};

export type ModelDeliveryTypeEnumInput = {
  eq?: DeliveryTypeEnum | null,
  ne?: DeliveryTypeEnum | null,
};

export type DeleteOrderInput = {
  company: string,
  id: string,
};

export type CreateOrderProductInput = {
  company: string,
  id?: string | null,
  orderId: string,
  productId: string,
  owner: string,
  productInfo: OrderProductInfoInput,
  orderType: OrderTypeEnum,
  startTime?: string | null,
  endTime?: string | null,
  qty: number,
  total: number,
  subTotal: number,
  discountTotal: number,
};

export type OrderProductInfoInput = {
  name: string,
  categoryId?: string | null,
  description?: string | null,
  dimensions?: DimensionsInput | null,
  imageUrl?: string | null,
  price: number,
};

export type DimensionsInput = {
  height?: number | null,
  width?: number | null,
  weight?: number | null,
  length?: number | null,
};

export type ModelOrderProductConditionInput = {
  orderId?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  orderType?: ModelOrderTypeEnumInput | null,
  startTime?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  qty?: ModelFloatInput | null,
  total?: ModelFloatInput | null,
  subTotal?: ModelFloatInput | null,
  discountTotal?: ModelFloatInput | null,
  and?: Array< ModelOrderProductConditionInput | null > | null,
  or?: Array< ModelOrderProductConditionInput | null > | null,
  not?: ModelOrderProductConditionInput | null,
};

export type UpdateOrderProductInput = {
  company: string,
  id: string,
  orderId?: string | null,
  productId?: string | null,
  owner?: string | null,
  productInfo?: OrderProductInfoInput | null,
  orderType?: OrderTypeEnum | null,
  startTime?: string | null,
  endTime?: string | null,
  qty?: number | null,
  total?: number | null,
  subTotal?: number | null,
  discountTotal?: number | null,
};

export type DeleteOrderProductInput = {
  company: string,
  id: string,
};

export type CreateOrderCouponInput = {
  company: string,
  id?: string | null,
  orderId: string,
  couponId: string,
  owner: string,
  discountTotal: number,
};

export type ModelOrderCouponConditionInput = {
  orderId?: ModelIDInput | null,
  couponId?: ModelIDInput | null,
  discountTotal?: ModelFloatInput | null,
  and?: Array< ModelOrderCouponConditionInput | null > | null,
  or?: Array< ModelOrderCouponConditionInput | null > | null,
  not?: ModelOrderCouponConditionInput | null,
};

export type UpdateOrderCouponInput = {
  company: string,
  id: string,
  orderId?: string | null,
  couponId?: string | null,
  owner?: string | null,
  discountTotal?: number | null,
};

export type DeleteOrderCouponInput = {
  company: string,
  id: string,
};

export type CreateOrderStockItemInput = {
  company: string,
  id?: string | null,
  orderId: string,
  stockItemId: string,
  orderType: OrderTypeEnum,
};

export type ModelOrderStockItemConditionInput = {
  orderId?: ModelIDInput | null,
  stockItemId?: ModelIDInput | null,
  orderType?: ModelOrderTypeEnumInput | null,
  and?: Array< ModelOrderStockItemConditionInput | null > | null,
  or?: Array< ModelOrderStockItemConditionInput | null > | null,
  not?: ModelOrderStockItemConditionInput | null,
};

export type UpdateOrderStockItemInput = {
  company: string,
  id: string,
  orderId?: string | null,
  stockItemId?: string | null,
  orderType?: OrderTypeEnum | null,
};

export type DeleteOrderStockItemInput = {
  company: string,
  id: string,
};

export type CreateProductInput = {
  company: string,
  id?: string | null,
  comloc: string,
  sku: string,
  type: ProductTypeEnum,
  name: string,
  slug: string,
  excerpt?: string | null,
  mediaId: string,
  description?: string | null,
  attributes?: Array< AttributeInput | null > | null,
  status?: ProductStatusEnum | null,
  price?: number | null,
  deposit?: number | null,
  cost?: number | null,
  dimensions?: DimensionsInput | null,
  qtyOnHand: number,
  qtyAvailable: number,
  qtyReserved: number,
};

export type AttributeInput = {
  name?: string | null,
  type?: string | null,
  value?: string | null,
};

export type ModelProductConditionInput = {
  comloc?: ModelStringInput | null,
  sku?: ModelStringInput | null,
  type?: ModelProductTypeEnumInput | null,
  name?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  excerpt?: ModelStringInput | null,
  mediaId?: ModelIDInput | null,
  description?: ModelStringInput | null,
  status?: ModelProductStatusEnumInput | null,
  price?: ModelFloatInput | null,
  deposit?: ModelFloatInput | null,
  cost?: ModelFloatInput | null,
  qtyOnHand?: ModelIntInput | null,
  qtyAvailable?: ModelIntInput | null,
  qtyReserved?: ModelIntInput | null,
  and?: Array< ModelProductConditionInput | null > | null,
  or?: Array< ModelProductConditionInput | null > | null,
  not?: ModelProductConditionInput | null,
};

export type ModelProductTypeEnumInput = {
  eq?: ProductTypeEnum | null,
  ne?: ProductTypeEnum | null,
};

export type ModelProductStatusEnumInput = {
  eq?: ProductStatusEnum | null,
  ne?: ProductStatusEnum | null,
};

export type UpdateProductInput = {
  company: string,
  id: string,
  comloc?: string | null,
  sku?: string | null,
  type?: ProductTypeEnum | null,
  name?: string | null,
  slug?: string | null,
  excerpt?: string | null,
  mediaId?: string | null,
  description?: string | null,
  attributes?: Array< AttributeInput | null > | null,
  status?: ProductStatusEnum | null,
  price?: number | null,
  deposit?: number | null,
  cost?: number | null,
  dimensions?: DimensionsInput | null,
  qtyOnHand?: number | null,
  qtyAvailable?: number | null,
  qtyReserved?: number | null,
  expectedVersion: number,
};

export type DeleteProductInput = {
  company: string,
  id: string,
  expectedVersion: number,
};

export type CreateBundleProductInput = {
  company: string,
  id?: string | null,
  parentId: string,
  productId: string,
};

export type ModelBundleProductConditionInput = {
  parentId?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  and?: Array< ModelBundleProductConditionInput | null > | null,
  or?: Array< ModelBundleProductConditionInput | null > | null,
  not?: ModelBundleProductConditionInput | null,
};

export type UpdateBundleProductInput = {
  company: string,
  id: string,
  parentId?: string | null,
  productId?: string | null,
};

export type DeleteBundleProductInput = {
  company: string,
  id: string,
};

export type CreateFeatureInput = {
  company: string,
  id?: string | null,
  parentId: string,
  categoryId?: string | null,
  text: string,
  description?: string | null,
  imageUrl?: string | null,
  seq?: number | null,
};

export type ModelFeatureConditionInput = {
  parentId?: ModelIDInput | null,
  categoryId?: ModelIDInput | null,
  text?: ModelStringInput | null,
  description?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  seq?: ModelIntInput | null,
  and?: Array< ModelFeatureConditionInput | null > | null,
  or?: Array< ModelFeatureConditionInput | null > | null,
  not?: ModelFeatureConditionInput | null,
};

export type UpdateFeatureInput = {
  company: string,
  id: string,
  parentId?: string | null,
  categoryId?: string | null,
  text?: string | null,
  description?: string | null,
  imageUrl?: string | null,
  seq?: number | null,
};

export type DeleteFeatureInput = {
  company: string,
  id: string,
};

export type CreateCouponInput = {
  company: string,
  id?: string | null,
  description?: string | null,
  type: CouponTypeEnum,
  status: CouponStatusEnum,
  expireAt: string,
  startTime: string,
  value: number,
  qtyAvailable: number,
  qtyReserved: number,
  qtyUsed: number,
  minSpend?: number | null,
  maxSpend?: number | null,
};

export type ModelCouponConditionInput = {
  description?: ModelStringInput | null,
  type?: ModelCouponTypeEnumInput | null,
  status?: ModelCouponStatusEnumInput | null,
  expireAt?: ModelStringInput | null,
  startTime?: ModelStringInput | null,
  value?: ModelFloatInput | null,
  qtyAvailable?: ModelIntInput | null,
  qtyReserved?: ModelIntInput | null,
  qtyUsed?: ModelIntInput | null,
  minSpend?: ModelIntInput | null,
  maxSpend?: ModelIntInput | null,
  and?: Array< ModelCouponConditionInput | null > | null,
  or?: Array< ModelCouponConditionInput | null > | null,
  not?: ModelCouponConditionInput | null,
};

export type ModelCouponTypeEnumInput = {
  eq?: CouponTypeEnum | null,
  ne?: CouponTypeEnum | null,
};

export type ModelCouponStatusEnumInput = {
  eq?: CouponStatusEnum | null,
  ne?: CouponStatusEnum | null,
};

export type UpdateCouponInput = {
  company: string,
  id: string,
  description?: string | null,
  type?: CouponTypeEnum | null,
  status?: CouponStatusEnum | null,
  expireAt?: string | null,
  startTime?: string | null,
  value?: number | null,
  qtyAvailable?: number | null,
  qtyReserved?: number | null,
  qtyUsed?: number | null,
  minSpend?: number | null,
  maxSpend?: number | null,
  expectedVersion: number,
};

export type DeleteCouponInput = {
  company: string,
  id: string,
  expectedVersion: number,
};

export type CreateCouponProductInput = {
  company: string,
  id?: string | null,
  couponId: string,
  productId: string,
};

export type ModelCouponProductConditionInput = {
  couponId?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  and?: Array< ModelCouponProductConditionInput | null > | null,
  or?: Array< ModelCouponProductConditionInput | null > | null,
  not?: ModelCouponProductConditionInput | null,
};

export type UpdateCouponProductInput = {
  company: string,
  id: string,
  couponId?: string | null,
  productId?: string | null,
};

export type DeleteCouponProductInput = {
  company: string,
  id: string,
};

export type CreateStockItemInput = {
  company: string,
  id?: string | null,
  location: string,
  serialNumber: string,
  status?: StockItemStatusEnum | null,
  productId: string,
};

export type ModelStockItemConditionInput = {
  location?: ModelIDInput | null,
  serialNumber?: ModelStringInput | null,
  status?: ModelStockItemStatusEnumInput | null,
  productId?: ModelIDInput | null,
  and?: Array< ModelStockItemConditionInput | null > | null,
  or?: Array< ModelStockItemConditionInput | null > | null,
  not?: ModelStockItemConditionInput | null,
};

export type ModelStockItemStatusEnumInput = {
  eq?: StockItemStatusEnum | null,
  ne?: StockItemStatusEnum | null,
};

export type UpdateStockItemInput = {
  company: string,
  id: string,
  location?: string | null,
  serialNumber?: string | null,
  status?: StockItemStatusEnum | null,
  productId?: string | null,
};

export type DeleteStockItemInput = {
  company: string,
  id: string,
};

export type CreateProductCategoryInput = {
  company: string,
  id?: string | null,
  categoryId: string,
  productId: string,
  seq: string,
};

export type ModelProductCategoryConditionInput = {
  categoryId?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  seq?: ModelStringInput | null,
  and?: Array< ModelProductCategoryConditionInput | null > | null,
  or?: Array< ModelProductCategoryConditionInput | null > | null,
  not?: ModelProductCategoryConditionInput | null,
};

export type UpdateProductCategoryInput = {
  company: string,
  id: string,
  categoryId?: string | null,
  productId?: string | null,
  seq?: string | null,
};

export type DeleteProductCategoryInput = {
  company: string,
  id: string,
};

export type CreateRelatedProductInput = {
  company: string,
  id?: string | null,
  parentId: string,
  productId: string,
  seq?: number | null,
};

export type ModelRelatedProductConditionInput = {
  parentId?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  seq?: ModelIntInput | null,
  and?: Array< ModelRelatedProductConditionInput | null > | null,
  or?: Array< ModelRelatedProductConditionInput | null > | null,
  not?: ModelRelatedProductConditionInput | null,
};

export type RelatedProduct = {
  __typename: "RelatedProduct",
  company: string,
  id: string,
  parentId: string,
  productId: string,
  seq?: number | null,
  createdAt: string,
  updatedAt: string,
  parent?: Product | null,
  product?: Product | null,
};

export type UpdateRelatedProductInput = {
  company: string,
  id: string,
  parentId?: string | null,
  productId?: string | null,
  seq?: number | null,
};

export type DeleteRelatedProductInput = {
  company: string,
  id: string,
};

export type CreateUpsellProductInput = {
  company: string,
  id?: string | null,
  parentId: string,
  productId: string,
  seq?: number | null,
};

export type ModelUpsellProductConditionInput = {
  parentId?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  seq?: ModelIntInput | null,
  and?: Array< ModelUpsellProductConditionInput | null > | null,
  or?: Array< ModelUpsellProductConditionInput | null > | null,
  not?: ModelUpsellProductConditionInput | null,
};

export type UpdateUpsellProductInput = {
  company: string,
  id: string,
  parentId?: string | null,
  productId?: string | null,
  seq?: number | null,
};

export type DeleteUpsellProductInput = {
  company: string,
  id: string,
};

export type CreateCrossSellProductInput = {
  company: string,
  id?: string | null,
  parentId: string,
  productId: string,
  seq?: number | null,
};

export type ModelCrossSellProductConditionInput = {
  parentId?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  seq?: ModelIntInput | null,
  and?: Array< ModelCrossSellProductConditionInput | null > | null,
  or?: Array< ModelCrossSellProductConditionInput | null > | null,
  not?: ModelCrossSellProductConditionInput | null,
};

export type UpdateCrossSellProductInput = {
  company: string,
  id: string,
  parentId?: string | null,
  productId?: string | null,
  seq?: number | null,
};

export type DeleteCrossSellProductInput = {
  company: string,
  id: string,
};

export type CreateCategoryInput = {
  company: string,
  id?: string | null,
  name: string,
  description?: string | null,
  slug?: string | null,
  imageUrl?: string | null,
  parentId?: string | null,
  seq?: number | null,
  hidden?: boolean | null,
};

export type ModelCategoryConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  parentId?: ModelIDInput | null,
  seq?: ModelIntInput | null,
  hidden?: ModelBooleanInput | null,
  and?: Array< ModelCategoryConditionInput | null > | null,
  or?: Array< ModelCategoryConditionInput | null > | null,
  not?: ModelCategoryConditionInput | null,
};

export type UpdateCategoryInput = {
  company: string,
  id: string,
  name?: string | null,
  description?: string | null,
  slug?: string | null,
  imageUrl?: string | null,
  parentId?: string | null,
  seq?: number | null,
  hidden?: boolean | null,
};

export type DeleteCategoryInput = {
  company: string,
  id: string,
};

export type CreateMediaInput = {
  company: string,
  id?: string | null,
  url: string,
  name?: string | null,
  attributes?: Array< AttributeInput | null > | null,
};

export type ModelMediaConditionInput = {
  url?: ModelStringInput | null,
  name?: ModelStringInput | null,
  and?: Array< ModelMediaConditionInput | null > | null,
  or?: Array< ModelMediaConditionInput | null > | null,
  not?: ModelMediaConditionInput | null,
};

export type UpdateMediaInput = {
  company: string,
  id: string,
  url?: string | null,
  name?: string | null,
  attributes?: Array< AttributeInput | null > | null,
};

export type DeleteMediaInput = {
  company: string,
  id: string,
};

export type CreateMediaItemInput = {
  company: string,
  id?: string | null,
  mediaId: string,
  parentId: string,
  default?: boolean | null,
};

export type ModelMediaItemConditionInput = {
  mediaId?: ModelIDInput | null,
  parentId?: ModelIDInput | null,
  default?: ModelBooleanInput | null,
  and?: Array< ModelMediaItemConditionInput | null > | null,
  or?: Array< ModelMediaItemConditionInput | null > | null,
  not?: ModelMediaItemConditionInput | null,
};

export type UpdateMediaItemInput = {
  company: string,
  id: string,
  mediaId?: string | null,
  parentId?: string | null,
  default?: boolean | null,
};

export type DeleteMediaItemInput = {
  company: string,
  id: string,
};

export type CreateShippingZoneInput = {
  company: string,
  id?: string | null,
  name: string,
  regions?: string | null,
};

export type ModelShippingZoneConditionInput = {
  name?: ModelStringInput | null,
  regions?: ModelStringInput | null,
  and?: Array< ModelShippingZoneConditionInput | null > | null,
  or?: Array< ModelShippingZoneConditionInput | null > | null,
  not?: ModelShippingZoneConditionInput | null,
};

export type ShippingZone = {
  __typename: "ShippingZone",
  company: string,
  id: string,
  name: string,
  regions?: string | null,
  createdAt: string,
  updatedAt: string,
  shippingRegions?: ModelShippingRegionConnection | null,
  shippingMethods?: ModelZoneShippingMethodConnection | null,
};

export type ModelShippingRegionConnection = {
  __typename: "ModelShippingRegionConnection",
  items?:  Array<ShippingRegion | null > | null,
  nextToken?: string | null,
};

export type ShippingRegion = {
  __typename: "ShippingRegion",
  company: string,
  id: string,
  zoneId: string,
  description?: string | null,
  type?: ShippingRegionTypeEnum | null,
  data?: string | null,
  createdAt: string,
  updatedAt: string,
  shippingZone?: ShippingZone | null,
};

export enum ShippingRegionTypeEnum {
  POSTAL_CODE = "POSTAL_CODE",
}


export type ModelZoneShippingMethodConnection = {
  __typename: "ModelZoneShippingMethodConnection",
  items?:  Array<ZoneShippingMethod | null > | null,
  nextToken?: string | null,
};

export type ZoneShippingMethod = {
  __typename: "ZoneShippingMethod",
  company: string,
  id: string,
  zoneId: string,
  shippingMethodId: string,
  createdAt: string,
  updatedAt: string,
  shippingMethod?: ShippingMethod | null,
};

export type ShippingMethod = {
  __typename: "ShippingMethod",
  company: string,
  id: string,
  type: DeliveryTypeEnum,
  name: string,
  cost: number,
  address?: PhysicalAddress | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateShippingZoneInput = {
  company: string,
  id: string,
  name?: string | null,
  regions?: string | null,
};

export type DeleteShippingZoneInput = {
  company: string,
  id: string,
};

export type CreateShippingRegionInput = {
  company: string,
  id?: string | null,
  zoneId: string,
  description?: string | null,
  type?: ShippingRegionTypeEnum | null,
  data?: string | null,
};

export type ModelShippingRegionConditionInput = {
  zoneId?: ModelIDInput | null,
  description?: ModelStringInput | null,
  type?: ModelShippingRegionTypeEnumInput | null,
  data?: ModelStringInput | null,
  and?: Array< ModelShippingRegionConditionInput | null > | null,
  or?: Array< ModelShippingRegionConditionInput | null > | null,
  not?: ModelShippingRegionConditionInput | null,
};

export type ModelShippingRegionTypeEnumInput = {
  eq?: ShippingRegionTypeEnum | null,
  ne?: ShippingRegionTypeEnum | null,
};

export type UpdateShippingRegionInput = {
  company: string,
  id: string,
  zoneId?: string | null,
  description?: string | null,
  type?: ShippingRegionTypeEnum | null,
  data?: string | null,
};

export type DeleteShippingRegionInput = {
  company: string,
  id: string,
};

export type CreateShippingMethodInput = {
  company: string,
  id?: string | null,
  type: DeliveryTypeEnum,
  name: string,
  cost: number,
  address?: PhysicalAddressInput | null,
};

export type ModelShippingMethodConditionInput = {
  type?: ModelDeliveryTypeEnumInput | null,
  name?: ModelStringInput | null,
  cost?: ModelFloatInput | null,
  and?: Array< ModelShippingMethodConditionInput | null > | null,
  or?: Array< ModelShippingMethodConditionInput | null > | null,
  not?: ModelShippingMethodConditionInput | null,
};

export type UpdateShippingMethodInput = {
  company: string,
  id: string,
  type?: DeliveryTypeEnum | null,
  name?: string | null,
  cost?: number | null,
  address?: PhysicalAddressInput | null,
};

export type DeleteShippingMethodInput = {
  company: string,
  id: string,
};

export type CreateZoneShippingMethodInput = {
  company: string,
  id?: string | null,
  zoneId: string,
  shippingMethodId: string,
};

export type ModelZoneShippingMethodConditionInput = {
  zoneId?: ModelIDInput | null,
  shippingMethodId?: ModelIDInput | null,
  and?: Array< ModelZoneShippingMethodConditionInput | null > | null,
  or?: Array< ModelZoneShippingMethodConditionInput | null > | null,
  not?: ModelZoneShippingMethodConditionInput | null,
};

export type UpdateZoneShippingMethodInput = {
  company: string,
  id: string,
  zoneId?: string | null,
  shippingMethodId?: string | null,
};

export type DeleteZoneShippingMethodInput = {
  company: string,
  id: string,
};

export type CreateProductPriceInput = {
  company: string,
  id?: string | null,
  productId: string,
  startTime?: string | null,
  endTime?: string | null,
  price?: number | null,
};

export type ModelProductPriceConditionInput = {
  productId?: ModelIDInput | null,
  startTime?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  and?: Array< ModelProductPriceConditionInput | null > | null,
  or?: Array< ModelProductPriceConditionInput | null > | null,
  not?: ModelProductPriceConditionInput | null,
};

export type UpdateProductPriceInput = {
  company: string,
  id: string,
  productId?: string | null,
  startTime?: string | null,
  endTime?: string | null,
  price?: number | null,
};

export type DeleteProductPriceInput = {
  company: string,
  id: string,
};

export type CreateDiscountInput = {
  company: string,
  id?: string | null,
  name: string,
  rules?: Array< DiscountRuleInput | null > | null,
};

export type DiscountRuleInput = {
  conditionScope: DiscountScopeEnum,
  condition: DiscountRuleConditionInput,
  discountScope: DiscountScopeEnum,
  type: DiscountRuleTypeEnum,
  value: number,
};

export enum DiscountScopeEnum {
  BASKET = "BASKET",
  PRODUCT = "PRODUCT",
  DEPOSIT = "DEPOSIT",
}


export type DiscountRuleConditionInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export enum DiscountRuleTypeEnum {
  RANGE = "RANGE",
  QTY = "QTY",
}


export type ModelDiscountConditionInput = {
  name?: ModelStringInput | null,
  and?: Array< ModelDiscountConditionInput | null > | null,
  or?: Array< ModelDiscountConditionInput | null > | null,
  not?: ModelDiscountConditionInput | null,
};

export type Discount = {
  __typename: "Discount",
  company: string,
  id: string,
  name: string,
  rules?:  Array<DiscountRule | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type DiscountRule = {
  __typename: "DiscountRule",
  conditionScope: DiscountScopeEnum,
  condition: DiscountRuleCondition,
  discountScope: DiscountScopeEnum,
  type: DiscountRuleTypeEnum,
  value: number,
};

export type DiscountRuleCondition = {
  __typename: "DiscountRuleCondition",
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type UpdateDiscountInput = {
  company: string,
  id: string,
  name?: string | null,
  rules?: Array< DiscountRuleInput | null > | null,
};

export type DeleteDiscountInput = {
  company: string,
  id: string,
};

export type CreateLogInput = {
  company: string,
  id?: string | null,
  parentId: string,
  event: string,
  source?: string | null,
  destination?: string | null,
  description?: string | null,
  data?: string | null,
  createdAt?: string | null,
};

export type UpdateLogInput = {
  company: string,
  id: string,
  parentId?: string | null,
  event?: string | null,
  source?: string | null,
  destination?: string | null,
  description?: string | null,
  data?: string | null,
  createdAt?: string | null,
};

export type IsExistingCustomerResponse = {
  __typename: "IsExistingCustomerResponse",
  exists: boolean,
  customer?: ExistingCustomerInfo | null,
};

export type ExistingCustomerInfo = {
  __typename: "ExistingCustomerInfo",
  id?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  status?: string | null,
};

export type GetAvailableStockQtyInput = {
  company: string,
  products: Array< string | null >,
  location?: string | null,
  startTime: string,
  endTime: string,
};

export type AvailableStockQtyResponse = {
  __typename: "AvailableStockQtyResponse",
  productId: string,
  locationQty?:  Array<LocationQty | null > | null,
};

export type LocationQty = {
  __typename: "LocationQty",
  location: string,
  qty: number,
};

export type ValidateCouponInput = {
  customerId?: string | null,
  customerEmail?: string | null,
  couponId?: string | null,
};

export type ModelCompanyFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelCompanyStatusEnumInput | null,
  plan?: ModelStringInput | null,
  email?: ModelStringInput | null,
  timeZone?: ModelStringInput | null,
  locale?: ModelStringInput | null,
  country?: ModelStringInput | null,
  currency?: ModelStringInput | null,
  cards?: ModelStringInput | null,
  and?: Array< ModelCompanyFilterInput | null > | null,
  or?: Array< ModelCompanyFilterInput | null > | null,
  not?: ModelCompanyFilterInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelCompanyConnection = {
  __typename: "ModelCompanyConnection",
  items?:  Array<Company | null > | null,
  nextToken?: string | null,
};

export type ModelIDKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelLocationFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  type?: ModelLocationTypeEnumInput | null,
  email?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  and?: Array< ModelLocationFilterInput | null > | null,
  or?: Array< ModelLocationFilterInput | null > | null,
  not?: ModelLocationFilterInput | null,
};

export type ModelLocationConnection = {
  __typename: "ModelLocationConnection",
  items?:  Array<Location | null > | null,
  nextToken?: string | null,
};

export type ModelSettingPrimaryCompositeKeyConditionInput = {
  eq?: ModelSettingPrimaryCompositeKeyInput | null,
  le?: ModelSettingPrimaryCompositeKeyInput | null,
  lt?: ModelSettingPrimaryCompositeKeyInput | null,
  ge?: ModelSettingPrimaryCompositeKeyInput | null,
  gt?: ModelSettingPrimaryCompositeKeyInput | null,
  between?: Array< ModelSettingPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelSettingPrimaryCompositeKeyInput | null,
};

export type ModelSettingPrimaryCompositeKeyInput = {
  parentId?: string | null,
  settingId?: string | null,
};

export type ModelSettingFilterInput = {
  company?: ModelIDInput | null,
  parentId?: ModelIDInput | null,
  settingId?: ModelStringInput | null,
  value?: ModelStringInput | null,
  and?: Array< ModelSettingFilterInput | null > | null,
  or?: Array< ModelSettingFilterInput | null > | null,
  not?: ModelSettingFilterInput | null,
};

export type ModelAccountPaymentFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  plan?: ModelStringInput | null,
  status?: ModelPaymentStatusEnumInput | null,
  currency?: ModelStringInput | null,
  totalGross?: ModelFloatInput | null,
  totalFee?: ModelFloatInput | null,
  totalNet?: ModelFloatInput | null,
  processor?: ModelStringInput | null,
  processorData?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelAccountPaymentFilterInput | null > | null,
  or?: Array< ModelAccountPaymentFilterInput | null > | null,
  not?: ModelAccountPaymentFilterInput | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelCustomerFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  and?: Array< ModelCustomerFilterInput | null > | null,
  or?: Array< ModelCustomerFilterInput | null > | null,
  not?: ModelCustomerFilterInput | null,
};

export type ModelCustomerConnection = {
  __typename: "ModelCustomerConnection",
  items?:  Array<Customer | null > | null,
  nextToken?: string | null,
};

export type SearchableCustomerFilterInput = {
  company?: SearchableIDFilterInput | null,
  id?: SearchableIDFilterInput | null,
  email?: SearchableStringFilterInput | null,
  firstName?: SearchableStringFilterInput | null,
  lastName?: SearchableStringFilterInput | null,
  and?: Array< SearchableCustomerFilterInput | null > | null,
  or?: Array< SearchableCustomerFilterInput | null > | null,
  not?: SearchableCustomerFilterInput | null,
};

export type SearchableIDFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
};

export type SearchableStringFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
};

export type SearchableCustomerSortInput = {
  field?: SearchableCustomerSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableCustomerSortableFields {
  company = "company",
  id = "id",
  email = "email",
  firstName = "firstName",
  lastName = "lastName",
}


export enum SearchableSortDirection {
  asc = "asc",
  desc = "desc",
}


export type SearchableCustomerConnection = {
  __typename: "SearchableCustomerConnection",
  items?:  Array<Customer | null > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type ModelPaymentFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  customerId?: ModelIDInput | null,
  orderId?: ModelIDInput | null,
  status?: ModelPaymentStatusEnumInput | null,
  currency?: ModelStringInput | null,
  originalCurrency?: ModelStringInput | null,
  conversionRate?: ModelFloatInput | null,
  totalGross?: ModelFloatInput | null,
  totalFee?: ModelFloatInput | null,
  totalNet?: ModelFloatInput | null,
  processorId?: ModelIDInput | null,
  extPaymentId?: ModelIDInput | null,
  processorData?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  reason?: ModelStringInput | null,
  and?: Array< ModelPaymentFilterInput | null > | null,
  or?: Array< ModelPaymentFilterInput | null > | null,
  not?: ModelPaymentFilterInput | null,
};

export type ModelPaymentByOrderIdCreatedTimeCompositeKeyConditionInput = {
  eq?: ModelPaymentByOrderIdCreatedTimeCompositeKeyInput | null,
  le?: ModelPaymentByOrderIdCreatedTimeCompositeKeyInput | null,
  lt?: ModelPaymentByOrderIdCreatedTimeCompositeKeyInput | null,
  ge?: ModelPaymentByOrderIdCreatedTimeCompositeKeyInput | null,
  gt?: ModelPaymentByOrderIdCreatedTimeCompositeKeyInput | null,
  between?: Array< ModelPaymentByOrderIdCreatedTimeCompositeKeyInput | null > | null,
  beginsWith?: ModelPaymentByOrderIdCreatedTimeCompositeKeyInput | null,
};

export type ModelPaymentByOrderIdCreatedTimeCompositeKeyInput = {
  orderId?: string | null,
  createdAt?: string | null,
};

export type SearchablePaymentFilterInput = {
  company?: SearchableIDFilterInput | null,
  id?: SearchableIDFilterInput | null,
  customerId?: SearchableIDFilterInput | null,
  orderId?: SearchableIDFilterInput | null,
  currency?: SearchableStringFilterInput | null,
  originalCurrency?: SearchableStringFilterInput | null,
  conversionRate?: SearchableFloatFilterInput | null,
  totalGross?: SearchableFloatFilterInput | null,
  totalFee?: SearchableFloatFilterInput | null,
  totalNet?: SearchableFloatFilterInput | null,
  processorId?: SearchableIDFilterInput | null,
  extPaymentId?: SearchableIDFilterInput | null,
  processorData?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  reason?: SearchableStringFilterInput | null,
  and?: Array< SearchablePaymentFilterInput | null > | null,
  or?: Array< SearchablePaymentFilterInput | null > | null,
  not?: SearchablePaymentFilterInput | null,
};

export type SearchableFloatFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchablePaymentSortInput = {
  field?: SearchablePaymentSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchablePaymentSortableFields {
  company = "company",
  id = "id",
  customerId = "customerId",
  orderId = "orderId",
  currency = "currency",
  originalCurrency = "originalCurrency",
  conversionRate = "conversionRate",
  totalGross = "totalGross",
  totalFee = "totalFee",
  totalNet = "totalNet",
  processorId = "processorId",
  extPaymentId = "extPaymentId",
  processorData = "processorData",
  createdAt = "createdAt",
  reason = "reason",
}


export type SearchablePaymentConnection = {
  __typename: "SearchablePaymentConnection",
  items?:  Array<Payment | null > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type ModelPaymentProcessorFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  active?: ModelBooleanInput | null,
  logo?: ModelStringInput | null,
  countries?: ModelStringInput | null,
  website?: ModelStringInput | null,
  and?: Array< ModelPaymentProcessorFilterInput | null > | null,
  or?: Array< ModelPaymentProcessorFilterInput | null > | null,
  not?: ModelPaymentProcessorFilterInput | null,
};

export type ModelPaymentProcessorConnection = {
  __typename: "ModelPaymentProcessorConnection",
  items?:  Array<PaymentProcessor | null > | null,
  nextToken?: string | null,
};

export type ModelCompanyPaymentProcessorFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  active?: ModelBooleanInput | null,
  and?: Array< ModelCompanyPaymentProcessorFilterInput | null > | null,
  or?: Array< ModelCompanyPaymentProcessorFilterInput | null > | null,
  not?: ModelCompanyPaymentProcessorFilterInput | null,
};

export type ModelCompanyPaymentProcessorConnection = {
  __typename: "ModelCompanyPaymentProcessorConnection",
  items?:  Array<CompanyPaymentProcessor | null > | null,
  nextToken?: string | null,
};

export type ModelSequenceFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  version?: ModelIntInput | null,
  and?: Array< ModelSequenceFilterInput | null > | null,
  or?: Array< ModelSequenceFilterInput | null > | null,
  not?: ModelSequenceFilterInput | null,
};

export type ModelSequenceConnection = {
  __typename: "ModelSequenceConnection",
  items?:  Array<Sequence | null > | null,
  nextToken?: string | null,
};

export type ModelOrderFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  type?: ModelOrderTypeEnumInput | null,
  status?: ModelOrderStatusEnumInput | null,
  ref?: ModelStringInput | null,
  locationId?: ModelIDInput | null,
  customerId?: ModelIDInput | null,
  customerEmail?: ModelStringInput | null,
  customerFirstName?: ModelStringInput | null,
  customerLastName?: ModelStringInput | null,
  owner?: ModelIDInput | null,
  categoryId?: ModelIDInput | null,
  startTime?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  contactNumber?: ModelStringInput | null,
  deliveryType?: ModelDeliveryTypeEnumInput | null,
  deliveryTime?: ModelStringInput | null,
  returnedTime?: ModelStringInput | null,
  confirmedTime?: ModelStringInput | null,
  deliveredTime?: ModelStringInput | null,
  total?: ModelFloatInput | null,
  deposit?: ModelFloatInput | null,
  subTotal?: ModelFloatInput | null,
  discountTotal?: ModelFloatInput | null,
  deliveryFee?: ModelFloatInput | null,
  reason?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  completedAt?: ModelStringInput | null,
  and?: Array< ModelOrderFilterInput | null > | null,
  or?: Array< ModelOrderFilterInput | null > | null,
  not?: ModelOrderFilterInput | null,
};

export type ModelOrderConnection = {
  __typename: "ModelOrderConnection",
  items?:  Array<Order | null > | null,
  nextToken?: string | null,
};

export type ModelOrderByStatusStartTimeCompositeKeyConditionInput = {
  eq?: ModelOrderByStatusStartTimeCompositeKeyInput | null,
  le?: ModelOrderByStatusStartTimeCompositeKeyInput | null,
  lt?: ModelOrderByStatusStartTimeCompositeKeyInput | null,
  ge?: ModelOrderByStatusStartTimeCompositeKeyInput | null,
  gt?: ModelOrderByStatusStartTimeCompositeKeyInput | null,
  between?: Array< ModelOrderByStatusStartTimeCompositeKeyInput | null > | null,
  beginsWith?: ModelOrderByStatusStartTimeCompositeKeyInput | null,
};

export type ModelOrderByStatusStartTimeCompositeKeyInput = {
  status?: OrderStatusEnum | null,
  startTime?: string | null,
};

export type ModelOrderByStatusEndTimeCompositeKeyConditionInput = {
  eq?: ModelOrderByStatusEndTimeCompositeKeyInput | null,
  le?: ModelOrderByStatusEndTimeCompositeKeyInput | null,
  lt?: ModelOrderByStatusEndTimeCompositeKeyInput | null,
  ge?: ModelOrderByStatusEndTimeCompositeKeyInput | null,
  gt?: ModelOrderByStatusEndTimeCompositeKeyInput | null,
  between?: Array< ModelOrderByStatusEndTimeCompositeKeyInput | null > | null,
  beginsWith?: ModelOrderByStatusEndTimeCompositeKeyInput | null,
};

export type ModelOrderByStatusEndTimeCompositeKeyInput = {
  status?: OrderStatusEnum | null,
  endTime?: string | null,
};

export type ModelOrderByStatusCompletedAtCompositeKeyConditionInput = {
  eq?: ModelOrderByStatusCompletedAtCompositeKeyInput | null,
  le?: ModelOrderByStatusCompletedAtCompositeKeyInput | null,
  lt?: ModelOrderByStatusCompletedAtCompositeKeyInput | null,
  ge?: ModelOrderByStatusCompletedAtCompositeKeyInput | null,
  gt?: ModelOrderByStatusCompletedAtCompositeKeyInput | null,
  between?: Array< ModelOrderByStatusCompletedAtCompositeKeyInput | null > | null,
  beginsWith?: ModelOrderByStatusCompletedAtCompositeKeyInput | null,
};

export type ModelOrderByStatusCompletedAtCompositeKeyInput = {
  company?: string | null,
  completedAt?: string | null,
};

export type ModelOrderByCustomerIdCompositeKeyConditionInput = {
  eq?: ModelOrderByCustomerIdCompositeKeyInput | null,
  le?: ModelOrderByCustomerIdCompositeKeyInput | null,
  lt?: ModelOrderByCustomerIdCompositeKeyInput | null,
  ge?: ModelOrderByCustomerIdCompositeKeyInput | null,
  gt?: ModelOrderByCustomerIdCompositeKeyInput | null,
  between?: Array< ModelOrderByCustomerIdCompositeKeyInput | null > | null,
  beginsWith?: ModelOrderByCustomerIdCompositeKeyInput | null,
};

export type ModelOrderByCustomerIdCompositeKeyInput = {
  customerId?: string | null,
  createdAt?: string | null,
};

export type SearchableOrderFilterInput = {
  company?: SearchableIDFilterInput | null,
  id?: SearchableIDFilterInput | null,
  ref?: SearchableStringFilterInput | null,
  locationId?: SearchableIDFilterInput | null,
  customerId?: SearchableIDFilterInput | null,
  customerEmail?: SearchableStringFilterInput | null,
  customerFirstName?: SearchableStringFilterInput | null,
  customerLastName?: SearchableStringFilterInput | null,
  owner?: SearchableIDFilterInput | null,
  categoryId?: SearchableIDFilterInput | null,
  startTime?: SearchableStringFilterInput | null,
  endTime?: SearchableStringFilterInput | null,
  contactNumber?: SearchableStringFilterInput | null,
  deliveryTime?: SearchableStringFilterInput | null,
  returnedTime?: SearchableStringFilterInput | null,
  confirmedTime?: SearchableStringFilterInput | null,
  deliveredTime?: SearchableStringFilterInput | null,
  total?: SearchableFloatFilterInput | null,
  deposit?: SearchableFloatFilterInput | null,
  subTotal?: SearchableFloatFilterInput | null,
  discountTotal?: SearchableFloatFilterInput | null,
  deliveryFee?: SearchableFloatFilterInput | null,
  reason?: SearchableStringFilterInput | null,
  notes?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  completedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableOrderFilterInput | null > | null,
  or?: Array< SearchableOrderFilterInput | null > | null,
  not?: SearchableOrderFilterInput | null,
};

export type SearchableOrderSortInput = {
  field?: SearchableOrderSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableOrderSortableFields {
  company = "company",
  id = "id",
  ref = "ref",
  locationId = "locationId",
  customerId = "customerId",
  customerEmail = "customerEmail",
  customerFirstName = "customerFirstName",
  customerLastName = "customerLastName",
  owner = "owner",
  categoryId = "categoryId",
  startTime = "startTime",
  endTime = "endTime",
  contactNumber = "contactNumber",
  deliveryTime = "deliveryTime",
  returnedTime = "returnedTime",
  confirmedTime = "confirmedTime",
  deliveredTime = "deliveredTime",
  total = "total",
  deposit = "deposit",
  subTotal = "subTotal",
  discountTotal = "discountTotal",
  deliveryFee = "deliveryFee",
  reason = "reason",
  notes = "notes",
  createdAt = "createdAt",
  completedAt = "completedAt",
}


export type SearchableOrderConnection = {
  __typename: "SearchableOrderConnection",
  items?:  Array<Order | null > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type ModelOrderProductFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  orderId?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  owner?: ModelIDInput | null,
  orderType?: ModelOrderTypeEnumInput | null,
  startTime?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  qty?: ModelFloatInput | null,
  total?: ModelFloatInput | null,
  subTotal?: ModelFloatInput | null,
  discountTotal?: ModelFloatInput | null,
  and?: Array< ModelOrderProductFilterInput | null > | null,
  or?: Array< ModelOrderProductFilterInput | null > | null,
  not?: ModelOrderProductFilterInput | null,
};

export type ModelOrderProductByProductCompositeKeyConditionInput = {
  eq?: ModelOrderProductByProductCompositeKeyInput | null,
  le?: ModelOrderProductByProductCompositeKeyInput | null,
  lt?: ModelOrderProductByProductCompositeKeyInput | null,
  ge?: ModelOrderProductByProductCompositeKeyInput | null,
  gt?: ModelOrderProductByProductCompositeKeyInput | null,
  between?: Array< ModelOrderProductByProductCompositeKeyInput | null > | null,
  beginsWith?: ModelOrderProductByProductCompositeKeyInput | null,
};

export type ModelOrderProductByProductCompositeKeyInput = {
  productId?: string | null,
  startTime?: string | null,
};

export type ModelOrderCouponFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  orderId?: ModelIDInput | null,
  couponId?: ModelIDInput | null,
  owner?: ModelIDInput | null,
  discountTotal?: ModelFloatInput | null,
  and?: Array< ModelOrderCouponFilterInput | null > | null,
  or?: Array< ModelOrderCouponFilterInput | null > | null,
  not?: ModelOrderCouponFilterInput | null,
};

export type ModelOrderStockItemFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  orderId?: ModelIDInput | null,
  stockItemId?: ModelIDInput | null,
  orderType?: ModelOrderTypeEnumInput | null,
  and?: Array< ModelOrderStockItemFilterInput | null > | null,
  or?: Array< ModelOrderStockItemFilterInput | null > | null,
  not?: ModelOrderStockItemFilterInput | null,
};

export type ModelProductFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  comloc?: ModelStringInput | null,
  sku?: ModelStringInput | null,
  type?: ModelProductTypeEnumInput | null,
  name?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  excerpt?: ModelStringInput | null,
  mediaId?: ModelIDInput | null,
  description?: ModelStringInput | null,
  status?: ModelProductStatusEnumInput | null,
  price?: ModelFloatInput | null,
  deposit?: ModelFloatInput | null,
  cost?: ModelFloatInput | null,
  qtyOnHand?: ModelIntInput | null,
  qtyAvailable?: ModelIntInput | null,
  qtyReserved?: ModelIntInput | null,
  and?: Array< ModelProductFilterInput | null > | null,
  or?: Array< ModelProductFilterInput | null > | null,
  not?: ModelProductFilterInput | null,
};

export type ModelProductConnection = {
  __typename: "ModelProductConnection",
  items?:  Array<Product | null > | null,
  nextToken?: string | null,
};

export type ModelProductListProductsByTypeCompositeKeyConditionInput = {
  eq?: ModelProductListProductsByTypeCompositeKeyInput | null,
  le?: ModelProductListProductsByTypeCompositeKeyInput | null,
  lt?: ModelProductListProductsByTypeCompositeKeyInput | null,
  ge?: ModelProductListProductsByTypeCompositeKeyInput | null,
  gt?: ModelProductListProductsByTypeCompositeKeyInput | null,
  between?: Array< ModelProductListProductsByTypeCompositeKeyInput | null > | null,
  beginsWith?: ModelProductListProductsByTypeCompositeKeyInput | null,
};

export type ModelProductListProductsByTypeCompositeKeyInput = {
  type?: ProductTypeEnum | null,
  name?: string | null,
};

export type ModelProductListProductsByStatusCompositeKeyConditionInput = {
  eq?: ModelProductListProductsByStatusCompositeKeyInput | null,
  le?: ModelProductListProductsByStatusCompositeKeyInput | null,
  lt?: ModelProductListProductsByStatusCompositeKeyInput | null,
  ge?: ModelProductListProductsByStatusCompositeKeyInput | null,
  gt?: ModelProductListProductsByStatusCompositeKeyInput | null,
  between?: Array< ModelProductListProductsByStatusCompositeKeyInput | null > | null,
  beginsWith?: ModelProductListProductsByStatusCompositeKeyInput | null,
};

export type ModelProductListProductsByStatusCompositeKeyInput = {
  type?: ProductTypeEnum | null,
  status?: ProductStatusEnum | null,
  name?: string | null,
};

export type ModelProductListLocationProductsByTypeCompositeKeyConditionInput = {
  eq?: ModelProductListLocationProductsByTypeCompositeKeyInput | null,
  le?: ModelProductListLocationProductsByTypeCompositeKeyInput | null,
  lt?: ModelProductListLocationProductsByTypeCompositeKeyInput | null,
  ge?: ModelProductListLocationProductsByTypeCompositeKeyInput | null,
  gt?: ModelProductListLocationProductsByTypeCompositeKeyInput | null,
  between?: Array< ModelProductListLocationProductsByTypeCompositeKeyInput | null > | null,
  beginsWith?: ModelProductListLocationProductsByTypeCompositeKeyInput | null,
};

export type ModelProductListLocationProductsByTypeCompositeKeyInput = {
  type?: ProductTypeEnum | null,
  status?: ProductStatusEnum | null,
  name?: string | null,
};

export type SearchableProductFilterInput = {
  company?: SearchableIDFilterInput | null,
  id?: SearchableIDFilterInput | null,
  sku?: SearchableStringFilterInput | null,
  name?: SearchableStringFilterInput | null,
  type?: SearchableStringFilterInput | null,
  slug?: SearchableStringFilterInput | null,
  description?: SearchableStringFilterInput | null,
  price?: SearchableFloatFilterInput | null,
  cost?: SearchableFloatFilterInput | null,
  qtyOnHand?: SearchableIntFilterInput | null,
  qtyAvailable?: SearchableIntFilterInput | null,
  qtyReserved?: SearchableIntFilterInput | null,
  and?: Array< SearchableProductFilterInput | null > | null,
  or?: Array< SearchableProductFilterInput | null > | null,
  not?: SearchableProductFilterInput | null,
};

export type SearchableIntFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchableProductSortInput = {
  field?: SearchableProductSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableProductSortableFields {
  company = "company",
  id = "id",
  comloc = "comloc",
  sku = "sku",
  name = "name",
  slug = "slug",
  excerpt = "excerpt",
  mediaId = "mediaId",
  description = "description",
  price = "price",
  deposit = "deposit",
  cost = "cost",
  qtyOnHand = "qtyOnHand",
  qtyAvailable = "qtyAvailable",
  qtyReserved = "qtyReserved",
}


export type SearchableProductConnection = {
  __typename: "SearchableProductConnection",
  items?:  Array<Product | null > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type ModelBundleProductFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  parentId?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  and?: Array< ModelBundleProductFilterInput | null > | null,
  or?: Array< ModelBundleProductFilterInput | null > | null,
  not?: ModelBundleProductFilterInput | null,
};

export type ModelFeatureFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  parentId?: ModelIDInput | null,
  categoryId?: ModelIDInput | null,
  text?: ModelStringInput | null,
  description?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  seq?: ModelIntInput | null,
  and?: Array< ModelFeatureFilterInput | null > | null,
  or?: Array< ModelFeatureFilterInput | null > | null,
  not?: ModelFeatureFilterInput | null,
};

export type ModelCouponFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  description?: ModelStringInput | null,
  type?: ModelCouponTypeEnumInput | null,
  status?: ModelCouponStatusEnumInput | null,
  expireAt?: ModelStringInput | null,
  startTime?: ModelStringInput | null,
  value?: ModelFloatInput | null,
  qtyAvailable?: ModelIntInput | null,
  qtyReserved?: ModelIntInput | null,
  qtyUsed?: ModelIntInput | null,
  minSpend?: ModelIntInput | null,
  maxSpend?: ModelIntInput | null,
  and?: Array< ModelCouponFilterInput | null > | null,
  or?: Array< ModelCouponFilterInput | null > | null,
  not?: ModelCouponFilterInput | null,
};

export type ModelCouponConnection = {
  __typename: "ModelCouponConnection",
  items?:  Array<Coupon | null > | null,
  nextToken?: string | null,
};

export type ModelCouponByStatusExpireAtCompositeKeyConditionInput = {
  eq?: ModelCouponByStatusExpireAtCompositeKeyInput | null,
  le?: ModelCouponByStatusExpireAtCompositeKeyInput | null,
  lt?: ModelCouponByStatusExpireAtCompositeKeyInput | null,
  ge?: ModelCouponByStatusExpireAtCompositeKeyInput | null,
  gt?: ModelCouponByStatusExpireAtCompositeKeyInput | null,
  between?: Array< ModelCouponByStatusExpireAtCompositeKeyInput | null > | null,
  beginsWith?: ModelCouponByStatusExpireAtCompositeKeyInput | null,
};

export type ModelCouponByStatusExpireAtCompositeKeyInput = {
  status?: CouponStatusEnum | null,
  expireAt?: string | null,
};

export type ModelCouponProductFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  couponId?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  and?: Array< ModelCouponProductFilterInput | null > | null,
  or?: Array< ModelCouponProductFilterInput | null > | null,
  not?: ModelCouponProductFilterInput | null,
};

export type ModelStockItemFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  location?: ModelIDInput | null,
  serialNumber?: ModelStringInput | null,
  status?: ModelStockItemStatusEnumInput | null,
  productId?: ModelIDInput | null,
  and?: Array< ModelStockItemFilterInput | null > | null,
  or?: Array< ModelStockItemFilterInput | null > | null,
  not?: ModelStockItemFilterInput | null,
};

export type ModelProductCategoryFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  categoryId?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  seq?: ModelStringInput | null,
  and?: Array< ModelProductCategoryFilterInput | null > | null,
  or?: Array< ModelProductCategoryFilterInput | null > | null,
  not?: ModelProductCategoryFilterInput | null,
};

export type ModelProductCategoryByCategorySeqCompositeKeyConditionInput = {
  eq?: ModelProductCategoryByCategorySeqCompositeKeyInput | null,
  le?: ModelProductCategoryByCategorySeqCompositeKeyInput | null,
  lt?: ModelProductCategoryByCategorySeqCompositeKeyInput | null,
  ge?: ModelProductCategoryByCategorySeqCompositeKeyInput | null,
  gt?: ModelProductCategoryByCategorySeqCompositeKeyInput | null,
  between?: Array< ModelProductCategoryByCategorySeqCompositeKeyInput | null > | null,
  beginsWith?: ModelProductCategoryByCategorySeqCompositeKeyInput | null,
};

export type ModelProductCategoryByCategorySeqCompositeKeyInput = {
  categoryId?: string | null,
  seq?: string | null,
};

export type SearchableProductCategoryFilterInput = {
  company?: SearchableIDFilterInput | null,
  id?: SearchableIDFilterInput | null,
  categoryId?: SearchableIDFilterInput | null,
  productId?: SearchableIDFilterInput | null,
  seq?: SearchableStringFilterInput | null,
  and?: Array< SearchableProductCategoryFilterInput | null > | null,
  or?: Array< SearchableProductCategoryFilterInput | null > | null,
  not?: SearchableProductCategoryFilterInput | null,
};

export type SearchableProductCategorySortInput = {
  field?: SearchableProductCategorySortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableProductCategorySortableFields {
  company = "company",
  id = "id",
  categoryId = "categoryId",
  productId = "productId",
  seq = "seq",
}


export type SearchableProductCategoryConnection = {
  __typename: "SearchableProductCategoryConnection",
  items?:  Array<ProductCategory | null > | null,
  nextToken?: string | null,
  total?: number | null,
};

export type ModelRelatedProductFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  parentId?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  seq?: ModelIntInput | null,
  and?: Array< ModelRelatedProductFilterInput | null > | null,
  or?: Array< ModelRelatedProductFilterInput | null > | null,
  not?: ModelRelatedProductFilterInput | null,
};

export type ModelRelatedProductConnection = {
  __typename: "ModelRelatedProductConnection",
  items?:  Array<RelatedProduct | null > | null,
  nextToken?: string | null,
};

export type ModelUpsellProductFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  parentId?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  seq?: ModelIntInput | null,
  and?: Array< ModelUpsellProductFilterInput | null > | null,
  or?: Array< ModelUpsellProductFilterInput | null > | null,
  not?: ModelUpsellProductFilterInput | null,
};

export type ModelCrossSellProductFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  parentId?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  seq?: ModelIntInput | null,
  and?: Array< ModelCrossSellProductFilterInput | null > | null,
  or?: Array< ModelCrossSellProductFilterInput | null > | null,
  not?: ModelCrossSellProductFilterInput | null,
};

export type ModelCategoryFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  parentId?: ModelIDInput | null,
  seq?: ModelIntInput | null,
  hidden?: ModelBooleanInput | null,
  and?: Array< ModelCategoryFilterInput | null > | null,
  or?: Array< ModelCategoryFilterInput | null > | null,
  not?: ModelCategoryFilterInput | null,
};

export type ModelMediaFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  url?: ModelStringInput | null,
  name?: ModelStringInput | null,
  and?: Array< ModelMediaFilterInput | null > | null,
  or?: Array< ModelMediaFilterInput | null > | null,
  not?: ModelMediaFilterInput | null,
};

export type ModelMediaConnection = {
  __typename: "ModelMediaConnection",
  items?:  Array<Media | null > | null,
  nextToken?: string | null,
};

export type ModelShippingZoneFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  regions?: ModelStringInput | null,
  and?: Array< ModelShippingZoneFilterInput | null > | null,
  or?: Array< ModelShippingZoneFilterInput | null > | null,
  not?: ModelShippingZoneFilterInput | null,
};

export type ModelShippingZoneConnection = {
  __typename: "ModelShippingZoneConnection",
  items?:  Array<ShippingZone | null > | null,
  nextToken?: string | null,
};

export type ModelShippingRegionFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  zoneId?: ModelIDInput | null,
  description?: ModelStringInput | null,
  type?: ModelShippingRegionTypeEnumInput | null,
  data?: ModelStringInput | null,
  and?: Array< ModelShippingRegionFilterInput | null > | null,
  or?: Array< ModelShippingRegionFilterInput | null > | null,
  not?: ModelShippingRegionFilterInput | null,
};

export type ModelShippingRegionByTypeDataCompositeKeyConditionInput = {
  eq?: ModelShippingRegionByTypeDataCompositeKeyInput | null,
  le?: ModelShippingRegionByTypeDataCompositeKeyInput | null,
  lt?: ModelShippingRegionByTypeDataCompositeKeyInput | null,
  ge?: ModelShippingRegionByTypeDataCompositeKeyInput | null,
  gt?: ModelShippingRegionByTypeDataCompositeKeyInput | null,
  between?: Array< ModelShippingRegionByTypeDataCompositeKeyInput | null > | null,
  beginsWith?: ModelShippingRegionByTypeDataCompositeKeyInput | null,
};

export type ModelShippingRegionByTypeDataCompositeKeyInput = {
  type?: ShippingRegionTypeEnum | null,
  data?: string | null,
};

export type ModelShippingMethodFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  type?: ModelDeliveryTypeEnumInput | null,
  name?: ModelStringInput | null,
  cost?: ModelFloatInput | null,
  and?: Array< ModelShippingMethodFilterInput | null > | null,
  or?: Array< ModelShippingMethodFilterInput | null > | null,
  not?: ModelShippingMethodFilterInput | null,
};

export type ModelShippingMethodConnection = {
  __typename: "ModelShippingMethodConnection",
  items?:  Array<ShippingMethod | null > | null,
  nextToken?: string | null,
};

export type ModelZoneShippingMethodFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  zoneId?: ModelIDInput | null,
  shippingMethodId?: ModelIDInput | null,
  and?: Array< ModelZoneShippingMethodFilterInput | null > | null,
  or?: Array< ModelZoneShippingMethodFilterInput | null > | null,
  not?: ModelZoneShippingMethodFilterInput | null,
};

export type ModelProductPriceFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  startTime?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  and?: Array< ModelProductPriceFilterInput | null > | null,
  or?: Array< ModelProductPriceFilterInput | null > | null,
  not?: ModelProductPriceFilterInput | null,
};

export type ModelDiscountFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  and?: Array< ModelDiscountFilterInput | null > | null,
  or?: Array< ModelDiscountFilterInput | null > | null,
  not?: ModelDiscountFilterInput | null,
};

export type ModelDiscountConnection = {
  __typename: "ModelDiscountConnection",
  items?:  Array<Discount | null > | null,
  nextToken?: string | null,
};

export type ModelLogFilterInput = {
  company?: ModelIDInput | null,
  id?: ModelIDInput | null,
  parentId?: ModelIDInput | null,
  event?: ModelStringInput | null,
  source?: ModelStringInput | null,
  destination?: ModelStringInput | null,
  description?: ModelStringInput | null,
  data?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelLogFilterInput | null > | null,
  or?: Array< ModelLogFilterInput | null > | null,
  not?: ModelLogFilterInput | null,
};

export type ModelLogByParentIdEventCompositeKeyConditionInput = {
  eq?: ModelLogByParentIdEventCompositeKeyInput | null,
  le?: ModelLogByParentIdEventCompositeKeyInput | null,
  lt?: ModelLogByParentIdEventCompositeKeyInput | null,
  ge?: ModelLogByParentIdEventCompositeKeyInput | null,
  gt?: ModelLogByParentIdEventCompositeKeyInput | null,
  between?: Array< ModelLogByParentIdEventCompositeKeyInput | null > | null,
  beginsWith?: ModelLogByParentIdEventCompositeKeyInput | null,
};

export type ModelLogByParentIdEventCompositeKeyInput = {
  parentId?: string | null,
  event?: string | null,
};

export type UpsertSettingsMutationVariables = {
  input: Array< CreateSettingInput | null >,
};

export type UpsertSettingsMutation = {
  upsertSettings?:  Array< {
    __typename: "Setting",
    company: string,
    parentId: string,
    settingId: string,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null > | null,
};

export type GenerateReportMutationVariables = {
  input: GenerateReportInput,
};

export type GenerateReportMutation = {
  generateReport?:  {
    __typename: "GenerateReportResponse",
    result?: string | null,
  } | null,
};

export type CreateCompanyPaymentProcessorMutationVariables = {
  input: CreateCompanyPaymentProcessorInput,
  condition?: ModelCompanyPaymentProcessorConditionInput | null,
};

export type CreateCompanyPaymentProcessorMutation = {
  createCompanyPaymentProcessor?:  {
    __typename: "CompanyPaymentProcessor",
    company: string,
    id: string,
    name?: string | null,
    description?: string | null,
    active?: boolean | null,
    formValues?:  Array< {
      __typename: "FieldValue",
      name: string,
      type: string,
      value?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    processor?:  {
      __typename: "PaymentProcessor",
      id: string,
      name?: string | null,
      description?: string | null,
      active?: boolean | null,
      logo?: string | null,
      formFields?:  Array< {
        __typename: "FieldDefinition",
        name: string,
        type: string,
        required: boolean,
        tooltip?: string | null,
      } | null > | null,
      countries?: Array< string | null > | null,
      website?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type UpdateCompanyPaymentProcessorMutationVariables = {
  input: UpdateCompanyPaymentProcessorInput,
  condition?: ModelCompanyPaymentProcessorConditionInput | null,
};

export type UpdateCompanyPaymentProcessorMutation = {
  updateCompanyPaymentProcessor?:  {
    __typename: "CompanyPaymentProcessor",
    company: string,
    id: string,
    name?: string | null,
    description?: string | null,
    active?: boolean | null,
    formValues?:  Array< {
      __typename: "FieldValue",
      name: string,
      type: string,
      value?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    processor?:  {
      __typename: "PaymentProcessor",
      id: string,
      name?: string | null,
      description?: string | null,
      active?: boolean | null,
      logo?: string | null,
      formFields?:  Array< {
        __typename: "FieldDefinition",
        name: string,
        type: string,
        required: boolean,
        tooltip?: string | null,
      } | null > | null,
      countries?: Array< string | null > | null,
      website?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeleteCompanyPaymentProcessorMutationVariables = {
  input: DeleteCompanyPaymentProcessorInput,
  condition?: ModelCompanyPaymentProcessorConditionInput | null,
};

export type DeleteCompanyPaymentProcessorMutation = {
  deleteCompanyPaymentProcessor?:  {
    __typename: "CompanyPaymentProcessor",
    company: string,
    id: string,
    name?: string | null,
    description?: string | null,
    active?: boolean | null,
    formValues?:  Array< {
      __typename: "FieldValue",
      name: string,
      type: string,
      value?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    processor?:  {
      __typename: "PaymentProcessor",
      id: string,
      name?: string | null,
      description?: string | null,
      active?: boolean | null,
      logo?: string | null,
      formFields?:  Array< {
        __typename: "FieldDefinition",
        name: string,
        type: string,
        required: boolean,
        tooltip?: string | null,
      } | null > | null,
      countries?: Array< string | null > | null,
      website?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeleteLogMutationVariables = {
  input: DeleteLogInput,
  condition?: ModelLogConditionInput | null,
};

export type DeleteLogMutation = {
  deleteLog?:  {
    __typename: "Log",
    company: string,
    id: string,
    parentId: string,
    event: string,
    source?: string | null,
    destination?: string | null,
    description?: string | null,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type InitOrderMutationVariables = {
  input: InitOrderInput,
};

export type InitOrderMutation = {
  initOrder?:  {
    __typename: "InitOrderResponse",
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    payment?:  {
      __typename: "Payment",
      company: string,
      id: string,
      customerId: string,
      orderId: string,
      status: PaymentStatusEnum,
      currency: string,
      originalCurrency?: string | null,
      conversionRate?: number | null,
      totalGross: number,
      totalFee?: number | null,
      totalNet?: number | null,
      processorId: string,
      extPaymentId?: string | null,
      processorData?: string | null,
      createdAt: string,
      reason?: string | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      processor?:  {
        __typename: "CompanyPaymentProcessor",
        company: string,
        id: string,
        name?: string | null,
        description?: string | null,
        active?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type EditOrderMutationVariables = {
  input: EditOrderInput,
};

export type EditOrderMutation = {
  editOrder?:  {
    __typename: "Order",
    company: string,
    id: string,
    type?: OrderTypeEnum | null,
    status?: OrderStatusEnum | null,
    ref: string,
    locationId?: string | null,
    customerId: string,
    customerEmail?: string | null,
    customerFirstName?: string | null,
    customerLastName?: string | null,
    owner: string,
    categoryId?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    contactNumber?: string | null,
    deliveryType?: DeliveryTypeEnum | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryTime?: string | null,
    returnedTime?: string | null,
    confirmedTime?: string | null,
    deliveredTime?: string | null,
    total?: number | null,
    deposit?: number | null,
    subTotal?: number | null,
    discountTotal?: number | null,
    deliveryFee?: number | null,
    reason?: string | null,
    notes?: string | null,
    createdAt: string,
    completedAt?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    updatedAt: string,
    customer?:  {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    payments?:  {
      __typename: "ModelPaymentConnection",
      items?:  Array< {
        __typename: "Payment",
        company: string,
        id: string,
        customerId: string,
        orderId: string,
        status: PaymentStatusEnum,
        currency: string,
        originalCurrency?: string | null,
        conversionRate?: number | null,
        totalGross: number,
        totalFee?: number | null,
        totalNet?: number | null,
        processorId: string,
        extPaymentId?: string | null,
        processorData?: string | null,
        createdAt: string,
        reason?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    products?:  {
      __typename: "ModelOrderProductConnection",
      items?:  Array< {
        __typename: "OrderProduct",
        company: string,
        id: string,
        orderId: string,
        productId: string,
        owner: string,
        orderType: OrderTypeEnum,
        startTime?: string | null,
        endTime?: string | null,
        qty: number,
        total: number,
        subTotal: number,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    coupons?:  {
      __typename: "ModelOrderCouponConnection",
      items?:  Array< {
        __typename: "OrderCoupon",
        company: string,
        id: string,
        orderId: string,
        couponId: string,
        owner: string,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelOrderStockItemConnection",
      items?:  Array< {
        __typename: "OrderStockItem",
        company: string,
        id: string,
        orderId: string,
        stockItemId: string,
        orderType: OrderTypeEnum,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    logs?:  {
      __typename: "ModelLogConnection",
      items?:  Array< {
        __typename: "Log",
        company: string,
        id: string,
        parentId: string,
        event: string,
        source?: string | null,
        destination?: string | null,
        description?: string | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateCompanyMutationVariables = {
  input: CreateCompanyInput,
  condition?: ModelCompanyConditionInput | null,
};

export type CreateCompanyMutation = {
  createCompany?:  {
    __typename: "Company",
    id: string,
    status?: CompanyStatusEnum | null,
    plan: string,
    email: string,
    timeZone: string,
    locale?: string | null,
    country: string,
    currency?: string | null,
    billingDetails?:  {
      __typename: "BillingDetails",
      processor: string,
      currency: string,
      nextPaymentDate: string,
      nextPaymentAmount: number,
    } | null,
    cards?: string | null,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    accountPayments?:  {
      __typename: "ModelAccountPaymentConnection",
      items?:  Array< {
        __typename: "AccountPayment",
        company: string,
        id: string,
        plan: string,
        status: PaymentStatusEnum,
        currency: string,
        totalGross: number,
        totalFee: number,
        totalNet: number,
        processor?: string | null,
        processorData?: string | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateCompanyMutationVariables = {
  input: UpdateCompanyInput,
  condition?: ModelCompanyConditionInput | null,
};

export type UpdateCompanyMutation = {
  updateCompany?:  {
    __typename: "Company",
    id: string,
    status?: CompanyStatusEnum | null,
    plan: string,
    email: string,
    timeZone: string,
    locale?: string | null,
    country: string,
    currency?: string | null,
    billingDetails?:  {
      __typename: "BillingDetails",
      processor: string,
      currency: string,
      nextPaymentDate: string,
      nextPaymentAmount: number,
    } | null,
    cards?: string | null,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    accountPayments?:  {
      __typename: "ModelAccountPaymentConnection",
      items?:  Array< {
        __typename: "AccountPayment",
        company: string,
        id: string,
        plan: string,
        status: PaymentStatusEnum,
        currency: string,
        totalGross: number,
        totalFee: number,
        totalNet: number,
        processor?: string | null,
        processorData?: string | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteCompanyMutationVariables = {
  input: DeleteCompanyInput,
  condition?: ModelCompanyConditionInput | null,
};

export type DeleteCompanyMutation = {
  deleteCompany?:  {
    __typename: "Company",
    id: string,
    status?: CompanyStatusEnum | null,
    plan: string,
    email: string,
    timeZone: string,
    locale?: string | null,
    country: string,
    currency?: string | null,
    billingDetails?:  {
      __typename: "BillingDetails",
      processor: string,
      currency: string,
      nextPaymentDate: string,
      nextPaymentAmount: number,
    } | null,
    cards?: string | null,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    accountPayments?:  {
      __typename: "ModelAccountPaymentConnection",
      items?:  Array< {
        __typename: "AccountPayment",
        company: string,
        id: string,
        plan: string,
        status: PaymentStatusEnum,
        currency: string,
        totalGross: number,
        totalFee: number,
        totalNet: number,
        processor?: string | null,
        processorData?: string | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateLocationMutationVariables = {
  input: CreateLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type CreateLocationMutation = {
  createLocation?:  {
    __typename: "Location",
    company: string,
    id: string,
    createdAt: string,
    name: string,
    description?: string | null,
    type: LocationTypeEnum,
    email?: string | null,
    phoneNumber?: string | null,
    physicalAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    updatedAt: string,
    settings?:  {
      __typename: "ModelSettingConnection",
      items?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateLocationMutationVariables = {
  input: UpdateLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type UpdateLocationMutation = {
  updateLocation?:  {
    __typename: "Location",
    company: string,
    id: string,
    createdAt: string,
    name: string,
    description?: string | null,
    type: LocationTypeEnum,
    email?: string | null,
    phoneNumber?: string | null,
    physicalAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    updatedAt: string,
    settings?:  {
      __typename: "ModelSettingConnection",
      items?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteLocationMutationVariables = {
  input: DeleteLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type DeleteLocationMutation = {
  deleteLocation?:  {
    __typename: "Location",
    company: string,
    id: string,
    createdAt: string,
    name: string,
    description?: string | null,
    type: LocationTypeEnum,
    email?: string | null,
    phoneNumber?: string | null,
    physicalAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    updatedAt: string,
    settings?:  {
      __typename: "ModelSettingConnection",
      items?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateSettingMutationVariables = {
  input: CreateSettingInput,
  condition?: ModelSettingConditionInput | null,
};

export type CreateSettingMutation = {
  createSetting?:  {
    __typename: "Setting",
    company: string,
    parentId: string,
    settingId: string,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSettingMutationVariables = {
  input: UpdateSettingInput,
  condition?: ModelSettingConditionInput | null,
};

export type UpdateSettingMutation = {
  updateSetting?:  {
    __typename: "Setting",
    company: string,
    parentId: string,
    settingId: string,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSettingMutationVariables = {
  input: DeleteSettingInput,
  condition?: ModelSettingConditionInput | null,
};

export type DeleteSettingMutation = {
  deleteSetting?:  {
    __typename: "Setting",
    company: string,
    parentId: string,
    settingId: string,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAccountPaymentMutationVariables = {
  input: CreateAccountPaymentInput,
  condition?: ModelAccountPaymentConditionInput | null,
};

export type CreateAccountPaymentMutation = {
  createAccountPayment?:  {
    __typename: "AccountPayment",
    company: string,
    id: string,
    plan: string,
    status: PaymentStatusEnum,
    currency: string,
    totalGross: number,
    totalFee: number,
    totalNet: number,
    processor?: string | null,
    processorData?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateAccountPaymentMutationVariables = {
  input: UpdateAccountPaymentInput,
  condition?: ModelAccountPaymentConditionInput | null,
};

export type UpdateAccountPaymentMutation = {
  updateAccountPayment?:  {
    __typename: "AccountPayment",
    company: string,
    id: string,
    plan: string,
    status: PaymentStatusEnum,
    currency: string,
    totalGross: number,
    totalFee: number,
    totalNet: number,
    processor?: string | null,
    processorData?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteAccountPaymentMutationVariables = {
  input: DeleteAccountPaymentInput,
  condition?: ModelAccountPaymentConditionInput | null,
};

export type DeleteAccountPaymentMutation = {
  deleteAccountPayment?:  {
    __typename: "AccountPayment",
    company: string,
    id: string,
    plan: string,
    status: PaymentStatusEnum,
    currency: string,
    totalGross: number,
    totalFee: number,
    totalNet: number,
    processor?: string | null,
    processorData?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateCustomerMutationVariables = {
  input: CreateCustomerInput,
  condition?: ModelCustomerConditionInput | null,
};

export type CreateCustomerMutation = {
  createCustomer?:  {
    __typename: "Customer",
    company: string,
    id: string,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    physicalAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCustomerMutationVariables = {
  input: UpdateCustomerInput,
  condition?: ModelCustomerConditionInput | null,
};

export type UpdateCustomerMutation = {
  updateCustomer?:  {
    __typename: "Customer",
    company: string,
    id: string,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    physicalAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCustomerMutationVariables = {
  input: DeleteCustomerInput,
  condition?: ModelCustomerConditionInput | null,
};

export type DeleteCustomerMutation = {
  deleteCustomer?:  {
    __typename: "Customer",
    company: string,
    id: string,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    physicalAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePaymentMutationVariables = {
  input: CreatePaymentInput,
  condition?: ModelPaymentConditionInput | null,
};

export type CreatePaymentMutation = {
  createPayment?:  {
    __typename: "Payment",
    company: string,
    id: string,
    customerId: string,
    orderId: string,
    status: PaymentStatusEnum,
    currency: string,
    originalCurrency?: string | null,
    conversionRate?: number | null,
    totalGross: number,
    totalFee?: number | null,
    totalNet?: number | null,
    processorId: string,
    extPaymentId?: string | null,
    processorData?: string | null,
    createdAt: string,
    reason?: string | null,
    updatedAt: string,
    customer?:  {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    processor?:  {
      __typename: "CompanyPaymentProcessor",
      company: string,
      id: string,
      name?: string | null,
      description?: string | null,
      active?: boolean | null,
      formValues?:  Array< {
        __typename: "FieldValue",
        name: string,
        type: string,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
      processor?:  {
        __typename: "PaymentProcessor",
        id: string,
        name?: string | null,
        description?: string | null,
        active?: boolean | null,
        logo?: string | null,
        countries?: Array< string | null > | null,
        website?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type UpdatePaymentMutationVariables = {
  input: UpdatePaymentInput,
  condition?: ModelPaymentConditionInput | null,
};

export type UpdatePaymentMutation = {
  updatePayment?:  {
    __typename: "Payment",
    company: string,
    id: string,
    customerId: string,
    orderId: string,
    status: PaymentStatusEnum,
    currency: string,
    originalCurrency?: string | null,
    conversionRate?: number | null,
    totalGross: number,
    totalFee?: number | null,
    totalNet?: number | null,
    processorId: string,
    extPaymentId?: string | null,
    processorData?: string | null,
    createdAt: string,
    reason?: string | null,
    updatedAt: string,
    customer?:  {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    processor?:  {
      __typename: "CompanyPaymentProcessor",
      company: string,
      id: string,
      name?: string | null,
      description?: string | null,
      active?: boolean | null,
      formValues?:  Array< {
        __typename: "FieldValue",
        name: string,
        type: string,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
      processor?:  {
        __typename: "PaymentProcessor",
        id: string,
        name?: string | null,
        description?: string | null,
        active?: boolean | null,
        logo?: string | null,
        countries?: Array< string | null > | null,
        website?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type DeletePaymentMutationVariables = {
  input: DeletePaymentInput,
  condition?: ModelPaymentConditionInput | null,
};

export type DeletePaymentMutation = {
  deletePayment?:  {
    __typename: "Payment",
    company: string,
    id: string,
    customerId: string,
    orderId: string,
    status: PaymentStatusEnum,
    currency: string,
    originalCurrency?: string | null,
    conversionRate?: number | null,
    totalGross: number,
    totalFee?: number | null,
    totalNet?: number | null,
    processorId: string,
    extPaymentId?: string | null,
    processorData?: string | null,
    createdAt: string,
    reason?: string | null,
    updatedAt: string,
    customer?:  {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    processor?:  {
      __typename: "CompanyPaymentProcessor",
      company: string,
      id: string,
      name?: string | null,
      description?: string | null,
      active?: boolean | null,
      formValues?:  Array< {
        __typename: "FieldValue",
        name: string,
        type: string,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
      processor?:  {
        __typename: "PaymentProcessor",
        id: string,
        name?: string | null,
        description?: string | null,
        active?: boolean | null,
        logo?: string | null,
        countries?: Array< string | null > | null,
        website?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type CreatePaymentProcessorMutationVariables = {
  input: CreatePaymentProcessorInput,
  condition?: ModelPaymentProcessorConditionInput | null,
};

export type CreatePaymentProcessorMutation = {
  createPaymentProcessor?:  {
    __typename: "PaymentProcessor",
    id: string,
    name?: string | null,
    description?: string | null,
    active?: boolean | null,
    logo?: string | null,
    formFields?:  Array< {
      __typename: "FieldDefinition",
      name: string,
      type: string,
      required: boolean,
      tooltip?: string | null,
    } | null > | null,
    countries?: Array< string | null > | null,
    website?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePaymentProcessorMutationVariables = {
  input: UpdatePaymentProcessorInput,
  condition?: ModelPaymentProcessorConditionInput | null,
};

export type UpdatePaymentProcessorMutation = {
  updatePaymentProcessor?:  {
    __typename: "PaymentProcessor",
    id: string,
    name?: string | null,
    description?: string | null,
    active?: boolean | null,
    logo?: string | null,
    formFields?:  Array< {
      __typename: "FieldDefinition",
      name: string,
      type: string,
      required: boolean,
      tooltip?: string | null,
    } | null > | null,
    countries?: Array< string | null > | null,
    website?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePaymentProcessorMutationVariables = {
  input: DeletePaymentProcessorInput,
  condition?: ModelPaymentProcessorConditionInput | null,
};

export type DeletePaymentProcessorMutation = {
  deletePaymentProcessor?:  {
    __typename: "PaymentProcessor",
    id: string,
    name?: string | null,
    description?: string | null,
    active?: boolean | null,
    logo?: string | null,
    formFields?:  Array< {
      __typename: "FieldDefinition",
      name: string,
      type: string,
      required: boolean,
      tooltip?: string | null,
    } | null > | null,
    countries?: Array< string | null > | null,
    website?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSequenceMutationVariables = {
  input: CreateSequenceInput,
  condition?: ModelSequenceConditionInput | null,
};

export type CreateSequenceMutation = {
  createSequence?:  {
    __typename: "Sequence",
    company: string,
    id: string,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSequenceMutationVariables = {
  input: UpdateSequenceInput,
  condition?: ModelSequenceConditionInput | null,
};

export type UpdateSequenceMutation = {
  updateSequence?:  {
    __typename: "Sequence",
    company: string,
    id: string,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSequenceMutationVariables = {
  input: DeleteSequenceInput,
  condition?: ModelSequenceConditionInput | null,
};

export type DeleteSequenceMutation = {
  deleteSequence?:  {
    __typename: "Sequence",
    company: string,
    id: string,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOrderMutationVariables = {
  input: CreateOrderInput,
  condition?: ModelOrderConditionInput | null,
};

export type CreateOrderMutation = {
  createOrder?:  {
    __typename: "Order",
    company: string,
    id: string,
    type?: OrderTypeEnum | null,
    status?: OrderStatusEnum | null,
    ref: string,
    locationId?: string | null,
    customerId: string,
    customerEmail?: string | null,
    customerFirstName?: string | null,
    customerLastName?: string | null,
    owner: string,
    categoryId?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    contactNumber?: string | null,
    deliveryType?: DeliveryTypeEnum | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryTime?: string | null,
    returnedTime?: string | null,
    confirmedTime?: string | null,
    deliveredTime?: string | null,
    total?: number | null,
    deposit?: number | null,
    subTotal?: number | null,
    discountTotal?: number | null,
    deliveryFee?: number | null,
    reason?: string | null,
    notes?: string | null,
    createdAt: string,
    completedAt?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    updatedAt: string,
    customer?:  {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    payments?:  {
      __typename: "ModelPaymentConnection",
      items?:  Array< {
        __typename: "Payment",
        company: string,
        id: string,
        customerId: string,
        orderId: string,
        status: PaymentStatusEnum,
        currency: string,
        originalCurrency?: string | null,
        conversionRate?: number | null,
        totalGross: number,
        totalFee?: number | null,
        totalNet?: number | null,
        processorId: string,
        extPaymentId?: string | null,
        processorData?: string | null,
        createdAt: string,
        reason?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    products?:  {
      __typename: "ModelOrderProductConnection",
      items?:  Array< {
        __typename: "OrderProduct",
        company: string,
        id: string,
        orderId: string,
        productId: string,
        owner: string,
        orderType: OrderTypeEnum,
        startTime?: string | null,
        endTime?: string | null,
        qty: number,
        total: number,
        subTotal: number,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    coupons?:  {
      __typename: "ModelOrderCouponConnection",
      items?:  Array< {
        __typename: "OrderCoupon",
        company: string,
        id: string,
        orderId: string,
        couponId: string,
        owner: string,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelOrderStockItemConnection",
      items?:  Array< {
        __typename: "OrderStockItem",
        company: string,
        id: string,
        orderId: string,
        stockItemId: string,
        orderType: OrderTypeEnum,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    logs?:  {
      __typename: "ModelLogConnection",
      items?:  Array< {
        __typename: "Log",
        company: string,
        id: string,
        parentId: string,
        event: string,
        source?: string | null,
        destination?: string | null,
        description?: string | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateOrderMutationVariables = {
  input: UpdateOrderInput,
  condition?: ModelOrderConditionInput | null,
};

export type UpdateOrderMutation = {
  updateOrder?:  {
    __typename: "Order",
    company: string,
    id: string,
    type?: OrderTypeEnum | null,
    status?: OrderStatusEnum | null,
    ref: string,
    locationId?: string | null,
    customerId: string,
    customerEmail?: string | null,
    customerFirstName?: string | null,
    customerLastName?: string | null,
    owner: string,
    categoryId?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    contactNumber?: string | null,
    deliveryType?: DeliveryTypeEnum | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryTime?: string | null,
    returnedTime?: string | null,
    confirmedTime?: string | null,
    deliveredTime?: string | null,
    total?: number | null,
    deposit?: number | null,
    subTotal?: number | null,
    discountTotal?: number | null,
    deliveryFee?: number | null,
    reason?: string | null,
    notes?: string | null,
    createdAt: string,
    completedAt?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    updatedAt: string,
    customer?:  {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    payments?:  {
      __typename: "ModelPaymentConnection",
      items?:  Array< {
        __typename: "Payment",
        company: string,
        id: string,
        customerId: string,
        orderId: string,
        status: PaymentStatusEnum,
        currency: string,
        originalCurrency?: string | null,
        conversionRate?: number | null,
        totalGross: number,
        totalFee?: number | null,
        totalNet?: number | null,
        processorId: string,
        extPaymentId?: string | null,
        processorData?: string | null,
        createdAt: string,
        reason?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    products?:  {
      __typename: "ModelOrderProductConnection",
      items?:  Array< {
        __typename: "OrderProduct",
        company: string,
        id: string,
        orderId: string,
        productId: string,
        owner: string,
        orderType: OrderTypeEnum,
        startTime?: string | null,
        endTime?: string | null,
        qty: number,
        total: number,
        subTotal: number,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    coupons?:  {
      __typename: "ModelOrderCouponConnection",
      items?:  Array< {
        __typename: "OrderCoupon",
        company: string,
        id: string,
        orderId: string,
        couponId: string,
        owner: string,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelOrderStockItemConnection",
      items?:  Array< {
        __typename: "OrderStockItem",
        company: string,
        id: string,
        orderId: string,
        stockItemId: string,
        orderType: OrderTypeEnum,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    logs?:  {
      __typename: "ModelLogConnection",
      items?:  Array< {
        __typename: "Log",
        company: string,
        id: string,
        parentId: string,
        event: string,
        source?: string | null,
        destination?: string | null,
        description?: string | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteOrderMutationVariables = {
  input: DeleteOrderInput,
  condition?: ModelOrderConditionInput | null,
};

export type DeleteOrderMutation = {
  deleteOrder?:  {
    __typename: "Order",
    company: string,
    id: string,
    type?: OrderTypeEnum | null,
    status?: OrderStatusEnum | null,
    ref: string,
    locationId?: string | null,
    customerId: string,
    customerEmail?: string | null,
    customerFirstName?: string | null,
    customerLastName?: string | null,
    owner: string,
    categoryId?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    contactNumber?: string | null,
    deliveryType?: DeliveryTypeEnum | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryTime?: string | null,
    returnedTime?: string | null,
    confirmedTime?: string | null,
    deliveredTime?: string | null,
    total?: number | null,
    deposit?: number | null,
    subTotal?: number | null,
    discountTotal?: number | null,
    deliveryFee?: number | null,
    reason?: string | null,
    notes?: string | null,
    createdAt: string,
    completedAt?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    updatedAt: string,
    customer?:  {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    payments?:  {
      __typename: "ModelPaymentConnection",
      items?:  Array< {
        __typename: "Payment",
        company: string,
        id: string,
        customerId: string,
        orderId: string,
        status: PaymentStatusEnum,
        currency: string,
        originalCurrency?: string | null,
        conversionRate?: number | null,
        totalGross: number,
        totalFee?: number | null,
        totalNet?: number | null,
        processorId: string,
        extPaymentId?: string | null,
        processorData?: string | null,
        createdAt: string,
        reason?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    products?:  {
      __typename: "ModelOrderProductConnection",
      items?:  Array< {
        __typename: "OrderProduct",
        company: string,
        id: string,
        orderId: string,
        productId: string,
        owner: string,
        orderType: OrderTypeEnum,
        startTime?: string | null,
        endTime?: string | null,
        qty: number,
        total: number,
        subTotal: number,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    coupons?:  {
      __typename: "ModelOrderCouponConnection",
      items?:  Array< {
        __typename: "OrderCoupon",
        company: string,
        id: string,
        orderId: string,
        couponId: string,
        owner: string,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelOrderStockItemConnection",
      items?:  Array< {
        __typename: "OrderStockItem",
        company: string,
        id: string,
        orderId: string,
        stockItemId: string,
        orderType: OrderTypeEnum,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    logs?:  {
      __typename: "ModelLogConnection",
      items?:  Array< {
        __typename: "Log",
        company: string,
        id: string,
        parentId: string,
        event: string,
        source?: string | null,
        destination?: string | null,
        description?: string | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateOrderProductMutationVariables = {
  input: CreateOrderProductInput,
  condition?: ModelOrderProductConditionInput | null,
};

export type CreateOrderProductMutation = {
  createOrderProduct?:  {
    __typename: "OrderProduct",
    company: string,
    id: string,
    orderId: string,
    productId: string,
    owner: string,
    productInfo:  {
      __typename: "OrderProductInfo",
      name: string,
      categoryId?: string | null,
      description?: string | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      imageUrl?: string | null,
      price: number,
    },
    orderType: OrderTypeEnum,
    startTime?: string | null,
    endTime?: string | null,
    qty: number,
    total: number,
    subTotal: number,
    discountTotal: number,
    createdAt: string,
    updatedAt: string,
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateOrderProductMutationVariables = {
  input: UpdateOrderProductInput,
  condition?: ModelOrderProductConditionInput | null,
};

export type UpdateOrderProductMutation = {
  updateOrderProduct?:  {
    __typename: "OrderProduct",
    company: string,
    id: string,
    orderId: string,
    productId: string,
    owner: string,
    productInfo:  {
      __typename: "OrderProductInfo",
      name: string,
      categoryId?: string | null,
      description?: string | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      imageUrl?: string | null,
      price: number,
    },
    orderType: OrderTypeEnum,
    startTime?: string | null,
    endTime?: string | null,
    qty: number,
    total: number,
    subTotal: number,
    discountTotal: number,
    createdAt: string,
    updatedAt: string,
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteOrderProductMutationVariables = {
  input: DeleteOrderProductInput,
  condition?: ModelOrderProductConditionInput | null,
};

export type DeleteOrderProductMutation = {
  deleteOrderProduct?:  {
    __typename: "OrderProduct",
    company: string,
    id: string,
    orderId: string,
    productId: string,
    owner: string,
    productInfo:  {
      __typename: "OrderProductInfo",
      name: string,
      categoryId?: string | null,
      description?: string | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      imageUrl?: string | null,
      price: number,
    },
    orderType: OrderTypeEnum,
    startTime?: string | null,
    endTime?: string | null,
    qty: number,
    total: number,
    subTotal: number,
    discountTotal: number,
    createdAt: string,
    updatedAt: string,
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateOrderCouponMutationVariables = {
  input: CreateOrderCouponInput,
  condition?: ModelOrderCouponConditionInput | null,
};

export type CreateOrderCouponMutation = {
  createOrderCoupon?:  {
    __typename: "OrderCoupon",
    company: string,
    id: string,
    orderId: string,
    couponId: string,
    owner: string,
    coupon?:  {
      __typename: "Coupon",
      company: string,
      id: string,
      description?: string | null,
      type: CouponTypeEnum,
      status: CouponStatusEnum,
      expireAt: string,
      startTime: string,
      value: number,
      settings?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      qtyAvailable: number,
      qtyReserved: number,
      qtyUsed: number,
      minSpend?: number | null,
      maxSpend?: number | null,
      createdAt: string,
      updatedAt: string,
      version: number,
      products?:  {
        __typename: "ModelCouponProductConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    discountTotal: number,
    createdAt: string,
    updatedAt: string,
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateOrderCouponMutationVariables = {
  input: UpdateOrderCouponInput,
  condition?: ModelOrderCouponConditionInput | null,
};

export type UpdateOrderCouponMutation = {
  updateOrderCoupon?:  {
    __typename: "OrderCoupon",
    company: string,
    id: string,
    orderId: string,
    couponId: string,
    owner: string,
    coupon?:  {
      __typename: "Coupon",
      company: string,
      id: string,
      description?: string | null,
      type: CouponTypeEnum,
      status: CouponStatusEnum,
      expireAt: string,
      startTime: string,
      value: number,
      settings?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      qtyAvailable: number,
      qtyReserved: number,
      qtyUsed: number,
      minSpend?: number | null,
      maxSpend?: number | null,
      createdAt: string,
      updatedAt: string,
      version: number,
      products?:  {
        __typename: "ModelCouponProductConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    discountTotal: number,
    createdAt: string,
    updatedAt: string,
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteOrderCouponMutationVariables = {
  input: DeleteOrderCouponInput,
  condition?: ModelOrderCouponConditionInput | null,
};

export type DeleteOrderCouponMutation = {
  deleteOrderCoupon?:  {
    __typename: "OrderCoupon",
    company: string,
    id: string,
    orderId: string,
    couponId: string,
    owner: string,
    coupon?:  {
      __typename: "Coupon",
      company: string,
      id: string,
      description?: string | null,
      type: CouponTypeEnum,
      status: CouponStatusEnum,
      expireAt: string,
      startTime: string,
      value: number,
      settings?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      qtyAvailable: number,
      qtyReserved: number,
      qtyUsed: number,
      minSpend?: number | null,
      maxSpend?: number | null,
      createdAt: string,
      updatedAt: string,
      version: number,
      products?:  {
        __typename: "ModelCouponProductConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    discountTotal: number,
    createdAt: string,
    updatedAt: string,
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateOrderStockItemMutationVariables = {
  input: CreateOrderStockItemInput,
  condition?: ModelOrderStockItemConditionInput | null,
};

export type CreateOrderStockItemMutation = {
  createOrderStockItem?:  {
    __typename: "OrderStockItem",
    company: string,
    id: string,
    orderId: string,
    stockItemId: string,
    orderType: OrderTypeEnum,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateOrderStockItemMutationVariables = {
  input: UpdateOrderStockItemInput,
  condition?: ModelOrderStockItemConditionInput | null,
};

export type UpdateOrderStockItemMutation = {
  updateOrderStockItem?:  {
    __typename: "OrderStockItem",
    company: string,
    id: string,
    orderId: string,
    stockItemId: string,
    orderType: OrderTypeEnum,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteOrderStockItemMutationVariables = {
  input: DeleteOrderStockItemInput,
  condition?: ModelOrderStockItemConditionInput | null,
};

export type DeleteOrderStockItemMutation = {
  deleteOrderStockItem?:  {
    __typename: "OrderStockItem",
    company: string,
    id: string,
    orderId: string,
    stockItemId: string,
    orderType: OrderTypeEnum,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateProductMutationVariables = {
  input: CreateProductInput,
  condition?: ModelProductConditionInput | null,
};

export type CreateProductMutation = {
  createProduct?:  {
    __typename: "Product",
    company: string,
    id: string,
    comloc: string,
    sku: string,
    type: ProductTypeEnum,
    name: string,
    slug: string,
    excerpt?: string | null,
    mediaId: string,
    description?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    status?: ProductStatusEnum | null,
    price?: number | null,
    deposit?: number | null,
    cost?: number | null,
    dimensions?:  {
      __typename: "Dimensions",
      height?: number | null,
      width?: number | null,
      weight?: number | null,
      length?: number | null,
    } | null,
    qtyOnHand: number,
    qtyAvailable: number,
    qtyReserved: number,
    createdAt: string,
    updatedAt: string,
    version: number,
    settings?:  {
      __typename: "ModelSettingConnection",
      items?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    bundleProducts?:  {
      __typename: "ModelBundleProductConnection",
      items?:  Array< {
        __typename: "BundleProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    features?:  {
      __typename: "ModelFeatureConnection",
      items?:  Array< {
        __typename: "Feature",
        company: string,
        id: string,
        parentId: string,
        categoryId?: string | null,
        text: string,
        description?: string | null,
        imageUrl?: string | null,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelStockItemConnection",
      items?:  Array< {
        __typename: "StockItem",
        company: string,
        id: string,
        location: string,
        serialNumber: string,
        status?: StockItemStatusEnum | null,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    categories?:  {
      __typename: "ModelProductCategoryConnection",
      items?:  Array< {
        __typename: "ProductCategory",
        company: string,
        id: string,
        categoryId: string,
        productId: string,
        seq: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    upsellProducts?:  {
      __typename: "ModelUpsellProductConnection",
      items?:  Array< {
        __typename: "UpsellProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    crossSellProducts?:  {
      __typename: "ModelCrossSellProductConnection",
      items?:  Array< {
        __typename: "CrossSellProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    image?:  {
      __typename: "Media",
      company: string,
      id: string,
      url: string,
      name?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    media?:  {
      __typename: "ModelMediaItemConnection",
      items?:  Array< {
        __typename: "MediaItem",
        company: string,
        id: string,
        mediaId: string,
        parentId: string,
        default?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    customPrice?:  {
      __typename: "ModelProductPriceConnection",
      items?:  Array< {
        __typename: "ProductPrice",
        company: string,
        id: string,
        productId: string,
        startTime?: string | null,
        endTime?: string | null,
        price?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateProductMutationVariables = {
  input: UpdateProductInput,
  condition?: ModelProductConditionInput | null,
};

export type UpdateProductMutation = {
  updateProduct?:  {
    __typename: "Product",
    company: string,
    id: string,
    comloc: string,
    sku: string,
    type: ProductTypeEnum,
    name: string,
    slug: string,
    excerpt?: string | null,
    mediaId: string,
    description?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    status?: ProductStatusEnum | null,
    price?: number | null,
    deposit?: number | null,
    cost?: number | null,
    dimensions?:  {
      __typename: "Dimensions",
      height?: number | null,
      width?: number | null,
      weight?: number | null,
      length?: number | null,
    } | null,
    qtyOnHand: number,
    qtyAvailable: number,
    qtyReserved: number,
    createdAt: string,
    updatedAt: string,
    version: number,
    settings?:  {
      __typename: "ModelSettingConnection",
      items?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    bundleProducts?:  {
      __typename: "ModelBundleProductConnection",
      items?:  Array< {
        __typename: "BundleProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    features?:  {
      __typename: "ModelFeatureConnection",
      items?:  Array< {
        __typename: "Feature",
        company: string,
        id: string,
        parentId: string,
        categoryId?: string | null,
        text: string,
        description?: string | null,
        imageUrl?: string | null,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelStockItemConnection",
      items?:  Array< {
        __typename: "StockItem",
        company: string,
        id: string,
        location: string,
        serialNumber: string,
        status?: StockItemStatusEnum | null,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    categories?:  {
      __typename: "ModelProductCategoryConnection",
      items?:  Array< {
        __typename: "ProductCategory",
        company: string,
        id: string,
        categoryId: string,
        productId: string,
        seq: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    upsellProducts?:  {
      __typename: "ModelUpsellProductConnection",
      items?:  Array< {
        __typename: "UpsellProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    crossSellProducts?:  {
      __typename: "ModelCrossSellProductConnection",
      items?:  Array< {
        __typename: "CrossSellProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    image?:  {
      __typename: "Media",
      company: string,
      id: string,
      url: string,
      name?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    media?:  {
      __typename: "ModelMediaItemConnection",
      items?:  Array< {
        __typename: "MediaItem",
        company: string,
        id: string,
        mediaId: string,
        parentId: string,
        default?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    customPrice?:  {
      __typename: "ModelProductPriceConnection",
      items?:  Array< {
        __typename: "ProductPrice",
        company: string,
        id: string,
        productId: string,
        startTime?: string | null,
        endTime?: string | null,
        price?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteProductMutationVariables = {
  input: DeleteProductInput,
  condition?: ModelProductConditionInput | null,
};

export type DeleteProductMutation = {
  deleteProduct?:  {
    __typename: "Product",
    company: string,
    id: string,
    comloc: string,
    sku: string,
    type: ProductTypeEnum,
    name: string,
    slug: string,
    excerpt?: string | null,
    mediaId: string,
    description?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    status?: ProductStatusEnum | null,
    price?: number | null,
    deposit?: number | null,
    cost?: number | null,
    dimensions?:  {
      __typename: "Dimensions",
      height?: number | null,
      width?: number | null,
      weight?: number | null,
      length?: number | null,
    } | null,
    qtyOnHand: number,
    qtyAvailable: number,
    qtyReserved: number,
    createdAt: string,
    updatedAt: string,
    version: number,
    settings?:  {
      __typename: "ModelSettingConnection",
      items?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    bundleProducts?:  {
      __typename: "ModelBundleProductConnection",
      items?:  Array< {
        __typename: "BundleProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    features?:  {
      __typename: "ModelFeatureConnection",
      items?:  Array< {
        __typename: "Feature",
        company: string,
        id: string,
        parentId: string,
        categoryId?: string | null,
        text: string,
        description?: string | null,
        imageUrl?: string | null,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelStockItemConnection",
      items?:  Array< {
        __typename: "StockItem",
        company: string,
        id: string,
        location: string,
        serialNumber: string,
        status?: StockItemStatusEnum | null,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    categories?:  {
      __typename: "ModelProductCategoryConnection",
      items?:  Array< {
        __typename: "ProductCategory",
        company: string,
        id: string,
        categoryId: string,
        productId: string,
        seq: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    upsellProducts?:  {
      __typename: "ModelUpsellProductConnection",
      items?:  Array< {
        __typename: "UpsellProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    crossSellProducts?:  {
      __typename: "ModelCrossSellProductConnection",
      items?:  Array< {
        __typename: "CrossSellProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    image?:  {
      __typename: "Media",
      company: string,
      id: string,
      url: string,
      name?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    media?:  {
      __typename: "ModelMediaItemConnection",
      items?:  Array< {
        __typename: "MediaItem",
        company: string,
        id: string,
        mediaId: string,
        parentId: string,
        default?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    customPrice?:  {
      __typename: "ModelProductPriceConnection",
      items?:  Array< {
        __typename: "ProductPrice",
        company: string,
        id: string,
        productId: string,
        startTime?: string | null,
        endTime?: string | null,
        price?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateBundleProductMutationVariables = {
  input: CreateBundleProductInput,
  condition?: ModelBundleProductConditionInput | null,
};

export type CreateBundleProductMutation = {
  createBundleProduct?:  {
    __typename: "BundleProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateBundleProductMutationVariables = {
  input: UpdateBundleProductInput,
  condition?: ModelBundleProductConditionInput | null,
};

export type UpdateBundleProductMutation = {
  updateBundleProduct?:  {
    __typename: "BundleProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteBundleProductMutationVariables = {
  input: DeleteBundleProductInput,
  condition?: ModelBundleProductConditionInput | null,
};

export type DeleteBundleProductMutation = {
  deleteBundleProduct?:  {
    __typename: "BundleProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateFeatureMutationVariables = {
  input: CreateFeatureInput,
  condition?: ModelFeatureConditionInput | null,
};

export type CreateFeatureMutation = {
  createFeature?:  {
    __typename: "Feature",
    company: string,
    id: string,
    parentId: string,
    categoryId?: string | null,
    text: string,
    description?: string | null,
    imageUrl?: string | null,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFeatureMutationVariables = {
  input: UpdateFeatureInput,
  condition?: ModelFeatureConditionInput | null,
};

export type UpdateFeatureMutation = {
  updateFeature?:  {
    __typename: "Feature",
    company: string,
    id: string,
    parentId: string,
    categoryId?: string | null,
    text: string,
    description?: string | null,
    imageUrl?: string | null,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFeatureMutationVariables = {
  input: DeleteFeatureInput,
  condition?: ModelFeatureConditionInput | null,
};

export type DeleteFeatureMutation = {
  deleteFeature?:  {
    __typename: "Feature",
    company: string,
    id: string,
    parentId: string,
    categoryId?: string | null,
    text: string,
    description?: string | null,
    imageUrl?: string | null,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCouponMutationVariables = {
  input: CreateCouponInput,
  condition?: ModelCouponConditionInput | null,
};

export type CreateCouponMutation = {
  createCoupon?:  {
    __typename: "Coupon",
    company: string,
    id: string,
    description?: string | null,
    type: CouponTypeEnum,
    status: CouponStatusEnum,
    expireAt: string,
    startTime: string,
    value: number,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    qtyAvailable: number,
    qtyReserved: number,
    qtyUsed: number,
    minSpend?: number | null,
    maxSpend?: number | null,
    createdAt: string,
    updatedAt: string,
    version: number,
    products?:  {
      __typename: "ModelCouponProductConnection",
      items?:  Array< {
        __typename: "CouponProduct",
        company: string,
        id: string,
        couponId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateCouponMutationVariables = {
  input: UpdateCouponInput,
  condition?: ModelCouponConditionInput | null,
};

export type UpdateCouponMutation = {
  updateCoupon?:  {
    __typename: "Coupon",
    company: string,
    id: string,
    description?: string | null,
    type: CouponTypeEnum,
    status: CouponStatusEnum,
    expireAt: string,
    startTime: string,
    value: number,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    qtyAvailable: number,
    qtyReserved: number,
    qtyUsed: number,
    minSpend?: number | null,
    maxSpend?: number | null,
    createdAt: string,
    updatedAt: string,
    version: number,
    products?:  {
      __typename: "ModelCouponProductConnection",
      items?:  Array< {
        __typename: "CouponProduct",
        company: string,
        id: string,
        couponId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteCouponMutationVariables = {
  input: DeleteCouponInput,
  condition?: ModelCouponConditionInput | null,
};

export type DeleteCouponMutation = {
  deleteCoupon?:  {
    __typename: "Coupon",
    company: string,
    id: string,
    description?: string | null,
    type: CouponTypeEnum,
    status: CouponStatusEnum,
    expireAt: string,
    startTime: string,
    value: number,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    qtyAvailable: number,
    qtyReserved: number,
    qtyUsed: number,
    minSpend?: number | null,
    maxSpend?: number | null,
    createdAt: string,
    updatedAt: string,
    version: number,
    products?:  {
      __typename: "ModelCouponProductConnection",
      items?:  Array< {
        __typename: "CouponProduct",
        company: string,
        id: string,
        couponId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateCouponProductMutationVariables = {
  input: CreateCouponProductInput,
  condition?: ModelCouponProductConditionInput | null,
};

export type CreateCouponProductMutation = {
  createCouponProduct?:  {
    __typename: "CouponProduct",
    company: string,
    id: string,
    couponId: string,
    productId: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCouponProductMutationVariables = {
  input: UpdateCouponProductInput,
  condition?: ModelCouponProductConditionInput | null,
};

export type UpdateCouponProductMutation = {
  updateCouponProduct?:  {
    __typename: "CouponProduct",
    company: string,
    id: string,
    couponId: string,
    productId: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCouponProductMutationVariables = {
  input: DeleteCouponProductInput,
  condition?: ModelCouponProductConditionInput | null,
};

export type DeleteCouponProductMutation = {
  deleteCouponProduct?:  {
    __typename: "CouponProduct",
    company: string,
    id: string,
    couponId: string,
    productId: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateStockItemMutationVariables = {
  input: CreateStockItemInput,
  condition?: ModelStockItemConditionInput | null,
};

export type CreateStockItemMutation = {
  createStockItem?:  {
    __typename: "StockItem",
    company: string,
    id: string,
    location: string,
    serialNumber: string,
    status?: StockItemStatusEnum | null,
    productId: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateStockItemMutationVariables = {
  input: UpdateStockItemInput,
  condition?: ModelStockItemConditionInput | null,
};

export type UpdateStockItemMutation = {
  updateStockItem?:  {
    __typename: "StockItem",
    company: string,
    id: string,
    location: string,
    serialNumber: string,
    status?: StockItemStatusEnum | null,
    productId: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteStockItemMutationVariables = {
  input: DeleteStockItemInput,
  condition?: ModelStockItemConditionInput | null,
};

export type DeleteStockItemMutation = {
  deleteStockItem?:  {
    __typename: "StockItem",
    company: string,
    id: string,
    location: string,
    serialNumber: string,
    status?: StockItemStatusEnum | null,
    productId: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateProductCategoryMutationVariables = {
  input: CreateProductCategoryInput,
  condition?: ModelProductCategoryConditionInput | null,
};

export type CreateProductCategoryMutation = {
  createProductCategory?:  {
    __typename: "ProductCategory",
    company: string,
    id: string,
    categoryId: string,
    productId: string,
    seq: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    category?:  {
      __typename: "Category",
      company: string,
      id: string,
      name: string,
      description?: string | null,
      slug?: string | null,
      imageUrl?: string | null,
      parentId?: string | null,
      seq?: number | null,
      hidden?: boolean | null,
      createdAt: string,
      updatedAt: string,
      products?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      children?:  {
        __typename: "ModelCategoryConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateProductCategoryMutationVariables = {
  input: UpdateProductCategoryInput,
  condition?: ModelProductCategoryConditionInput | null,
};

export type UpdateProductCategoryMutation = {
  updateProductCategory?:  {
    __typename: "ProductCategory",
    company: string,
    id: string,
    categoryId: string,
    productId: string,
    seq: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    category?:  {
      __typename: "Category",
      company: string,
      id: string,
      name: string,
      description?: string | null,
      slug?: string | null,
      imageUrl?: string | null,
      parentId?: string | null,
      seq?: number | null,
      hidden?: boolean | null,
      createdAt: string,
      updatedAt: string,
      products?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      children?:  {
        __typename: "ModelCategoryConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteProductCategoryMutationVariables = {
  input: DeleteProductCategoryInput,
  condition?: ModelProductCategoryConditionInput | null,
};

export type DeleteProductCategoryMutation = {
  deleteProductCategory?:  {
    __typename: "ProductCategory",
    company: string,
    id: string,
    categoryId: string,
    productId: string,
    seq: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    category?:  {
      __typename: "Category",
      company: string,
      id: string,
      name: string,
      description?: string | null,
      slug?: string | null,
      imageUrl?: string | null,
      parentId?: string | null,
      seq?: number | null,
      hidden?: boolean | null,
      createdAt: string,
      updatedAt: string,
      products?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      children?:  {
        __typename: "ModelCategoryConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateRelatedProductMutationVariables = {
  input: CreateRelatedProductInput,
  condition?: ModelRelatedProductConditionInput | null,
};

export type CreateRelatedProductMutation = {
  createRelatedProduct?:  {
    __typename: "RelatedProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateRelatedProductMutationVariables = {
  input: UpdateRelatedProductInput,
  condition?: ModelRelatedProductConditionInput | null,
};

export type UpdateRelatedProductMutation = {
  updateRelatedProduct?:  {
    __typename: "RelatedProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteRelatedProductMutationVariables = {
  input: DeleteRelatedProductInput,
  condition?: ModelRelatedProductConditionInput | null,
};

export type DeleteRelatedProductMutation = {
  deleteRelatedProduct?:  {
    __typename: "RelatedProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateUpsellProductMutationVariables = {
  input: CreateUpsellProductInput,
  condition?: ModelUpsellProductConditionInput | null,
};

export type CreateUpsellProductMutation = {
  createUpsellProduct?:  {
    __typename: "UpsellProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateUpsellProductMutationVariables = {
  input: UpdateUpsellProductInput,
  condition?: ModelUpsellProductConditionInput | null,
};

export type UpdateUpsellProductMutation = {
  updateUpsellProduct?:  {
    __typename: "UpsellProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteUpsellProductMutationVariables = {
  input: DeleteUpsellProductInput,
  condition?: ModelUpsellProductConditionInput | null,
};

export type DeleteUpsellProductMutation = {
  deleteUpsellProduct?:  {
    __typename: "UpsellProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateCrossSellProductMutationVariables = {
  input: CreateCrossSellProductInput,
  condition?: ModelCrossSellProductConditionInput | null,
};

export type CreateCrossSellProductMutation = {
  createCrossSellProduct?:  {
    __typename: "CrossSellProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateCrossSellProductMutationVariables = {
  input: UpdateCrossSellProductInput,
  condition?: ModelCrossSellProductConditionInput | null,
};

export type UpdateCrossSellProductMutation = {
  updateCrossSellProduct?:  {
    __typename: "CrossSellProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteCrossSellProductMutationVariables = {
  input: DeleteCrossSellProductInput,
  condition?: ModelCrossSellProductConditionInput | null,
};

export type DeleteCrossSellProductMutation = {
  deleteCrossSellProduct?:  {
    __typename: "CrossSellProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateCategoryMutationVariables = {
  input: CreateCategoryInput,
  condition?: ModelCategoryConditionInput | null,
};

export type CreateCategoryMutation = {
  createCategory?:  {
    __typename: "Category",
    company: string,
    id: string,
    name: string,
    description?: string | null,
    slug?: string | null,
    imageUrl?: string | null,
    parentId?: string | null,
    seq?: number | null,
    hidden?: boolean | null,
    createdAt: string,
    updatedAt: string,
    products?:  {
      __typename: "ModelProductCategoryConnection",
      items?:  Array< {
        __typename: "ProductCategory",
        company: string,
        id: string,
        categoryId: string,
        productId: string,
        seq: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    children?:  {
      __typename: "ModelCategoryConnection",
      items?:  Array< {
        __typename: "Category",
        company: string,
        id: string,
        name: string,
        description?: string | null,
        slug?: string | null,
        imageUrl?: string | null,
        parentId?: string | null,
        seq?: number | null,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateCategoryMutationVariables = {
  input: UpdateCategoryInput,
  condition?: ModelCategoryConditionInput | null,
};

export type UpdateCategoryMutation = {
  updateCategory?:  {
    __typename: "Category",
    company: string,
    id: string,
    name: string,
    description?: string | null,
    slug?: string | null,
    imageUrl?: string | null,
    parentId?: string | null,
    seq?: number | null,
    hidden?: boolean | null,
    createdAt: string,
    updatedAt: string,
    products?:  {
      __typename: "ModelProductCategoryConnection",
      items?:  Array< {
        __typename: "ProductCategory",
        company: string,
        id: string,
        categoryId: string,
        productId: string,
        seq: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    children?:  {
      __typename: "ModelCategoryConnection",
      items?:  Array< {
        __typename: "Category",
        company: string,
        id: string,
        name: string,
        description?: string | null,
        slug?: string | null,
        imageUrl?: string | null,
        parentId?: string | null,
        seq?: number | null,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteCategoryMutationVariables = {
  input: DeleteCategoryInput,
  condition?: ModelCategoryConditionInput | null,
};

export type DeleteCategoryMutation = {
  deleteCategory?:  {
    __typename: "Category",
    company: string,
    id: string,
    name: string,
    description?: string | null,
    slug?: string | null,
    imageUrl?: string | null,
    parentId?: string | null,
    seq?: number | null,
    hidden?: boolean | null,
    createdAt: string,
    updatedAt: string,
    products?:  {
      __typename: "ModelProductCategoryConnection",
      items?:  Array< {
        __typename: "ProductCategory",
        company: string,
        id: string,
        categoryId: string,
        productId: string,
        seq: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    children?:  {
      __typename: "ModelCategoryConnection",
      items?:  Array< {
        __typename: "Category",
        company: string,
        id: string,
        name: string,
        description?: string | null,
        slug?: string | null,
        imageUrl?: string | null,
        parentId?: string | null,
        seq?: number | null,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateMediaMutationVariables = {
  input: CreateMediaInput,
  condition?: ModelMediaConditionInput | null,
};

export type CreateMediaMutation = {
  createMedia?:  {
    __typename: "Media",
    company: string,
    id: string,
    url: string,
    name?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMediaMutationVariables = {
  input: UpdateMediaInput,
  condition?: ModelMediaConditionInput | null,
};

export type UpdateMediaMutation = {
  updateMedia?:  {
    __typename: "Media",
    company: string,
    id: string,
    url: string,
    name?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMediaMutationVariables = {
  input: DeleteMediaInput,
  condition?: ModelMediaConditionInput | null,
};

export type DeleteMediaMutation = {
  deleteMedia?:  {
    __typename: "Media",
    company: string,
    id: string,
    url: string,
    name?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMediaItemMutationVariables = {
  input: CreateMediaItemInput,
  condition?: ModelMediaItemConditionInput | null,
};

export type CreateMediaItemMutation = {
  createMediaItem?:  {
    __typename: "MediaItem",
    company: string,
    id: string,
    mediaId: string,
    parentId: string,
    default?: boolean | null,
    createdAt: string,
    updatedAt: string,
    media?:  {
      __typename: "Media",
      company: string,
      id: string,
      url: string,
      name?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type UpdateMediaItemMutationVariables = {
  input: UpdateMediaItemInput,
  condition?: ModelMediaItemConditionInput | null,
};

export type UpdateMediaItemMutation = {
  updateMediaItem?:  {
    __typename: "MediaItem",
    company: string,
    id: string,
    mediaId: string,
    parentId: string,
    default?: boolean | null,
    createdAt: string,
    updatedAt: string,
    media?:  {
      __typename: "Media",
      company: string,
      id: string,
      url: string,
      name?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeleteMediaItemMutationVariables = {
  input: DeleteMediaItemInput,
  condition?: ModelMediaItemConditionInput | null,
};

export type DeleteMediaItemMutation = {
  deleteMediaItem?:  {
    __typename: "MediaItem",
    company: string,
    id: string,
    mediaId: string,
    parentId: string,
    default?: boolean | null,
    createdAt: string,
    updatedAt: string,
    media?:  {
      __typename: "Media",
      company: string,
      id: string,
      url: string,
      name?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CreateShippingZoneMutationVariables = {
  input: CreateShippingZoneInput,
  condition?: ModelShippingZoneConditionInput | null,
};

export type CreateShippingZoneMutation = {
  createShippingZone?:  {
    __typename: "ShippingZone",
    company: string,
    id: string,
    name: string,
    regions?: string | null,
    createdAt: string,
    updatedAt: string,
    shippingRegions?:  {
      __typename: "ModelShippingRegionConnection",
      items?:  Array< {
        __typename: "ShippingRegion",
        company: string,
        id: string,
        zoneId: string,
        description?: string | null,
        type?: ShippingRegionTypeEnum | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    shippingMethods?:  {
      __typename: "ModelZoneShippingMethodConnection",
      items?:  Array< {
        __typename: "ZoneShippingMethod",
        company: string,
        id: string,
        zoneId: string,
        shippingMethodId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateShippingZoneMutationVariables = {
  input: UpdateShippingZoneInput,
  condition?: ModelShippingZoneConditionInput | null,
};

export type UpdateShippingZoneMutation = {
  updateShippingZone?:  {
    __typename: "ShippingZone",
    company: string,
    id: string,
    name: string,
    regions?: string | null,
    createdAt: string,
    updatedAt: string,
    shippingRegions?:  {
      __typename: "ModelShippingRegionConnection",
      items?:  Array< {
        __typename: "ShippingRegion",
        company: string,
        id: string,
        zoneId: string,
        description?: string | null,
        type?: ShippingRegionTypeEnum | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    shippingMethods?:  {
      __typename: "ModelZoneShippingMethodConnection",
      items?:  Array< {
        __typename: "ZoneShippingMethod",
        company: string,
        id: string,
        zoneId: string,
        shippingMethodId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteShippingZoneMutationVariables = {
  input: DeleteShippingZoneInput,
  condition?: ModelShippingZoneConditionInput | null,
};

export type DeleteShippingZoneMutation = {
  deleteShippingZone?:  {
    __typename: "ShippingZone",
    company: string,
    id: string,
    name: string,
    regions?: string | null,
    createdAt: string,
    updatedAt: string,
    shippingRegions?:  {
      __typename: "ModelShippingRegionConnection",
      items?:  Array< {
        __typename: "ShippingRegion",
        company: string,
        id: string,
        zoneId: string,
        description?: string | null,
        type?: ShippingRegionTypeEnum | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    shippingMethods?:  {
      __typename: "ModelZoneShippingMethodConnection",
      items?:  Array< {
        __typename: "ZoneShippingMethod",
        company: string,
        id: string,
        zoneId: string,
        shippingMethodId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateShippingRegionMutationVariables = {
  input: CreateShippingRegionInput,
  condition?: ModelShippingRegionConditionInput | null,
};

export type CreateShippingRegionMutation = {
  createShippingRegion?:  {
    __typename: "ShippingRegion",
    company: string,
    id: string,
    zoneId: string,
    description?: string | null,
    type?: ShippingRegionTypeEnum | null,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
    shippingZone?:  {
      __typename: "ShippingZone",
      company: string,
      id: string,
      name: string,
      regions?: string | null,
      createdAt: string,
      updatedAt: string,
      shippingRegions?:  {
        __typename: "ModelShippingRegionConnection",
        nextToken?: string | null,
      } | null,
      shippingMethods?:  {
        __typename: "ModelZoneShippingMethodConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateShippingRegionMutationVariables = {
  input: UpdateShippingRegionInput,
  condition?: ModelShippingRegionConditionInput | null,
};

export type UpdateShippingRegionMutation = {
  updateShippingRegion?:  {
    __typename: "ShippingRegion",
    company: string,
    id: string,
    zoneId: string,
    description?: string | null,
    type?: ShippingRegionTypeEnum | null,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
    shippingZone?:  {
      __typename: "ShippingZone",
      company: string,
      id: string,
      name: string,
      regions?: string | null,
      createdAt: string,
      updatedAt: string,
      shippingRegions?:  {
        __typename: "ModelShippingRegionConnection",
        nextToken?: string | null,
      } | null,
      shippingMethods?:  {
        __typename: "ModelZoneShippingMethodConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteShippingRegionMutationVariables = {
  input: DeleteShippingRegionInput,
  condition?: ModelShippingRegionConditionInput | null,
};

export type DeleteShippingRegionMutation = {
  deleteShippingRegion?:  {
    __typename: "ShippingRegion",
    company: string,
    id: string,
    zoneId: string,
    description?: string | null,
    type?: ShippingRegionTypeEnum | null,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
    shippingZone?:  {
      __typename: "ShippingZone",
      company: string,
      id: string,
      name: string,
      regions?: string | null,
      createdAt: string,
      updatedAt: string,
      shippingRegions?:  {
        __typename: "ModelShippingRegionConnection",
        nextToken?: string | null,
      } | null,
      shippingMethods?:  {
        __typename: "ModelZoneShippingMethodConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateShippingMethodMutationVariables = {
  input: CreateShippingMethodInput,
  condition?: ModelShippingMethodConditionInput | null,
};

export type CreateShippingMethodMutation = {
  createShippingMethod?:  {
    __typename: "ShippingMethod",
    company: string,
    id: string,
    type: DeliveryTypeEnum,
    name: string,
    cost: number,
    address?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateShippingMethodMutationVariables = {
  input: UpdateShippingMethodInput,
  condition?: ModelShippingMethodConditionInput | null,
};

export type UpdateShippingMethodMutation = {
  updateShippingMethod?:  {
    __typename: "ShippingMethod",
    company: string,
    id: string,
    type: DeliveryTypeEnum,
    name: string,
    cost: number,
    address?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteShippingMethodMutationVariables = {
  input: DeleteShippingMethodInput,
  condition?: ModelShippingMethodConditionInput | null,
};

export type DeleteShippingMethodMutation = {
  deleteShippingMethod?:  {
    __typename: "ShippingMethod",
    company: string,
    id: string,
    type: DeliveryTypeEnum,
    name: string,
    cost: number,
    address?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateZoneShippingMethodMutationVariables = {
  input: CreateZoneShippingMethodInput,
  condition?: ModelZoneShippingMethodConditionInput | null,
};

export type CreateZoneShippingMethodMutation = {
  createZoneShippingMethod?:  {
    __typename: "ZoneShippingMethod",
    company: string,
    id: string,
    zoneId: string,
    shippingMethodId: string,
    createdAt: string,
    updatedAt: string,
    shippingMethod?:  {
      __typename: "ShippingMethod",
      company: string,
      id: string,
      type: DeliveryTypeEnum,
      name: string,
      cost: number,
      address?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type UpdateZoneShippingMethodMutationVariables = {
  input: UpdateZoneShippingMethodInput,
  condition?: ModelZoneShippingMethodConditionInput | null,
};

export type UpdateZoneShippingMethodMutation = {
  updateZoneShippingMethod?:  {
    __typename: "ZoneShippingMethod",
    company: string,
    id: string,
    zoneId: string,
    shippingMethodId: string,
    createdAt: string,
    updatedAt: string,
    shippingMethod?:  {
      __typename: "ShippingMethod",
      company: string,
      id: string,
      type: DeliveryTypeEnum,
      name: string,
      cost: number,
      address?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeleteZoneShippingMethodMutationVariables = {
  input: DeleteZoneShippingMethodInput,
  condition?: ModelZoneShippingMethodConditionInput | null,
};

export type DeleteZoneShippingMethodMutation = {
  deleteZoneShippingMethod?:  {
    __typename: "ZoneShippingMethod",
    company: string,
    id: string,
    zoneId: string,
    shippingMethodId: string,
    createdAt: string,
    updatedAt: string,
    shippingMethod?:  {
      __typename: "ShippingMethod",
      company: string,
      id: string,
      type: DeliveryTypeEnum,
      name: string,
      cost: number,
      address?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CreateProductPriceMutationVariables = {
  input: CreateProductPriceInput,
  condition?: ModelProductPriceConditionInput | null,
};

export type CreateProductPriceMutation = {
  createProductPrice?:  {
    __typename: "ProductPrice",
    company: string,
    id: string,
    productId: string,
    startTime?: string | null,
    endTime?: string | null,
    price?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProductPriceMutationVariables = {
  input: UpdateProductPriceInput,
  condition?: ModelProductPriceConditionInput | null,
};

export type UpdateProductPriceMutation = {
  updateProductPrice?:  {
    __typename: "ProductPrice",
    company: string,
    id: string,
    productId: string,
    startTime?: string | null,
    endTime?: string | null,
    price?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProductPriceMutationVariables = {
  input: DeleteProductPriceInput,
  condition?: ModelProductPriceConditionInput | null,
};

export type DeleteProductPriceMutation = {
  deleteProductPrice?:  {
    __typename: "ProductPrice",
    company: string,
    id: string,
    productId: string,
    startTime?: string | null,
    endTime?: string | null,
    price?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDiscountMutationVariables = {
  input: CreateDiscountInput,
  condition?: ModelDiscountConditionInput | null,
};

export type CreateDiscountMutation = {
  createDiscount?:  {
    __typename: "Discount",
    company: string,
    id: string,
    name: string,
    rules?:  Array< {
      __typename: "DiscountRule",
      conditionScope: DiscountScopeEnum,
      condition:  {
        __typename: "DiscountRuleCondition",
        ne?: number | null,
        eq?: number | null,
        le?: number | null,
        lt?: number | null,
        ge?: number | null,
        gt?: number | null,
        between?: Array< number | null > | null,
      },
      discountScope: DiscountScopeEnum,
      type: DiscountRuleTypeEnum,
      value: number,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateDiscountMutationVariables = {
  input: UpdateDiscountInput,
  condition?: ModelDiscountConditionInput | null,
};

export type UpdateDiscountMutation = {
  updateDiscount?:  {
    __typename: "Discount",
    company: string,
    id: string,
    name: string,
    rules?:  Array< {
      __typename: "DiscountRule",
      conditionScope: DiscountScopeEnum,
      condition:  {
        __typename: "DiscountRuleCondition",
        ne?: number | null,
        eq?: number | null,
        le?: number | null,
        lt?: number | null,
        ge?: number | null,
        gt?: number | null,
        between?: Array< number | null > | null,
      },
      discountScope: DiscountScopeEnum,
      type: DiscountRuleTypeEnum,
      value: number,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteDiscountMutationVariables = {
  input: DeleteDiscountInput,
  condition?: ModelDiscountConditionInput | null,
};

export type DeleteDiscountMutation = {
  deleteDiscount?:  {
    __typename: "Discount",
    company: string,
    id: string,
    name: string,
    rules?:  Array< {
      __typename: "DiscountRule",
      conditionScope: DiscountScopeEnum,
      condition:  {
        __typename: "DiscountRuleCondition",
        ne?: number | null,
        eq?: number | null,
        le?: number | null,
        lt?: number | null,
        ge?: number | null,
        gt?: number | null,
        between?: Array< number | null > | null,
      },
      discountScope: DiscountScopeEnum,
      type: DiscountRuleTypeEnum,
      value: number,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLogMutationVariables = {
  input: CreateLogInput,
  condition?: ModelLogConditionInput | null,
};

export type CreateLogMutation = {
  createLog?:  {
    __typename: "Log",
    company: string,
    id: string,
    parentId: string,
    event: string,
    source?: string | null,
    destination?: string | null,
    description?: string | null,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLogMutationVariables = {
  input: UpdateLogInput,
  condition?: ModelLogConditionInput | null,
};

export type UpdateLogMutation = {
  updateLog?:  {
    __typename: "Log",
    company: string,
    id: string,
    parentId: string,
    event: string,
    source?: string | null,
    destination?: string | null,
    description?: string | null,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type IsExistingCustomerQueryVariables = {
  email?: string | null,
};

export type IsExistingCustomerQuery = {
  isExistingCustomer?:  {
    __typename: "IsExistingCustomerResponse",
    exists: boolean,
    customer?:  {
      __typename: "ExistingCustomerInfo",
      id?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      status?: string | null,
    } | null,
  } | null,
};

export type GetAvailableStockQtyQueryVariables = {
  input: GetAvailableStockQtyInput,
};

export type GetAvailableStockQtyQuery = {
  getAvailableStockQty?:  Array< {
    __typename: "AvailableStockQtyResponse",
    productId: string,
    locationQty?:  Array< {
      __typename: "LocationQty",
      location: string,
      qty: number,
    } | null > | null,
  } | null > | null,
};

export type ValidateCouponQueryVariables = {
  input: ValidateCouponInput,
};

export type ValidateCouponQuery = {
  validateCoupon?:  {
    __typename: "Coupon",
    company: string,
    id: string,
    description?: string | null,
    type: CouponTypeEnum,
    status: CouponStatusEnum,
    expireAt: string,
    startTime: string,
    value: number,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    qtyAvailable: number,
    qtyReserved: number,
    qtyUsed: number,
    minSpend?: number | null,
    maxSpend?: number | null,
    createdAt: string,
    updatedAt: string,
    version: number,
    products?:  {
      __typename: "ModelCouponProductConnection",
      items?:  Array< {
        __typename: "CouponProduct",
        company: string,
        id: string,
        couponId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type GetCompanyQueryVariables = {
  id: string,
};

export type GetCompanyQuery = {
  getCompany?:  {
    __typename: "Company",
    id: string,
    status?: CompanyStatusEnum | null,
    plan: string,
    email: string,
    timeZone: string,
    locale?: string | null,
    country: string,
    currency?: string | null,
    billingDetails?:  {
      __typename: "BillingDetails",
      processor: string,
      currency: string,
      nextPaymentDate: string,
      nextPaymentAmount: number,
    } | null,
    cards?: string | null,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    accountPayments?:  {
      __typename: "ModelAccountPaymentConnection",
      items?:  Array< {
        __typename: "AccountPayment",
        company: string,
        id: string,
        plan: string,
        status: PaymentStatusEnum,
        currency: string,
        totalGross: number,
        totalFee: number,
        totalNet: number,
        processor?: string | null,
        processorData?: string | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListCompanysQueryVariables = {
  id?: string | null,
  filter?: ModelCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCompanysQuery = {
  listCompanys?:  {
    __typename: "ModelCompanyConnection",
    items?:  Array< {
      __typename: "Company",
      id: string,
      status?: CompanyStatusEnum | null,
      plan: string,
      email: string,
      timeZone: string,
      locale?: string | null,
      country: string,
      currency?: string | null,
      billingDetails?:  {
        __typename: "BillingDetails",
        processor: string,
        currency: string,
        nextPaymentDate: string,
        nextPaymentAmount: number,
      } | null,
      cards?: string | null,
      settings?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
      accountPayments?:  {
        __typename: "ModelAccountPaymentConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListCompaniesByStatusQueryVariables = {
  status?: CompanyStatusEnum | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompaniesByStatusQuery = {
  listCompaniesByStatus?:  {
    __typename: "ModelCompanyConnection",
    items?:  Array< {
      __typename: "Company",
      id: string,
      status?: CompanyStatusEnum | null,
      plan: string,
      email: string,
      timeZone: string,
      locale?: string | null,
      country: string,
      currency?: string | null,
      billingDetails?:  {
        __typename: "BillingDetails",
        processor: string,
        currency: string,
        nextPaymentDate: string,
        nextPaymentAmount: number,
      } | null,
      cards?: string | null,
      settings?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
      accountPayments?:  {
        __typename: "ModelAccountPaymentConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetLocationQueryVariables = {
  company: string,
  id: string,
};

export type GetLocationQuery = {
  getLocation?:  {
    __typename: "Location",
    company: string,
    id: string,
    createdAt: string,
    name: string,
    description?: string | null,
    type: LocationTypeEnum,
    email?: string | null,
    phoneNumber?: string | null,
    physicalAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    updatedAt: string,
    settings?:  {
      __typename: "ModelSettingConnection",
      items?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListLocationsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLocationsQuery = {
  listLocations?:  {
    __typename: "ModelLocationConnection",
    items?:  Array< {
      __typename: "Location",
      company: string,
      id: string,
      createdAt: string,
      name: string,
      description?: string | null,
      type: LocationTypeEnum,
      email?: string | null,
      phoneNumber?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      updatedAt: string,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetSettingQueryVariables = {
  company: string,
  parentId: string,
  settingId: string,
};

export type GetSettingQuery = {
  getSetting?:  {
    __typename: "Setting",
    company: string,
    parentId: string,
    settingId: string,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSettingsQueryVariables = {
  company?: string | null,
  parentIdSettingId?: ModelSettingPrimaryCompositeKeyConditionInput | null,
  filter?: ModelSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSettingsQuery = {
  listSettings?:  {
    __typename: "ModelSettingConnection",
    items?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetAccountPaymentQueryVariables = {
  company: string,
  id: string,
};

export type GetAccountPaymentQuery = {
  getAccountPayment?:  {
    __typename: "AccountPayment",
    company: string,
    id: string,
    plan: string,
    status: PaymentStatusEnum,
    currency: string,
    totalGross: number,
    totalFee: number,
    totalNet: number,
    processor?: string | null,
    processorData?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListAccountPaymentsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelAccountPaymentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAccountPaymentsQuery = {
  listAccountPayments?:  {
    __typename: "ModelAccountPaymentConnection",
    items?:  Array< {
      __typename: "AccountPayment",
      company: string,
      id: string,
      plan: string,
      status: PaymentStatusEnum,
      currency: string,
      totalGross: number,
      totalFee: number,
      totalNet: number,
      processor?: string | null,
      processorData?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListAccountPaymentsByCreateTimeQueryVariables = {
  company?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAccountPaymentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAccountPaymentsByCreateTimeQuery = {
  listAccountPaymentsByCreateTime?:  {
    __typename: "ModelAccountPaymentConnection",
    items?:  Array< {
      __typename: "AccountPayment",
      company: string,
      id: string,
      plan: string,
      status: PaymentStatusEnum,
      currency: string,
      totalGross: number,
      totalFee: number,
      totalNet: number,
      processor?: string | null,
      processorData?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetCustomerQueryVariables = {
  company: string,
  id: string,
};

export type GetCustomerQuery = {
  getCustomer?:  {
    __typename: "Customer",
    company: string,
    id: string,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    physicalAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCustomersQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCustomersQuery = {
  listCustomers?:  {
    __typename: "ModelCustomerConnection",
    items?:  Array< {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type SearchCustomersQueryVariables = {
  filter?: SearchableCustomerFilterInput | null,
  sort?: SearchableCustomerSortInput | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SearchCustomersQuery = {
  searchCustomers?:  {
    __typename: "SearchableCustomerConnection",
    items?:  Array< {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type GetPaymentQueryVariables = {
  company: string,
  id: string,
};

export type GetPaymentQuery = {
  getPayment?:  {
    __typename: "Payment",
    company: string,
    id: string,
    customerId: string,
    orderId: string,
    status: PaymentStatusEnum,
    currency: string,
    originalCurrency?: string | null,
    conversionRate?: number | null,
    totalGross: number,
    totalFee?: number | null,
    totalNet?: number | null,
    processorId: string,
    extPaymentId?: string | null,
    processorData?: string | null,
    createdAt: string,
    reason?: string | null,
    updatedAt: string,
    customer?:  {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    processor?:  {
      __typename: "CompanyPaymentProcessor",
      company: string,
      id: string,
      name?: string | null,
      description?: string | null,
      active?: boolean | null,
      formValues?:  Array< {
        __typename: "FieldValue",
        name: string,
        type: string,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
      processor?:  {
        __typename: "PaymentProcessor",
        id: string,
        name?: string | null,
        description?: string | null,
        active?: boolean | null,
        logo?: string | null,
        countries?: Array< string | null > | null,
        website?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type ListPaymentsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelPaymentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPaymentsQuery = {
  listPayments?:  {
    __typename: "ModelPaymentConnection",
    items?:  Array< {
      __typename: "Payment",
      company: string,
      id: string,
      customerId: string,
      orderId: string,
      status: PaymentStatusEnum,
      currency: string,
      originalCurrency?: string | null,
      conversionRate?: number | null,
      totalGross: number,
      totalFee?: number | null,
      totalNet?: number | null,
      processorId: string,
      extPaymentId?: string | null,
      processorData?: string | null,
      createdAt: string,
      reason?: string | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      processor?:  {
        __typename: "CompanyPaymentProcessor",
        company: string,
        id: string,
        name?: string | null,
        description?: string | null,
        active?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListPaymentsByOrderIdQueryVariables = {
  company?: string | null,
  orderId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaymentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPaymentsByOrderIdQuery = {
  listPaymentsByOrderId?:  {
    __typename: "ModelPaymentConnection",
    items?:  Array< {
      __typename: "Payment",
      company: string,
      id: string,
      customerId: string,
      orderId: string,
      status: PaymentStatusEnum,
      currency: string,
      originalCurrency?: string | null,
      conversionRate?: number | null,
      totalGross: number,
      totalFee?: number | null,
      totalNet?: number | null,
      processorId: string,
      extPaymentId?: string | null,
      processorData?: string | null,
      createdAt: string,
      reason?: string | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      processor?:  {
        __typename: "CompanyPaymentProcessor",
        company: string,
        id: string,
        name?: string | null,
        description?: string | null,
        active?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListPaymentsByExtPaymentIdQueryVariables = {
  extPaymentId?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaymentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPaymentsByExtPaymentIdQuery = {
  listPaymentsByExtPaymentId?:  {
    __typename: "ModelPaymentConnection",
    items?:  Array< {
      __typename: "Payment",
      company: string,
      id: string,
      customerId: string,
      orderId: string,
      status: PaymentStatusEnum,
      currency: string,
      originalCurrency?: string | null,
      conversionRate?: number | null,
      totalGross: number,
      totalFee?: number | null,
      totalNet?: number | null,
      processorId: string,
      extPaymentId?: string | null,
      processorData?: string | null,
      createdAt: string,
      reason?: string | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      processor?:  {
        __typename: "CompanyPaymentProcessor",
        company: string,
        id: string,
        name?: string | null,
        description?: string | null,
        active?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListPaymentsByOrderIdCreateTimeQueryVariables = {
  company?: string | null,
  orderIdCreatedAt?: ModelPaymentByOrderIdCreatedTimeCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPaymentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPaymentsByOrderIdCreateTimeQuery = {
  listPaymentsByOrderIdCreateTime?:  {
    __typename: "ModelPaymentConnection",
    items?:  Array< {
      __typename: "Payment",
      company: string,
      id: string,
      customerId: string,
      orderId: string,
      status: PaymentStatusEnum,
      currency: string,
      originalCurrency?: string | null,
      conversionRate?: number | null,
      totalGross: number,
      totalFee?: number | null,
      totalNet?: number | null,
      processorId: string,
      extPaymentId?: string | null,
      processorData?: string | null,
      createdAt: string,
      reason?: string | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      processor?:  {
        __typename: "CompanyPaymentProcessor",
        company: string,
        id: string,
        name?: string | null,
        description?: string | null,
        active?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type SearchPaymentsQueryVariables = {
  filter?: SearchablePaymentFilterInput | null,
  sort?: SearchablePaymentSortInput | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SearchPaymentsQuery = {
  searchPayments?:  {
    __typename: "SearchablePaymentConnection",
    items?:  Array< {
      __typename: "Payment",
      company: string,
      id: string,
      customerId: string,
      orderId: string,
      status: PaymentStatusEnum,
      currency: string,
      originalCurrency?: string | null,
      conversionRate?: number | null,
      totalGross: number,
      totalFee?: number | null,
      totalNet?: number | null,
      processorId: string,
      extPaymentId?: string | null,
      processorData?: string | null,
      createdAt: string,
      reason?: string | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      processor?:  {
        __typename: "CompanyPaymentProcessor",
        company: string,
        id: string,
        name?: string | null,
        description?: string | null,
        active?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type GetPaymentProcessorQueryVariables = {
  id: string,
};

export type GetPaymentProcessorQuery = {
  getPaymentProcessor?:  {
    __typename: "PaymentProcessor",
    id: string,
    name?: string | null,
    description?: string | null,
    active?: boolean | null,
    logo?: string | null,
    formFields?:  Array< {
      __typename: "FieldDefinition",
      name: string,
      type: string,
      required: boolean,
      tooltip?: string | null,
    } | null > | null,
    countries?: Array< string | null > | null,
    website?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPaymentProcessorsQueryVariables = {
  id?: string | null,
  filter?: ModelPaymentProcessorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPaymentProcessorsQuery = {
  listPaymentProcessors?:  {
    __typename: "ModelPaymentProcessorConnection",
    items?:  Array< {
      __typename: "PaymentProcessor",
      id: string,
      name?: string | null,
      description?: string | null,
      active?: boolean | null,
      logo?: string | null,
      formFields?:  Array< {
        __typename: "FieldDefinition",
        name: string,
        type: string,
        required: boolean,
        tooltip?: string | null,
      } | null > | null,
      countries?: Array< string | null > | null,
      website?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetCompanyPaymentProcessorQueryVariables = {
  company: string,
  id: string,
};

export type GetCompanyPaymentProcessorQuery = {
  getCompanyPaymentProcessor?:  {
    __typename: "CompanyPaymentProcessor",
    company: string,
    id: string,
    name?: string | null,
    description?: string | null,
    active?: boolean | null,
    formValues?:  Array< {
      __typename: "FieldValue",
      name: string,
      type: string,
      value?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    processor?:  {
      __typename: "PaymentProcessor",
      id: string,
      name?: string | null,
      description?: string | null,
      active?: boolean | null,
      logo?: string | null,
      formFields?:  Array< {
        __typename: "FieldDefinition",
        name: string,
        type: string,
        required: boolean,
        tooltip?: string | null,
      } | null > | null,
      countries?: Array< string | null > | null,
      website?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ListCompanyPaymentProcessorsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelCompanyPaymentProcessorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCompanyPaymentProcessorsQuery = {
  listCompanyPaymentProcessors?:  {
    __typename: "ModelCompanyPaymentProcessorConnection",
    items?:  Array< {
      __typename: "CompanyPaymentProcessor",
      company: string,
      id: string,
      name?: string | null,
      description?: string | null,
      active?: boolean | null,
      formValues?:  Array< {
        __typename: "FieldValue",
        name: string,
        type: string,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
      processor?:  {
        __typename: "PaymentProcessor",
        id: string,
        name?: string | null,
        description?: string | null,
        active?: boolean | null,
        logo?: string | null,
        countries?: Array< string | null > | null,
        website?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetSequenceQueryVariables = {
  company: string,
  id: string,
};

export type GetSequenceQuery = {
  getSequence?:  {
    __typename: "Sequence",
    company: string,
    id: string,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSequencesQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelSequenceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSequencesQuery = {
  listSequences?:  {
    __typename: "ModelSequenceConnection",
    items?:  Array< {
      __typename: "Sequence",
      company: string,
      id: string,
      version: number,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetOrderQueryVariables = {
  company: string,
  id: string,
};

export type GetOrderQuery = {
  getOrder?:  {
    __typename: "Order",
    company: string,
    id: string,
    type?: OrderTypeEnum | null,
    status?: OrderStatusEnum | null,
    ref: string,
    locationId?: string | null,
    customerId: string,
    customerEmail?: string | null,
    customerFirstName?: string | null,
    customerLastName?: string | null,
    owner: string,
    categoryId?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    contactNumber?: string | null,
    deliveryType?: DeliveryTypeEnum | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryTime?: string | null,
    returnedTime?: string | null,
    confirmedTime?: string | null,
    deliveredTime?: string | null,
    total?: number | null,
    deposit?: number | null,
    subTotal?: number | null,
    discountTotal?: number | null,
    deliveryFee?: number | null,
    reason?: string | null,
    notes?: string | null,
    createdAt: string,
    completedAt?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    updatedAt: string,
    customer?:  {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    payments?:  {
      __typename: "ModelPaymentConnection",
      items?:  Array< {
        __typename: "Payment",
        company: string,
        id: string,
        customerId: string,
        orderId: string,
        status: PaymentStatusEnum,
        currency: string,
        originalCurrency?: string | null,
        conversionRate?: number | null,
        totalGross: number,
        totalFee?: number | null,
        totalNet?: number | null,
        processorId: string,
        extPaymentId?: string | null,
        processorData?: string | null,
        createdAt: string,
        reason?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    products?:  {
      __typename: "ModelOrderProductConnection",
      items?:  Array< {
        __typename: "OrderProduct",
        company: string,
        id: string,
        orderId: string,
        productId: string,
        owner: string,
        orderType: OrderTypeEnum,
        startTime?: string | null,
        endTime?: string | null,
        qty: number,
        total: number,
        subTotal: number,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    coupons?:  {
      __typename: "ModelOrderCouponConnection",
      items?:  Array< {
        __typename: "OrderCoupon",
        company: string,
        id: string,
        orderId: string,
        couponId: string,
        owner: string,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelOrderStockItemConnection",
      items?:  Array< {
        __typename: "OrderStockItem",
        company: string,
        id: string,
        orderId: string,
        stockItemId: string,
        orderType: OrderTypeEnum,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    logs?:  {
      __typename: "ModelLogConnection",
      items?:  Array< {
        __typename: "Log",
        company: string,
        id: string,
        parentId: string,
        event: string,
        source?: string | null,
        destination?: string | null,
        description?: string | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListOrdersQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListOrdersQuery = {
  listOrders?:  {
    __typename: "ModelOrderConnection",
    items?:  Array< {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListOrdersByStartTimeQueryVariables = {
  company?: string | null,
  startTime?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrdersByStartTimeQuery = {
  listOrdersByStartTime?:  {
    __typename: "ModelOrderConnection",
    items?:  Array< {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListOrdersByStatusStartTimeQueryVariables = {
  company?: string | null,
  statusStartTime?: ModelOrderByStatusStartTimeCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrdersByStatusStartTimeQuery = {
  listOrdersByStatusStartTime?:  {
    __typename: "ModelOrderConnection",
    items?:  Array< {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListOrdersByStatusEndTimeQueryVariables = {
  company?: string | null,
  statusEndTime?: ModelOrderByStatusEndTimeCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrdersByStatusEndTimeQuery = {
  listOrdersByStatusEndTime?:  {
    __typename: "ModelOrderConnection",
    items?:  Array< {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListOrdersByCompletedAtQueryVariables = {
  status?: OrderStatusEnum | null,
  companyCompletedAt?: ModelOrderByStatusCompletedAtCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrdersByCompletedAtQuery = {
  listOrdersByCompletedAt?:  {
    __typename: "ModelOrderConnection",
    items?:  Array< {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListOrdersByCustomerIdQueryVariables = {
  company?: string | null,
  customerIdCreatedAt?: ModelOrderByCustomerIdCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrdersByCustomerIdQuery = {
  listOrdersByCustomerId?:  {
    __typename: "ModelOrderConnection",
    items?:  Array< {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListOrdersByRefQueryVariables = {
  ref?: string | null,
  company?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrdersByRefQuery = {
  listOrdersByRef?:  {
    __typename: "ModelOrderConnection",
    items?:  Array< {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type SearchOrdersQueryVariables = {
  filter?: SearchableOrderFilterInput | null,
  sort?: SearchableOrderSortInput | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SearchOrdersQuery = {
  searchOrders?:  {
    __typename: "SearchableOrderConnection",
    items?:  Array< {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type GetOrderProductQueryVariables = {
  company: string,
  id: string,
};

export type GetOrderProductQuery = {
  getOrderProduct?:  {
    __typename: "OrderProduct",
    company: string,
    id: string,
    orderId: string,
    productId: string,
    owner: string,
    productInfo:  {
      __typename: "OrderProductInfo",
      name: string,
      categoryId?: string | null,
      description?: string | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      imageUrl?: string | null,
      price: number,
    },
    orderType: OrderTypeEnum,
    startTime?: string | null,
    endTime?: string | null,
    qty: number,
    total: number,
    subTotal: number,
    discountTotal: number,
    createdAt: string,
    updatedAt: string,
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListOrderProductsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelOrderProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListOrderProductsQuery = {
  listOrderProducts?:  {
    __typename: "ModelOrderProductConnection",
    items?:  Array< {
      __typename: "OrderProduct",
      company: string,
      id: string,
      orderId: string,
      productId: string,
      owner: string,
      productInfo:  {
        __typename: "OrderProductInfo",
        name: string,
        categoryId?: string | null,
        description?: string | null,
        imageUrl?: string | null,
        price: number,
      },
      orderType: OrderTypeEnum,
      startTime?: string | null,
      endTime?: string | null,
      qty: number,
      total: number,
      subTotal: number,
      discountTotal: number,
      createdAt: string,
      updatedAt: string,
      order?:  {
        __typename: "Order",
        company: string,
        id: string,
        type?: OrderTypeEnum | null,
        status?: OrderStatusEnum | null,
        ref: string,
        locationId?: string | null,
        customerId: string,
        customerEmail?: string | null,
        customerFirstName?: string | null,
        customerLastName?: string | null,
        owner: string,
        categoryId?: string | null,
        startTime?: string | null,
        endTime?: string | null,
        contactNumber?: string | null,
        deliveryType?: DeliveryTypeEnum | null,
        deliveryTime?: string | null,
        returnedTime?: string | null,
        confirmedTime?: string | null,
        deliveredTime?: string | null,
        total?: number | null,
        deposit?: number | null,
        subTotal?: number | null,
        discountTotal?: number | null,
        deliveryFee?: number | null,
        reason?: string | null,
        notes?: string | null,
        createdAt: string,
        completedAt?: string | null,
        updatedAt: string,
      } | null,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListOrderItemsByProductQueryVariables = {
  company?: string | null,
  productIdStartTime?: ModelOrderProductByProductCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrderItemsByProductQuery = {
  listOrderItemsByProduct?:  {
    __typename: "ModelOrderProductConnection",
    items?:  Array< {
      __typename: "OrderProduct",
      company: string,
      id: string,
      orderId: string,
      productId: string,
      owner: string,
      productInfo:  {
        __typename: "OrderProductInfo",
        name: string,
        categoryId?: string | null,
        description?: string | null,
        imageUrl?: string | null,
        price: number,
      },
      orderType: OrderTypeEnum,
      startTime?: string | null,
      endTime?: string | null,
      qty: number,
      total: number,
      subTotal: number,
      discountTotal: number,
      createdAt: string,
      updatedAt: string,
      order?:  {
        __typename: "Order",
        company: string,
        id: string,
        type?: OrderTypeEnum | null,
        status?: OrderStatusEnum | null,
        ref: string,
        locationId?: string | null,
        customerId: string,
        customerEmail?: string | null,
        customerFirstName?: string | null,
        customerLastName?: string | null,
        owner: string,
        categoryId?: string | null,
        startTime?: string | null,
        endTime?: string | null,
        contactNumber?: string | null,
        deliveryType?: DeliveryTypeEnum | null,
        deliveryTime?: string | null,
        returnedTime?: string | null,
        confirmedTime?: string | null,
        deliveredTime?: string | null,
        total?: number | null,
        deposit?: number | null,
        subTotal?: number | null,
        discountTotal?: number | null,
        deliveryFee?: number | null,
        reason?: string | null,
        notes?: string | null,
        createdAt: string,
        completedAt?: string | null,
        updatedAt: string,
      } | null,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetOrderCouponQueryVariables = {
  company: string,
  id: string,
};

export type GetOrderCouponQuery = {
  getOrderCoupon?:  {
    __typename: "OrderCoupon",
    company: string,
    id: string,
    orderId: string,
    couponId: string,
    owner: string,
    coupon?:  {
      __typename: "Coupon",
      company: string,
      id: string,
      description?: string | null,
      type: CouponTypeEnum,
      status: CouponStatusEnum,
      expireAt: string,
      startTime: string,
      value: number,
      settings?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      qtyAvailable: number,
      qtyReserved: number,
      qtyUsed: number,
      minSpend?: number | null,
      maxSpend?: number | null,
      createdAt: string,
      updatedAt: string,
      version: number,
      products?:  {
        __typename: "ModelCouponProductConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    discountTotal: number,
    createdAt: string,
    updatedAt: string,
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListOrderCouponsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelOrderCouponFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListOrderCouponsQuery = {
  listOrderCoupons?:  {
    __typename: "ModelOrderCouponConnection",
    items?:  Array< {
      __typename: "OrderCoupon",
      company: string,
      id: string,
      orderId: string,
      couponId: string,
      owner: string,
      coupon?:  {
        __typename: "Coupon",
        company: string,
        id: string,
        description?: string | null,
        type: CouponTypeEnum,
        status: CouponStatusEnum,
        expireAt: string,
        startTime: string,
        value: number,
        qtyAvailable: number,
        qtyReserved: number,
        qtyUsed: number,
        minSpend?: number | null,
        maxSpend?: number | null,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
      discountTotal: number,
      createdAt: string,
      updatedAt: string,
      order?:  {
        __typename: "Order",
        company: string,
        id: string,
        type?: OrderTypeEnum | null,
        status?: OrderStatusEnum | null,
        ref: string,
        locationId?: string | null,
        customerId: string,
        customerEmail?: string | null,
        customerFirstName?: string | null,
        customerLastName?: string | null,
        owner: string,
        categoryId?: string | null,
        startTime?: string | null,
        endTime?: string | null,
        contactNumber?: string | null,
        deliveryType?: DeliveryTypeEnum | null,
        deliveryTime?: string | null,
        returnedTime?: string | null,
        confirmedTime?: string | null,
        deliveredTime?: string | null,
        total?: number | null,
        deposit?: number | null,
        subTotal?: number | null,
        discountTotal?: number | null,
        deliveryFee?: number | null,
        reason?: string | null,
        notes?: string | null,
        createdAt: string,
        completedAt?: string | null,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListOrderCouponsByCouponIdQueryVariables = {
  company?: string | null,
  couponId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderCouponFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrderCouponsByCouponIdQuery = {
  listOrderCouponsByCouponId?:  {
    __typename: "ModelOrderCouponConnection",
    items?:  Array< {
      __typename: "OrderCoupon",
      company: string,
      id: string,
      orderId: string,
      couponId: string,
      owner: string,
      coupon?:  {
        __typename: "Coupon",
        company: string,
        id: string,
        description?: string | null,
        type: CouponTypeEnum,
        status: CouponStatusEnum,
        expireAt: string,
        startTime: string,
        value: number,
        qtyAvailable: number,
        qtyReserved: number,
        qtyUsed: number,
        minSpend?: number | null,
        maxSpend?: number | null,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
      discountTotal: number,
      createdAt: string,
      updatedAt: string,
      order?:  {
        __typename: "Order",
        company: string,
        id: string,
        type?: OrderTypeEnum | null,
        status?: OrderStatusEnum | null,
        ref: string,
        locationId?: string | null,
        customerId: string,
        customerEmail?: string | null,
        customerFirstName?: string | null,
        customerLastName?: string | null,
        owner: string,
        categoryId?: string | null,
        startTime?: string | null,
        endTime?: string | null,
        contactNumber?: string | null,
        deliveryType?: DeliveryTypeEnum | null,
        deliveryTime?: string | null,
        returnedTime?: string | null,
        confirmedTime?: string | null,
        deliveredTime?: string | null,
        total?: number | null,
        deposit?: number | null,
        subTotal?: number | null,
        discountTotal?: number | null,
        deliveryFee?: number | null,
        reason?: string | null,
        notes?: string | null,
        createdAt: string,
        completedAt?: string | null,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListOrderCouponsByOwnerQueryVariables = {
  owner?: string | null,
  company?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderCouponFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrderCouponsByOwnerQuery = {
  listOrderCouponsByOwner?:  {
    __typename: "ModelOrderCouponConnection",
    items?:  Array< {
      __typename: "OrderCoupon",
      company: string,
      id: string,
      orderId: string,
      couponId: string,
      owner: string,
      coupon?:  {
        __typename: "Coupon",
        company: string,
        id: string,
        description?: string | null,
        type: CouponTypeEnum,
        status: CouponStatusEnum,
        expireAt: string,
        startTime: string,
        value: number,
        qtyAvailable: number,
        qtyReserved: number,
        qtyUsed: number,
        minSpend?: number | null,
        maxSpend?: number | null,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
      discountTotal: number,
      createdAt: string,
      updatedAt: string,
      order?:  {
        __typename: "Order",
        company: string,
        id: string,
        type?: OrderTypeEnum | null,
        status?: OrderStatusEnum | null,
        ref: string,
        locationId?: string | null,
        customerId: string,
        customerEmail?: string | null,
        customerFirstName?: string | null,
        customerLastName?: string | null,
        owner: string,
        categoryId?: string | null,
        startTime?: string | null,
        endTime?: string | null,
        contactNumber?: string | null,
        deliveryType?: DeliveryTypeEnum | null,
        deliveryTime?: string | null,
        returnedTime?: string | null,
        confirmedTime?: string | null,
        deliveredTime?: string | null,
        total?: number | null,
        deposit?: number | null,
        subTotal?: number | null,
        discountTotal?: number | null,
        deliveryFee?: number | null,
        reason?: string | null,
        notes?: string | null,
        createdAt: string,
        completedAt?: string | null,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetOrderStockItemQueryVariables = {
  company: string,
  id: string,
};

export type GetOrderStockItemQuery = {
  getOrderStockItem?:  {
    __typename: "OrderStockItem",
    company: string,
    id: string,
    orderId: string,
    stockItemId: string,
    orderType: OrderTypeEnum,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListOrderStockItemsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelOrderStockItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListOrderStockItemsQuery = {
  listOrderStockItems?:  {
    __typename: "ModelOrderStockItemConnection",
    items?:  Array< {
      __typename: "OrderStockItem",
      company: string,
      id: string,
      orderId: string,
      stockItemId: string,
      orderType: OrderTypeEnum,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListOrderStockItemByOrderQueryVariables = {
  company?: string | null,
  orderId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderStockItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrderStockItemByOrderQuery = {
  listOrderStockItemByOrder?:  {
    __typename: "ModelOrderStockItemConnection",
    items?:  Array< {
      __typename: "OrderStockItem",
      company: string,
      id: string,
      orderId: string,
      stockItemId: string,
      orderType: OrderTypeEnum,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListOrderStockItemByProductQueryVariables = {
  company?: string | null,
  stockItemId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderStockItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrderStockItemByProductQuery = {
  listOrderStockItemByProduct?:  {
    __typename: "ModelOrderStockItemConnection",
    items?:  Array< {
      __typename: "OrderStockItem",
      company: string,
      id: string,
      orderId: string,
      stockItemId: string,
      orderType: OrderTypeEnum,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetProductQueryVariables = {
  company: string,
  id: string,
};

export type GetProductQuery = {
  getProduct?:  {
    __typename: "Product",
    company: string,
    id: string,
    comloc: string,
    sku: string,
    type: ProductTypeEnum,
    name: string,
    slug: string,
    excerpt?: string | null,
    mediaId: string,
    description?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    status?: ProductStatusEnum | null,
    price?: number | null,
    deposit?: number | null,
    cost?: number | null,
    dimensions?:  {
      __typename: "Dimensions",
      height?: number | null,
      width?: number | null,
      weight?: number | null,
      length?: number | null,
    } | null,
    qtyOnHand: number,
    qtyAvailable: number,
    qtyReserved: number,
    createdAt: string,
    updatedAt: string,
    version: number,
    settings?:  {
      __typename: "ModelSettingConnection",
      items?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    bundleProducts?:  {
      __typename: "ModelBundleProductConnection",
      items?:  Array< {
        __typename: "BundleProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    features?:  {
      __typename: "ModelFeatureConnection",
      items?:  Array< {
        __typename: "Feature",
        company: string,
        id: string,
        parentId: string,
        categoryId?: string | null,
        text: string,
        description?: string | null,
        imageUrl?: string | null,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelStockItemConnection",
      items?:  Array< {
        __typename: "StockItem",
        company: string,
        id: string,
        location: string,
        serialNumber: string,
        status?: StockItemStatusEnum | null,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    categories?:  {
      __typename: "ModelProductCategoryConnection",
      items?:  Array< {
        __typename: "ProductCategory",
        company: string,
        id: string,
        categoryId: string,
        productId: string,
        seq: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    upsellProducts?:  {
      __typename: "ModelUpsellProductConnection",
      items?:  Array< {
        __typename: "UpsellProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    crossSellProducts?:  {
      __typename: "ModelCrossSellProductConnection",
      items?:  Array< {
        __typename: "CrossSellProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    image?:  {
      __typename: "Media",
      company: string,
      id: string,
      url: string,
      name?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    media?:  {
      __typename: "ModelMediaItemConnection",
      items?:  Array< {
        __typename: "MediaItem",
        company: string,
        id: string,
        mediaId: string,
        parentId: string,
        default?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    customPrice?:  {
      __typename: "ModelProductPriceConnection",
      items?:  Array< {
        __typename: "ProductPrice",
        company: string,
        id: string,
        productId: string,
        startTime?: string | null,
        endTime?: string | null,
        price?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListProductsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListProductsQuery = {
  listProducts?:  {
    __typename: "ModelProductConnection",
    items?:  Array< {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListProductsByTypeQueryVariables = {
  company?: string | null,
  typeName?: ModelProductListProductsByTypeCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductsByTypeQuery = {
  listProductsByType?:  {
    __typename: "ModelProductConnection",
    items?:  Array< {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListProductsByStatusQueryVariables = {
  company?: string | null,
  typeStatusName?: ModelProductListProductsByStatusCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductsByStatusQuery = {
  listProductsByStatus?:  {
    __typename: "ModelProductConnection",
    items?:  Array< {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListLocationProductsByTypeQueryVariables = {
  comloc?: string | null,
  typeStatusName?: ModelProductListLocationProductsByTypeCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLocationProductsByTypeQuery = {
  listLocationProductsByType?:  {
    __typename: "ModelProductConnection",
    items?:  Array< {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type SearchProductsQueryVariables = {
  filter?: SearchableProductFilterInput | null,
  sort?: SearchableProductSortInput | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SearchProductsQuery = {
  searchProducts?:  {
    __typename: "SearchableProductConnection",
    items?:  Array< {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type GetBundleProductQueryVariables = {
  company: string,
  id: string,
};

export type GetBundleProductQuery = {
  getBundleProduct?:  {
    __typename: "BundleProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListBundleProductsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelBundleProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBundleProductsQuery = {
  listBundleProducts?:  {
    __typename: "ModelBundleProductConnection",
    items?:  Array< {
      __typename: "BundleProduct",
      company: string,
      id: string,
      parentId: string,
      productId: string,
      createdAt: string,
      updatedAt: string,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListBundleProductByParentIdQueryVariables = {
  company?: string | null,
  parentId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBundleProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBundleProductByParentIdQuery = {
  listBundleProductByParentId?:  {
    __typename: "ModelBundleProductConnection",
    items?:  Array< {
      __typename: "BundleProduct",
      company: string,
      id: string,
      parentId: string,
      productId: string,
      createdAt: string,
      updatedAt: string,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListBundleProductByProductIdQueryVariables = {
  company?: string | null,
  productId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBundleProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBundleProductByProductIdQuery = {
  listBundleProductByProductId?:  {
    __typename: "ModelBundleProductConnection",
    items?:  Array< {
      __typename: "BundleProduct",
      company: string,
      id: string,
      parentId: string,
      productId: string,
      createdAt: string,
      updatedAt: string,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetFeatureQueryVariables = {
  company: string,
  id: string,
};

export type GetFeatureQuery = {
  getFeature?:  {
    __typename: "Feature",
    company: string,
    id: string,
    parentId: string,
    categoryId?: string | null,
    text: string,
    description?: string | null,
    imageUrl?: string | null,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFeaturesQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelFeatureFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListFeaturesQuery = {
  listFeatures?:  {
    __typename: "ModelFeatureConnection",
    items?:  Array< {
      __typename: "Feature",
      company: string,
      id: string,
      parentId: string,
      categoryId?: string | null,
      text: string,
      description?: string | null,
      imageUrl?: string | null,
      seq?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetCouponQueryVariables = {
  company: string,
  id: string,
};

export type GetCouponQuery = {
  getCoupon?:  {
    __typename: "Coupon",
    company: string,
    id: string,
    description?: string | null,
    type: CouponTypeEnum,
    status: CouponStatusEnum,
    expireAt: string,
    startTime: string,
    value: number,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    qtyAvailable: number,
    qtyReserved: number,
    qtyUsed: number,
    minSpend?: number | null,
    maxSpend?: number | null,
    createdAt: string,
    updatedAt: string,
    version: number,
    products?:  {
      __typename: "ModelCouponProductConnection",
      items?:  Array< {
        __typename: "CouponProduct",
        company: string,
        id: string,
        couponId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListCouponsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelCouponFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCouponsQuery = {
  listCoupons?:  {
    __typename: "ModelCouponConnection",
    items?:  Array< {
      __typename: "Coupon",
      company: string,
      id: string,
      description?: string | null,
      type: CouponTypeEnum,
      status: CouponStatusEnum,
      expireAt: string,
      startTime: string,
      value: number,
      settings?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      qtyAvailable: number,
      qtyReserved: number,
      qtyUsed: number,
      minSpend?: number | null,
      maxSpend?: number | null,
      createdAt: string,
      updatedAt: string,
      version: number,
      products?:  {
        __typename: "ModelCouponProductConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListCouponsByStatusExpiryQueryVariables = {
  company?: string | null,
  statusExpireAt?: ModelCouponByStatusExpireAtCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCouponFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCouponsByStatusExpiryQuery = {
  listCouponsByStatusExpiry?:  {
    __typename: "ModelCouponConnection",
    items?:  Array< {
      __typename: "Coupon",
      company: string,
      id: string,
      description?: string | null,
      type: CouponTypeEnum,
      status: CouponStatusEnum,
      expireAt: string,
      startTime: string,
      value: number,
      settings?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      qtyAvailable: number,
      qtyReserved: number,
      qtyUsed: number,
      minSpend?: number | null,
      maxSpend?: number | null,
      createdAt: string,
      updatedAt: string,
      version: number,
      products?:  {
        __typename: "ModelCouponProductConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetCouponProductQueryVariables = {
  company: string,
  id: string,
};

export type GetCouponProductQuery = {
  getCouponProduct?:  {
    __typename: "CouponProduct",
    company: string,
    id: string,
    couponId: string,
    productId: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCouponProductsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelCouponProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCouponProductsQuery = {
  listCouponProducts?:  {
    __typename: "ModelCouponProductConnection",
    items?:  Array< {
      __typename: "CouponProduct",
      company: string,
      id: string,
      couponId: string,
      productId: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListCouponProductByCouponIdQueryVariables = {
  company?: string | null,
  couponId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCouponProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCouponProductByCouponIdQuery = {
  listCouponProductByCouponId?:  {
    __typename: "ModelCouponProductConnection",
    items?:  Array< {
      __typename: "CouponProduct",
      company: string,
      id: string,
      couponId: string,
      productId: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListCouponProductByProductIdQueryVariables = {
  company?: string | null,
  productId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCouponProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCouponProductByProductIdQuery = {
  listCouponProductByProductId?:  {
    __typename: "ModelCouponProductConnection",
    items?:  Array< {
      __typename: "CouponProduct",
      company: string,
      id: string,
      couponId: string,
      productId: string,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetStockItemQueryVariables = {
  company: string,
  id: string,
};

export type GetStockItemQuery = {
  getStockItem?:  {
    __typename: "StockItem",
    company: string,
    id: string,
    location: string,
    serialNumber: string,
    status?: StockItemStatusEnum | null,
    productId: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListStockItemsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelStockItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListStockItemsQuery = {
  listStockItems?:  {
    __typename: "ModelStockItemConnection",
    items?:  Array< {
      __typename: "StockItem",
      company: string,
      id: string,
      location: string,
      serialNumber: string,
      status?: StockItemStatusEnum | null,
      productId: string,
      createdAt: string,
      updatedAt: string,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListStockItemsByProductQueryVariables = {
  company?: string | null,
  productId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStockItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStockItemsByProductQuery = {
  listStockItemsByProduct?:  {
    __typename: "ModelStockItemConnection",
    items?:  Array< {
      __typename: "StockItem",
      company: string,
      id: string,
      location: string,
      serialNumber: string,
      status?: StockItemStatusEnum | null,
      productId: string,
      createdAt: string,
      updatedAt: string,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListLocationStockItemsQueryVariables = {
  company?: string | null,
  location?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStockItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLocationStockItemsQuery = {
  listLocationStockItems?:  {
    __typename: "ModelStockItemConnection",
    items?:  Array< {
      __typename: "StockItem",
      company: string,
      id: string,
      location: string,
      serialNumber: string,
      status?: StockItemStatusEnum | null,
      productId: string,
      createdAt: string,
      updatedAt: string,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetProductCategoryQueryVariables = {
  company: string,
  id: string,
};

export type GetProductCategoryQuery = {
  getProductCategory?:  {
    __typename: "ProductCategory",
    company: string,
    id: string,
    categoryId: string,
    productId: string,
    seq: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    category?:  {
      __typename: "Category",
      company: string,
      id: string,
      name: string,
      description?: string | null,
      slug?: string | null,
      imageUrl?: string | null,
      parentId?: string | null,
      seq?: number | null,
      hidden?: boolean | null,
      createdAt: string,
      updatedAt: string,
      products?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      children?:  {
        __typename: "ModelCategoryConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListProductCategorysQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelProductCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListProductCategorysQuery = {
  listProductCategorys?:  {
    __typename: "ModelProductCategoryConnection",
    items?:  Array< {
      __typename: "ProductCategory",
      company: string,
      id: string,
      categoryId: string,
      productId: string,
      seq: string,
      createdAt: string,
      updatedAt: string,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
      category?:  {
        __typename: "Category",
        company: string,
        id: string,
        name: string,
        description?: string | null,
        slug?: string | null,
        imageUrl?: string | null,
        parentId?: string | null,
        seq?: number | null,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListCategoriesByProductQueryVariables = {
  company?: string | null,
  productId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCategoriesByProductQuery = {
  listCategoriesByProduct?:  {
    __typename: "ModelProductCategoryConnection",
    items?:  Array< {
      __typename: "ProductCategory",
      company: string,
      id: string,
      categoryId: string,
      productId: string,
      seq: string,
      createdAt: string,
      updatedAt: string,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
      category?:  {
        __typename: "Category",
        company: string,
        id: string,
        name: string,
        description?: string | null,
        slug?: string | null,
        imageUrl?: string | null,
        parentId?: string | null,
        seq?: number | null,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListProductsByCategoryQueryVariables = {
  company?: string | null,
  categoryIdSeq?: ModelProductCategoryByCategorySeqCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductsByCategoryQuery = {
  listProductsByCategory?:  {
    __typename: "ModelProductCategoryConnection",
    items?:  Array< {
      __typename: "ProductCategory",
      company: string,
      id: string,
      categoryId: string,
      productId: string,
      seq: string,
      createdAt: string,
      updatedAt: string,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
      category?:  {
        __typename: "Category",
        company: string,
        id: string,
        name: string,
        description?: string | null,
        slug?: string | null,
        imageUrl?: string | null,
        parentId?: string | null,
        seq?: number | null,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type SearchProductCategorysQueryVariables = {
  filter?: SearchableProductCategoryFilterInput | null,
  sort?: SearchableProductCategorySortInput | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SearchProductCategorysQuery = {
  searchProductCategorys?:  {
    __typename: "SearchableProductCategoryConnection",
    items?:  Array< {
      __typename: "ProductCategory",
      company: string,
      id: string,
      categoryId: string,
      productId: string,
      seq: string,
      createdAt: string,
      updatedAt: string,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
      category?:  {
        __typename: "Category",
        company: string,
        id: string,
        name: string,
        description?: string | null,
        slug?: string | null,
        imageUrl?: string | null,
        parentId?: string | null,
        seq?: number | null,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type GetRelatedProductQueryVariables = {
  company: string,
  id: string,
};

export type GetRelatedProductQuery = {
  getRelatedProduct?:  {
    __typename: "RelatedProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListRelatedProductsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelRelatedProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListRelatedProductsQuery = {
  listRelatedProducts?:  {
    __typename: "ModelRelatedProductConnection",
    items?:  Array< {
      __typename: "RelatedProduct",
      company: string,
      id: string,
      parentId: string,
      productId: string,
      seq?: number | null,
      createdAt: string,
      updatedAt: string,
      parent?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListRelatedProductsByProductQueryVariables = {
  company?: string | null,
  productId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRelatedProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRelatedProductsByProductQuery = {
  listRelatedProductsByProduct?:  {
    __typename: "ModelRelatedProductConnection",
    items?:  Array< {
      __typename: "RelatedProduct",
      company: string,
      id: string,
      parentId: string,
      productId: string,
      seq?: number | null,
      createdAt: string,
      updatedAt: string,
      parent?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListRelatedProductsByParentQueryVariables = {
  company?: string | null,
  parentId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRelatedProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRelatedProductsByParentQuery = {
  listRelatedProductsByParent?:  {
    __typename: "ModelRelatedProductConnection",
    items?:  Array< {
      __typename: "RelatedProduct",
      company: string,
      id: string,
      parentId: string,
      productId: string,
      seq?: number | null,
      createdAt: string,
      updatedAt: string,
      parent?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetUpsellProductQueryVariables = {
  company: string,
  id: string,
};

export type GetUpsellProductQuery = {
  getUpsellProduct?:  {
    __typename: "UpsellProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListUpsellProductsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelUpsellProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUpsellProductsQuery = {
  listUpsellProducts?:  {
    __typename: "ModelUpsellProductConnection",
    items?:  Array< {
      __typename: "UpsellProduct",
      company: string,
      id: string,
      parentId: string,
      productId: string,
      seq?: number | null,
      createdAt: string,
      updatedAt: string,
      parent?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListUpsellByParentIdQueryVariables = {
  company?: string | null,
  parentId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUpsellProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUpsellByParentIdQuery = {
  listUpsellByParentId?:  {
    __typename: "ModelUpsellProductConnection",
    items?:  Array< {
      __typename: "UpsellProduct",
      company: string,
      id: string,
      parentId: string,
      productId: string,
      seq?: number | null,
      createdAt: string,
      updatedAt: string,
      parent?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetCrossSellProductQueryVariables = {
  company: string,
  id: string,
};

export type GetCrossSellProductQuery = {
  getCrossSellProduct?:  {
    __typename: "CrossSellProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListCrossSellProductsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelCrossSellProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCrossSellProductsQuery = {
  listCrossSellProducts?:  {
    __typename: "ModelCrossSellProductConnection",
    items?:  Array< {
      __typename: "CrossSellProduct",
      company: string,
      id: string,
      parentId: string,
      productId: string,
      seq?: number | null,
      createdAt: string,
      updatedAt: string,
      parent?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListCrossSellByParentIdQueryVariables = {
  company?: string | null,
  parentId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCrossSellProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCrossSellByParentIdQuery = {
  listCrossSellByParentId?:  {
    __typename: "ModelCrossSellProductConnection",
    items?:  Array< {
      __typename: "CrossSellProduct",
      company: string,
      id: string,
      parentId: string,
      productId: string,
      seq?: number | null,
      createdAt: string,
      updatedAt: string,
      parent?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
      product?:  {
        __typename: "Product",
        company: string,
        id: string,
        comloc: string,
        sku: string,
        type: ProductTypeEnum,
        name: string,
        slug: string,
        excerpt?: string | null,
        mediaId: string,
        description?: string | null,
        status?: ProductStatusEnum | null,
        price?: number | null,
        deposit?: number | null,
        cost?: number | null,
        qtyOnHand: number,
        qtyAvailable: number,
        qtyReserved: number,
        createdAt: string,
        updatedAt: string,
        version: number,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetCategoryQueryVariables = {
  company: string,
  id: string,
};

export type GetCategoryQuery = {
  getCategory?:  {
    __typename: "Category",
    company: string,
    id: string,
    name: string,
    description?: string | null,
    slug?: string | null,
    imageUrl?: string | null,
    parentId?: string | null,
    seq?: number | null,
    hidden?: boolean | null,
    createdAt: string,
    updatedAt: string,
    products?:  {
      __typename: "ModelProductCategoryConnection",
      items?:  Array< {
        __typename: "ProductCategory",
        company: string,
        id: string,
        categoryId: string,
        productId: string,
        seq: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    children?:  {
      __typename: "ModelCategoryConnection",
      items?:  Array< {
        __typename: "Category",
        company: string,
        id: string,
        name: string,
        description?: string | null,
        slug?: string | null,
        imageUrl?: string | null,
        parentId?: string | null,
        seq?: number | null,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListCategorysQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCategorysQuery = {
  listCategorys?:  {
    __typename: "ModelCategoryConnection",
    items?:  Array< {
      __typename: "Category",
      company: string,
      id: string,
      name: string,
      description?: string | null,
      slug?: string | null,
      imageUrl?: string | null,
      parentId?: string | null,
      seq?: number | null,
      hidden?: boolean | null,
      createdAt: string,
      updatedAt: string,
      products?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      children?:  {
        __typename: "ModelCategoryConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListCategoriesBySlugQueryVariables = {
  slug?: string | null,
  company?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCategoriesBySlugQuery = {
  listCategoriesBySlug?:  {
    __typename: "ModelCategoryConnection",
    items?:  Array< {
      __typename: "Category",
      company: string,
      id: string,
      name: string,
      description?: string | null,
      slug?: string | null,
      imageUrl?: string | null,
      parentId?: string | null,
      seq?: number | null,
      hidden?: boolean | null,
      createdAt: string,
      updatedAt: string,
      products?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      children?:  {
        __typename: "ModelCategoryConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListCategoriesByParentIdQueryVariables = {
  parentId?: string | null,
  company?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCategoriesByParentIdQuery = {
  listCategoriesByParentId?:  {
    __typename: "ModelCategoryConnection",
    items?:  Array< {
      __typename: "Category",
      company: string,
      id: string,
      name: string,
      description?: string | null,
      slug?: string | null,
      imageUrl?: string | null,
      parentId?: string | null,
      seq?: number | null,
      hidden?: boolean | null,
      createdAt: string,
      updatedAt: string,
      products?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      children?:  {
        __typename: "ModelCategoryConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetMediaQueryVariables = {
  company: string,
  id: string,
};

export type GetMediaQuery = {
  getMedia?:  {
    __typename: "Media",
    company: string,
    id: string,
    url: string,
    name?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMediasQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelMediaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListMediasQuery = {
  listMedias?:  {
    __typename: "ModelMediaConnection",
    items?:  Array< {
      __typename: "Media",
      company: string,
      id: string,
      url: string,
      name?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetShippingZoneQueryVariables = {
  company: string,
  id: string,
};

export type GetShippingZoneQuery = {
  getShippingZone?:  {
    __typename: "ShippingZone",
    company: string,
    id: string,
    name: string,
    regions?: string | null,
    createdAt: string,
    updatedAt: string,
    shippingRegions?:  {
      __typename: "ModelShippingRegionConnection",
      items?:  Array< {
        __typename: "ShippingRegion",
        company: string,
        id: string,
        zoneId: string,
        description?: string | null,
        type?: ShippingRegionTypeEnum | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    shippingMethods?:  {
      __typename: "ModelZoneShippingMethodConnection",
      items?:  Array< {
        __typename: "ZoneShippingMethod",
        company: string,
        id: string,
        zoneId: string,
        shippingMethodId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListShippingZonesQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelShippingZoneFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListShippingZonesQuery = {
  listShippingZones?:  {
    __typename: "ModelShippingZoneConnection",
    items?:  Array< {
      __typename: "ShippingZone",
      company: string,
      id: string,
      name: string,
      regions?: string | null,
      createdAt: string,
      updatedAt: string,
      shippingRegions?:  {
        __typename: "ModelShippingRegionConnection",
        nextToken?: string | null,
      } | null,
      shippingMethods?:  {
        __typename: "ModelZoneShippingMethodConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListShippingZonesByRegionQueryVariables = {
  company?: string | null,
  regions?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelShippingZoneFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListShippingZonesByRegionQuery = {
  listShippingZonesByRegion?:  {
    __typename: "ModelShippingZoneConnection",
    items?:  Array< {
      __typename: "ShippingZone",
      company: string,
      id: string,
      name: string,
      regions?: string | null,
      createdAt: string,
      updatedAt: string,
      shippingRegions?:  {
        __typename: "ModelShippingRegionConnection",
        nextToken?: string | null,
      } | null,
      shippingMethods?:  {
        __typename: "ModelZoneShippingMethodConnection",
        nextToken?: string | null,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetShippingRegionQueryVariables = {
  company: string,
  id: string,
};

export type GetShippingRegionQuery = {
  getShippingRegion?:  {
    __typename: "ShippingRegion",
    company: string,
    id: string,
    zoneId: string,
    description?: string | null,
    type?: ShippingRegionTypeEnum | null,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
    shippingZone?:  {
      __typename: "ShippingZone",
      company: string,
      id: string,
      name: string,
      regions?: string | null,
      createdAt: string,
      updatedAt: string,
      shippingRegions?:  {
        __typename: "ModelShippingRegionConnection",
        nextToken?: string | null,
      } | null,
      shippingMethods?:  {
        __typename: "ModelZoneShippingMethodConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListShippingRegionsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelShippingRegionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListShippingRegionsQuery = {
  listShippingRegions?:  {
    __typename: "ModelShippingRegionConnection",
    items?:  Array< {
      __typename: "ShippingRegion",
      company: string,
      id: string,
      zoneId: string,
      description?: string | null,
      type?: ShippingRegionTypeEnum | null,
      data?: string | null,
      createdAt: string,
      updatedAt: string,
      shippingZone?:  {
        __typename: "ShippingZone",
        company: string,
        id: string,
        name: string,
        regions?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListShippingRegionsByZoneQueryVariables = {
  company?: string | null,
  zoneId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelShippingRegionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListShippingRegionsByZoneQuery = {
  listShippingRegionsByZone?:  {
    __typename: "ModelShippingRegionConnection",
    items?:  Array< {
      __typename: "ShippingRegion",
      company: string,
      id: string,
      zoneId: string,
      description?: string | null,
      type?: ShippingRegionTypeEnum | null,
      data?: string | null,
      createdAt: string,
      updatedAt: string,
      shippingZone?:  {
        __typename: "ShippingZone",
        company: string,
        id: string,
        name: string,
        regions?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListShippingRegionsByTypeDataQueryVariables = {
  company?: string | null,
  typeData?: ModelShippingRegionByTypeDataCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelShippingRegionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListShippingRegionsByTypeDataQuery = {
  listShippingRegionsByTypeData?:  {
    __typename: "ModelShippingRegionConnection",
    items?:  Array< {
      __typename: "ShippingRegion",
      company: string,
      id: string,
      zoneId: string,
      description?: string | null,
      type?: ShippingRegionTypeEnum | null,
      data?: string | null,
      createdAt: string,
      updatedAt: string,
      shippingZone?:  {
        __typename: "ShippingZone",
        company: string,
        id: string,
        name: string,
        regions?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetShippingMethodQueryVariables = {
  company: string,
  id: string,
};

export type GetShippingMethodQuery = {
  getShippingMethod?:  {
    __typename: "ShippingMethod",
    company: string,
    id: string,
    type: DeliveryTypeEnum,
    name: string,
    cost: number,
    address?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListShippingMethodsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelShippingMethodFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListShippingMethodsQuery = {
  listShippingMethods?:  {
    __typename: "ModelShippingMethodConnection",
    items?:  Array< {
      __typename: "ShippingMethod",
      company: string,
      id: string,
      type: DeliveryTypeEnum,
      name: string,
      cost: number,
      address?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetZoneShippingMethodQueryVariables = {
  company: string,
  id: string,
};

export type GetZoneShippingMethodQuery = {
  getZoneShippingMethod?:  {
    __typename: "ZoneShippingMethod",
    company: string,
    id: string,
    zoneId: string,
    shippingMethodId: string,
    createdAt: string,
    updatedAt: string,
    shippingMethod?:  {
      __typename: "ShippingMethod",
      company: string,
      id: string,
      type: DeliveryTypeEnum,
      name: string,
      cost: number,
      address?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ListZoneShippingMethodsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelZoneShippingMethodFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListZoneShippingMethodsQuery = {
  listZoneShippingMethods?:  {
    __typename: "ModelZoneShippingMethodConnection",
    items?:  Array< {
      __typename: "ZoneShippingMethod",
      company: string,
      id: string,
      zoneId: string,
      shippingMethodId: string,
      createdAt: string,
      updatedAt: string,
      shippingMethod?:  {
        __typename: "ShippingMethod",
        company: string,
        id: string,
        type: DeliveryTypeEnum,
        name: string,
        cost: number,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetProductPriceQueryVariables = {
  company: string,
  id: string,
};

export type GetProductPriceQuery = {
  getProductPrice?:  {
    __typename: "ProductPrice",
    company: string,
    id: string,
    productId: string,
    startTime?: string | null,
    endTime?: string | null,
    price?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProductPricesQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelProductPriceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListProductPricesQuery = {
  listProductPrices?:  {
    __typename: "ModelProductPriceConnection",
    items?:  Array< {
      __typename: "ProductPrice",
      company: string,
      id: string,
      productId: string,
      startTime?: string | null,
      endTime?: string | null,
      price?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetDiscountQueryVariables = {
  company: string,
  id: string,
};

export type GetDiscountQuery = {
  getDiscount?:  {
    __typename: "Discount",
    company: string,
    id: string,
    name: string,
    rules?:  Array< {
      __typename: "DiscountRule",
      conditionScope: DiscountScopeEnum,
      condition:  {
        __typename: "DiscountRuleCondition",
        ne?: number | null,
        eq?: number | null,
        le?: number | null,
        lt?: number | null,
        ge?: number | null,
        gt?: number | null,
        between?: Array< number | null > | null,
      },
      discountScope: DiscountScopeEnum,
      type: DiscountRuleTypeEnum,
      value: number,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListDiscountsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelDiscountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDiscountsQuery = {
  listDiscounts?:  {
    __typename: "ModelDiscountConnection",
    items?:  Array< {
      __typename: "Discount",
      company: string,
      id: string,
      name: string,
      rules?:  Array< {
        __typename: "DiscountRule",
        conditionScope: DiscountScopeEnum,
        discountScope: DiscountScopeEnum,
        type: DiscountRuleTypeEnum,
        value: number,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetLogQueryVariables = {
  company: string,
  id: string,
};

export type GetLogQuery = {
  getLog?:  {
    __typename: "Log",
    company: string,
    id: string,
    parentId: string,
    event: string,
    source?: string | null,
    destination?: string | null,
    description?: string | null,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLogsQueryVariables = {
  company?: string | null,
  id?: ModelIDKeyConditionInput | null,
  filter?: ModelLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLogsQuery = {
  listLogs?:  {
    __typename: "ModelLogConnection",
    items?:  Array< {
      __typename: "Log",
      company: string,
      id: string,
      parentId: string,
      event: string,
      source?: string | null,
      destination?: string | null,
      description?: string | null,
      data?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListLogByParentIdQueryVariables = {
  company?: string | null,
  parentId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogByParentIdQuery = {
  listLogByParentId?:  {
    __typename: "ModelLogConnection",
    items?:  Array< {
      __typename: "Log",
      company: string,
      id: string,
      parentId: string,
      event: string,
      source?: string | null,
      destination?: string | null,
      description?: string | null,
      data?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListLogByParentIdEventQueryVariables = {
  company?: string | null,
  parentIdEvent?: ModelLogByParentIdEventCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogByParentIdEventQuery = {
  listLogByParentIdEvent?:  {
    __typename: "ModelLogConnection",
    items?:  Array< {
      __typename: "Log",
      company: string,
      id: string,
      parentId: string,
      event: string,
      source?: string | null,
      destination?: string | null,
      description?: string | null,
      data?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type OnUpdatePaymentSubscriptionVariables = {
  customerId?: string | null,
  company?: string | null,
};

export type OnUpdatePaymentSubscription = {
  onUpdatePayment?:  {
    __typename: "Payment",
    company: string,
    id: string,
    customerId: string,
    orderId: string,
    status: PaymentStatusEnum,
    currency: string,
    originalCurrency?: string | null,
    conversionRate?: number | null,
    totalGross: number,
    totalFee?: number | null,
    totalNet?: number | null,
    processorId: string,
    extPaymentId?: string | null,
    processorData?: string | null,
    createdAt: string,
    reason?: string | null,
    updatedAt: string,
    customer?:  {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    processor?:  {
      __typename: "CompanyPaymentProcessor",
      company: string,
      id: string,
      name?: string | null,
      description?: string | null,
      active?: boolean | null,
      formValues?:  Array< {
        __typename: "FieldValue",
        name: string,
        type: string,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
      processor?:  {
        __typename: "PaymentProcessor",
        id: string,
        name?: string | null,
        description?: string | null,
        active?: boolean | null,
        logo?: string | null,
        countries?: Array< string | null > | null,
        website?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnCreateCompanySubscriptionVariables = {
  id?: string | null,
};

export type OnCreateCompanySubscription = {
  onCreateCompany?:  {
    __typename: "Company",
    id: string,
    status?: CompanyStatusEnum | null,
    plan: string,
    email: string,
    timeZone: string,
    locale?: string | null,
    country: string,
    currency?: string | null,
    billingDetails?:  {
      __typename: "BillingDetails",
      processor: string,
      currency: string,
      nextPaymentDate: string,
      nextPaymentAmount: number,
    } | null,
    cards?: string | null,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    accountPayments?:  {
      __typename: "ModelAccountPaymentConnection",
      items?:  Array< {
        __typename: "AccountPayment",
        company: string,
        id: string,
        plan: string,
        status: PaymentStatusEnum,
        currency: string,
        totalGross: number,
        totalFee: number,
        totalNet: number,
        processor?: string | null,
        processorData?: string | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateCompanySubscriptionVariables = {
  id?: string | null,
};

export type OnUpdateCompanySubscription = {
  onUpdateCompany?:  {
    __typename: "Company",
    id: string,
    status?: CompanyStatusEnum | null,
    plan: string,
    email: string,
    timeZone: string,
    locale?: string | null,
    country: string,
    currency?: string | null,
    billingDetails?:  {
      __typename: "BillingDetails",
      processor: string,
      currency: string,
      nextPaymentDate: string,
      nextPaymentAmount: number,
    } | null,
    cards?: string | null,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    accountPayments?:  {
      __typename: "ModelAccountPaymentConnection",
      items?:  Array< {
        __typename: "AccountPayment",
        company: string,
        id: string,
        plan: string,
        status: PaymentStatusEnum,
        currency: string,
        totalGross: number,
        totalFee: number,
        totalNet: number,
        processor?: string | null,
        processorData?: string | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteCompanySubscriptionVariables = {
  id?: string | null,
};

export type OnDeleteCompanySubscription = {
  onDeleteCompany?:  {
    __typename: "Company",
    id: string,
    status?: CompanyStatusEnum | null,
    plan: string,
    email: string,
    timeZone: string,
    locale?: string | null,
    country: string,
    currency?: string | null,
    billingDetails?:  {
      __typename: "BillingDetails",
      processor: string,
      currency: string,
      nextPaymentDate: string,
      nextPaymentAmount: number,
    } | null,
    cards?: string | null,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    accountPayments?:  {
      __typename: "ModelAccountPaymentConnection",
      items?:  Array< {
        __typename: "AccountPayment",
        company: string,
        id: string,
        plan: string,
        status: PaymentStatusEnum,
        currency: string,
        totalGross: number,
        totalFee: number,
        totalNet: number,
        processor?: string | null,
        processorData?: string | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateLocationSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateLocationSubscription = {
  onCreateLocation?:  {
    __typename: "Location",
    company: string,
    id: string,
    createdAt: string,
    name: string,
    description?: string | null,
    type: LocationTypeEnum,
    email?: string | null,
    phoneNumber?: string | null,
    physicalAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    updatedAt: string,
    settings?:  {
      __typename: "ModelSettingConnection",
      items?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateLocationSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateLocationSubscription = {
  onUpdateLocation?:  {
    __typename: "Location",
    company: string,
    id: string,
    createdAt: string,
    name: string,
    description?: string | null,
    type: LocationTypeEnum,
    email?: string | null,
    phoneNumber?: string | null,
    physicalAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    updatedAt: string,
    settings?:  {
      __typename: "ModelSettingConnection",
      items?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteLocationSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteLocationSubscription = {
  onDeleteLocation?:  {
    __typename: "Location",
    company: string,
    id: string,
    createdAt: string,
    name: string,
    description?: string | null,
    type: LocationTypeEnum,
    email?: string | null,
    phoneNumber?: string | null,
    physicalAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    updatedAt: string,
    settings?:  {
      __typename: "ModelSettingConnection",
      items?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateSettingSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateSettingSubscription = {
  onCreateSetting?:  {
    __typename: "Setting",
    company: string,
    parentId: string,
    settingId: string,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSettingSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateSettingSubscription = {
  onUpdateSetting?:  {
    __typename: "Setting",
    company: string,
    parentId: string,
    settingId: string,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSettingSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteSettingSubscription = {
  onDeleteSetting?:  {
    __typename: "Setting",
    company: string,
    parentId: string,
    settingId: string,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAccountPaymentSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateAccountPaymentSubscription = {
  onCreateAccountPayment?:  {
    __typename: "AccountPayment",
    company: string,
    id: string,
    plan: string,
    status: PaymentStatusEnum,
    currency: string,
    totalGross: number,
    totalFee: number,
    totalNet: number,
    processor?: string | null,
    processorData?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateAccountPaymentSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateAccountPaymentSubscription = {
  onUpdateAccountPayment?:  {
    __typename: "AccountPayment",
    company: string,
    id: string,
    plan: string,
    status: PaymentStatusEnum,
    currency: string,
    totalGross: number,
    totalFee: number,
    totalNet: number,
    processor?: string | null,
    processorData?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteAccountPaymentSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteAccountPaymentSubscription = {
  onDeleteAccountPayment?:  {
    __typename: "AccountPayment",
    company: string,
    id: string,
    plan: string,
    status: PaymentStatusEnum,
    currency: string,
    totalGross: number,
    totalFee: number,
    totalNet: number,
    processor?: string | null,
    processorData?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateCustomerSubscriptionVariables = {
  id?: string | null,
  company?: string | null,
};

export type OnCreateCustomerSubscription = {
  onCreateCustomer?:  {
    __typename: "Customer",
    company: string,
    id: string,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    physicalAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCustomerSubscriptionVariables = {
  id?: string | null,
  company?: string | null,
};

export type OnUpdateCustomerSubscription = {
  onUpdateCustomer?:  {
    __typename: "Customer",
    company: string,
    id: string,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    physicalAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCustomerSubscriptionVariables = {
  id?: string | null,
  company?: string | null,
};

export type OnDeleteCustomerSubscription = {
  onDeleteCustomer?:  {
    __typename: "Customer",
    company: string,
    id: string,
    email?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    physicalAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePaymentProcessorSubscription = {
  onCreatePaymentProcessor?:  {
    __typename: "PaymentProcessor",
    id: string,
    name?: string | null,
    description?: string | null,
    active?: boolean | null,
    logo?: string | null,
    formFields?:  Array< {
      __typename: "FieldDefinition",
      name: string,
      type: string,
      required: boolean,
      tooltip?: string | null,
    } | null > | null,
    countries?: Array< string | null > | null,
    website?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePaymentProcessorSubscription = {
  onUpdatePaymentProcessor?:  {
    __typename: "PaymentProcessor",
    id: string,
    name?: string | null,
    description?: string | null,
    active?: boolean | null,
    logo?: string | null,
    formFields?:  Array< {
      __typename: "FieldDefinition",
      name: string,
      type: string,
      required: boolean,
      tooltip?: string | null,
    } | null > | null,
    countries?: Array< string | null > | null,
    website?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePaymentProcessorSubscription = {
  onDeletePaymentProcessor?:  {
    __typename: "PaymentProcessor",
    id: string,
    name?: string | null,
    description?: string | null,
    active?: boolean | null,
    logo?: string | null,
    formFields?:  Array< {
      __typename: "FieldDefinition",
      name: string,
      type: string,
      required: boolean,
      tooltip?: string | null,
    } | null > | null,
    countries?: Array< string | null > | null,
    website?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCompanyPaymentProcessorSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateCompanyPaymentProcessorSubscription = {
  onCreateCompanyPaymentProcessor?:  {
    __typename: "CompanyPaymentProcessor",
    company: string,
    id: string,
    name?: string | null,
    description?: string | null,
    active?: boolean | null,
    formValues?:  Array< {
      __typename: "FieldValue",
      name: string,
      type: string,
      value?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    processor?:  {
      __typename: "PaymentProcessor",
      id: string,
      name?: string | null,
      description?: string | null,
      active?: boolean | null,
      logo?: string | null,
      formFields?:  Array< {
        __typename: "FieldDefinition",
        name: string,
        type: string,
        required: boolean,
        tooltip?: string | null,
      } | null > | null,
      countries?: Array< string | null > | null,
      website?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnUpdateCompanyPaymentProcessorSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateCompanyPaymentProcessorSubscription = {
  onUpdateCompanyPaymentProcessor?:  {
    __typename: "CompanyPaymentProcessor",
    company: string,
    id: string,
    name?: string | null,
    description?: string | null,
    active?: boolean | null,
    formValues?:  Array< {
      __typename: "FieldValue",
      name: string,
      type: string,
      value?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    processor?:  {
      __typename: "PaymentProcessor",
      id: string,
      name?: string | null,
      description?: string | null,
      active?: boolean | null,
      logo?: string | null,
      formFields?:  Array< {
        __typename: "FieldDefinition",
        name: string,
        type: string,
        required: boolean,
        tooltip?: string | null,
      } | null > | null,
      countries?: Array< string | null > | null,
      website?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnDeleteCompanyPaymentProcessorSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteCompanyPaymentProcessorSubscription = {
  onDeleteCompanyPaymentProcessor?:  {
    __typename: "CompanyPaymentProcessor",
    company: string,
    id: string,
    name?: string | null,
    description?: string | null,
    active?: boolean | null,
    formValues?:  Array< {
      __typename: "FieldValue",
      name: string,
      type: string,
      value?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
    processor?:  {
      __typename: "PaymentProcessor",
      id: string,
      name?: string | null,
      description?: string | null,
      active?: boolean | null,
      logo?: string | null,
      formFields?:  Array< {
        __typename: "FieldDefinition",
        name: string,
        type: string,
        required: boolean,
        tooltip?: string | null,
      } | null > | null,
      countries?: Array< string | null > | null,
      website?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnCreateSequenceSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateSequenceSubscription = {
  onCreateSequence?:  {
    __typename: "Sequence",
    company: string,
    id: string,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSequenceSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateSequenceSubscription = {
  onUpdateSequence?:  {
    __typename: "Sequence",
    company: string,
    id: string,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSequenceSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteSequenceSubscription = {
  onDeleteSequence?:  {
    __typename: "Sequence",
    company: string,
    id: string,
    version: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateOrderSubscriptionVariables = {
  owner?: string | null,
  company?: string | null,
};

export type OnCreateOrderSubscription = {
  onCreateOrder?:  {
    __typename: "Order",
    company: string,
    id: string,
    type?: OrderTypeEnum | null,
    status?: OrderStatusEnum | null,
    ref: string,
    locationId?: string | null,
    customerId: string,
    customerEmail?: string | null,
    customerFirstName?: string | null,
    customerLastName?: string | null,
    owner: string,
    categoryId?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    contactNumber?: string | null,
    deliveryType?: DeliveryTypeEnum | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryTime?: string | null,
    returnedTime?: string | null,
    confirmedTime?: string | null,
    deliveredTime?: string | null,
    total?: number | null,
    deposit?: number | null,
    subTotal?: number | null,
    discountTotal?: number | null,
    deliveryFee?: number | null,
    reason?: string | null,
    notes?: string | null,
    createdAt: string,
    completedAt?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    updatedAt: string,
    customer?:  {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    payments?:  {
      __typename: "ModelPaymentConnection",
      items?:  Array< {
        __typename: "Payment",
        company: string,
        id: string,
        customerId: string,
        orderId: string,
        status: PaymentStatusEnum,
        currency: string,
        originalCurrency?: string | null,
        conversionRate?: number | null,
        totalGross: number,
        totalFee?: number | null,
        totalNet?: number | null,
        processorId: string,
        extPaymentId?: string | null,
        processorData?: string | null,
        createdAt: string,
        reason?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    products?:  {
      __typename: "ModelOrderProductConnection",
      items?:  Array< {
        __typename: "OrderProduct",
        company: string,
        id: string,
        orderId: string,
        productId: string,
        owner: string,
        orderType: OrderTypeEnum,
        startTime?: string | null,
        endTime?: string | null,
        qty: number,
        total: number,
        subTotal: number,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    coupons?:  {
      __typename: "ModelOrderCouponConnection",
      items?:  Array< {
        __typename: "OrderCoupon",
        company: string,
        id: string,
        orderId: string,
        couponId: string,
        owner: string,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelOrderStockItemConnection",
      items?:  Array< {
        __typename: "OrderStockItem",
        company: string,
        id: string,
        orderId: string,
        stockItemId: string,
        orderType: OrderTypeEnum,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    logs?:  {
      __typename: "ModelLogConnection",
      items?:  Array< {
        __typename: "Log",
        company: string,
        id: string,
        parentId: string,
        event: string,
        source?: string | null,
        destination?: string | null,
        description?: string | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateOrderSubscriptionVariables = {
  owner?: string | null,
  company?: string | null,
};

export type OnUpdateOrderSubscription = {
  onUpdateOrder?:  {
    __typename: "Order",
    company: string,
    id: string,
    type?: OrderTypeEnum | null,
    status?: OrderStatusEnum | null,
    ref: string,
    locationId?: string | null,
    customerId: string,
    customerEmail?: string | null,
    customerFirstName?: string | null,
    customerLastName?: string | null,
    owner: string,
    categoryId?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    contactNumber?: string | null,
    deliveryType?: DeliveryTypeEnum | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryTime?: string | null,
    returnedTime?: string | null,
    confirmedTime?: string | null,
    deliveredTime?: string | null,
    total?: number | null,
    deposit?: number | null,
    subTotal?: number | null,
    discountTotal?: number | null,
    deliveryFee?: number | null,
    reason?: string | null,
    notes?: string | null,
    createdAt: string,
    completedAt?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    updatedAt: string,
    customer?:  {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    payments?:  {
      __typename: "ModelPaymentConnection",
      items?:  Array< {
        __typename: "Payment",
        company: string,
        id: string,
        customerId: string,
        orderId: string,
        status: PaymentStatusEnum,
        currency: string,
        originalCurrency?: string | null,
        conversionRate?: number | null,
        totalGross: number,
        totalFee?: number | null,
        totalNet?: number | null,
        processorId: string,
        extPaymentId?: string | null,
        processorData?: string | null,
        createdAt: string,
        reason?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    products?:  {
      __typename: "ModelOrderProductConnection",
      items?:  Array< {
        __typename: "OrderProduct",
        company: string,
        id: string,
        orderId: string,
        productId: string,
        owner: string,
        orderType: OrderTypeEnum,
        startTime?: string | null,
        endTime?: string | null,
        qty: number,
        total: number,
        subTotal: number,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    coupons?:  {
      __typename: "ModelOrderCouponConnection",
      items?:  Array< {
        __typename: "OrderCoupon",
        company: string,
        id: string,
        orderId: string,
        couponId: string,
        owner: string,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelOrderStockItemConnection",
      items?:  Array< {
        __typename: "OrderStockItem",
        company: string,
        id: string,
        orderId: string,
        stockItemId: string,
        orderType: OrderTypeEnum,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    logs?:  {
      __typename: "ModelLogConnection",
      items?:  Array< {
        __typename: "Log",
        company: string,
        id: string,
        parentId: string,
        event: string,
        source?: string | null,
        destination?: string | null,
        description?: string | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteOrderSubscriptionVariables = {
  owner?: string | null,
  company?: string | null,
};

export type OnDeleteOrderSubscription = {
  onDeleteOrder?:  {
    __typename: "Order",
    company: string,
    id: string,
    type?: OrderTypeEnum | null,
    status?: OrderStatusEnum | null,
    ref: string,
    locationId?: string | null,
    customerId: string,
    customerEmail?: string | null,
    customerFirstName?: string | null,
    customerLastName?: string | null,
    owner: string,
    categoryId?: string | null,
    startTime?: string | null,
    endTime?: string | null,
    contactNumber?: string | null,
    deliveryType?: DeliveryTypeEnum | null,
    billingAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryAddress?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    deliveryTime?: string | null,
    returnedTime?: string | null,
    confirmedTime?: string | null,
    deliveredTime?: string | null,
    total?: number | null,
    deposit?: number | null,
    subTotal?: number | null,
    discountTotal?: number | null,
    deliveryFee?: number | null,
    reason?: string | null,
    notes?: string | null,
    createdAt: string,
    completedAt?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    updatedAt: string,
    customer?:  {
      __typename: "Customer",
      company: string,
      id: string,
      email?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      physicalAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    payments?:  {
      __typename: "ModelPaymentConnection",
      items?:  Array< {
        __typename: "Payment",
        company: string,
        id: string,
        customerId: string,
        orderId: string,
        status: PaymentStatusEnum,
        currency: string,
        originalCurrency?: string | null,
        conversionRate?: number | null,
        totalGross: number,
        totalFee?: number | null,
        totalNet?: number | null,
        processorId: string,
        extPaymentId?: string | null,
        processorData?: string | null,
        createdAt: string,
        reason?: string | null,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    products?:  {
      __typename: "ModelOrderProductConnection",
      items?:  Array< {
        __typename: "OrderProduct",
        company: string,
        id: string,
        orderId: string,
        productId: string,
        owner: string,
        orderType: OrderTypeEnum,
        startTime?: string | null,
        endTime?: string | null,
        qty: number,
        total: number,
        subTotal: number,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    coupons?:  {
      __typename: "ModelOrderCouponConnection",
      items?:  Array< {
        __typename: "OrderCoupon",
        company: string,
        id: string,
        orderId: string,
        couponId: string,
        owner: string,
        discountTotal: number,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelOrderStockItemConnection",
      items?:  Array< {
        __typename: "OrderStockItem",
        company: string,
        id: string,
        orderId: string,
        stockItemId: string,
        orderType: OrderTypeEnum,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    logs?:  {
      __typename: "ModelLogConnection",
      items?:  Array< {
        __typename: "Log",
        company: string,
        id: string,
        parentId: string,
        event: string,
        source?: string | null,
        destination?: string | null,
        description?: string | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateOrderProductSubscriptionVariables = {
  owner?: string | null,
  company?: string | null,
};

export type OnCreateOrderProductSubscription = {
  onCreateOrderProduct?:  {
    __typename: "OrderProduct",
    company: string,
    id: string,
    orderId: string,
    productId: string,
    owner: string,
    productInfo:  {
      __typename: "OrderProductInfo",
      name: string,
      categoryId?: string | null,
      description?: string | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      imageUrl?: string | null,
      price: number,
    },
    orderType: OrderTypeEnum,
    startTime?: string | null,
    endTime?: string | null,
    qty: number,
    total: number,
    subTotal: number,
    discountTotal: number,
    createdAt: string,
    updatedAt: string,
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateOrderProductSubscriptionVariables = {
  owner?: string | null,
  company?: string | null,
};

export type OnUpdateOrderProductSubscription = {
  onUpdateOrderProduct?:  {
    __typename: "OrderProduct",
    company: string,
    id: string,
    orderId: string,
    productId: string,
    owner: string,
    productInfo:  {
      __typename: "OrderProductInfo",
      name: string,
      categoryId?: string | null,
      description?: string | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      imageUrl?: string | null,
      price: number,
    },
    orderType: OrderTypeEnum,
    startTime?: string | null,
    endTime?: string | null,
    qty: number,
    total: number,
    subTotal: number,
    discountTotal: number,
    createdAt: string,
    updatedAt: string,
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteOrderProductSubscriptionVariables = {
  owner?: string | null,
  company?: string | null,
};

export type OnDeleteOrderProductSubscription = {
  onDeleteOrderProduct?:  {
    __typename: "OrderProduct",
    company: string,
    id: string,
    orderId: string,
    productId: string,
    owner: string,
    productInfo:  {
      __typename: "OrderProductInfo",
      name: string,
      categoryId?: string | null,
      description?: string | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      imageUrl?: string | null,
      price: number,
    },
    orderType: OrderTypeEnum,
    startTime?: string | null,
    endTime?: string | null,
    qty: number,
    total: number,
    subTotal: number,
    discountTotal: number,
    createdAt: string,
    updatedAt: string,
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateOrderCouponSubscriptionVariables = {
  owner?: string | null,
  company?: string | null,
};

export type OnCreateOrderCouponSubscription = {
  onCreateOrderCoupon?:  {
    __typename: "OrderCoupon",
    company: string,
    id: string,
    orderId: string,
    couponId: string,
    owner: string,
    coupon?:  {
      __typename: "Coupon",
      company: string,
      id: string,
      description?: string | null,
      type: CouponTypeEnum,
      status: CouponStatusEnum,
      expireAt: string,
      startTime: string,
      value: number,
      settings?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      qtyAvailable: number,
      qtyReserved: number,
      qtyUsed: number,
      minSpend?: number | null,
      maxSpend?: number | null,
      createdAt: string,
      updatedAt: string,
      version: number,
      products?:  {
        __typename: "ModelCouponProductConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    discountTotal: number,
    createdAt: string,
    updatedAt: string,
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateOrderCouponSubscriptionVariables = {
  owner?: string | null,
  company?: string | null,
};

export type OnUpdateOrderCouponSubscription = {
  onUpdateOrderCoupon?:  {
    __typename: "OrderCoupon",
    company: string,
    id: string,
    orderId: string,
    couponId: string,
    owner: string,
    coupon?:  {
      __typename: "Coupon",
      company: string,
      id: string,
      description?: string | null,
      type: CouponTypeEnum,
      status: CouponStatusEnum,
      expireAt: string,
      startTime: string,
      value: number,
      settings?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      qtyAvailable: number,
      qtyReserved: number,
      qtyUsed: number,
      minSpend?: number | null,
      maxSpend?: number | null,
      createdAt: string,
      updatedAt: string,
      version: number,
      products?:  {
        __typename: "ModelCouponProductConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    discountTotal: number,
    createdAt: string,
    updatedAt: string,
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteOrderCouponSubscriptionVariables = {
  owner?: string | null,
  company?: string | null,
};

export type OnDeleteOrderCouponSubscription = {
  onDeleteOrderCoupon?:  {
    __typename: "OrderCoupon",
    company: string,
    id: string,
    orderId: string,
    couponId: string,
    owner: string,
    coupon?:  {
      __typename: "Coupon",
      company: string,
      id: string,
      description?: string | null,
      type: CouponTypeEnum,
      status: CouponStatusEnum,
      expireAt: string,
      startTime: string,
      value: number,
      settings?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      qtyAvailable: number,
      qtyReserved: number,
      qtyUsed: number,
      minSpend?: number | null,
      maxSpend?: number | null,
      createdAt: string,
      updatedAt: string,
      version: number,
      products?:  {
        __typename: "ModelCouponProductConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    discountTotal: number,
    createdAt: string,
    updatedAt: string,
    order?:  {
      __typename: "Order",
      company: string,
      id: string,
      type?: OrderTypeEnum | null,
      status?: OrderStatusEnum | null,
      ref: string,
      locationId?: string | null,
      customerId: string,
      customerEmail?: string | null,
      customerFirstName?: string | null,
      customerLastName?: string | null,
      owner: string,
      categoryId?: string | null,
      startTime?: string | null,
      endTime?: string | null,
      contactNumber?: string | null,
      deliveryType?: DeliveryTypeEnum | null,
      billingAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryAddress?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      deliveryTime?: string | null,
      returnedTime?: string | null,
      confirmedTime?: string | null,
      deliveredTime?: string | null,
      total?: number | null,
      deposit?: number | null,
      subTotal?: number | null,
      discountTotal?: number | null,
      deliveryFee?: number | null,
      reason?: string | null,
      notes?: string | null,
      createdAt: string,
      completedAt?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      updatedAt: string,
      customer?:  {
        __typename: "Customer",
        company: string,
        id: string,
        email?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      payments?:  {
        __typename: "ModelPaymentConnection",
        nextToken?: string | null,
      } | null,
      products?:  {
        __typename: "ModelOrderProductConnection",
        nextToken?: string | null,
      } | null,
      coupons?:  {
        __typename: "ModelOrderCouponConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelOrderStockItemConnection",
        nextToken?: string | null,
      } | null,
      logs?:  {
        __typename: "ModelLogConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateOrderStockItemSubscriptionVariables = {
  owner?: string | null,
  company?: string | null,
};

export type OnCreateOrderStockItemSubscription = {
  onCreateOrderStockItem?:  {
    __typename: "OrderStockItem",
    company: string,
    id: string,
    orderId: string,
    stockItemId: string,
    orderType: OrderTypeEnum,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateOrderStockItemSubscriptionVariables = {
  owner?: string | null,
  company?: string | null,
};

export type OnUpdateOrderStockItemSubscription = {
  onUpdateOrderStockItem?:  {
    __typename: "OrderStockItem",
    company: string,
    id: string,
    orderId: string,
    stockItemId: string,
    orderType: OrderTypeEnum,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteOrderStockItemSubscriptionVariables = {
  owner?: string | null,
  company?: string | null,
};

export type OnDeleteOrderStockItemSubscription = {
  onDeleteOrderStockItem?:  {
    __typename: "OrderStockItem",
    company: string,
    id: string,
    orderId: string,
    stockItemId: string,
    orderType: OrderTypeEnum,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateProductSubscription = {
  onCreateProduct?:  {
    __typename: "Product",
    company: string,
    id: string,
    comloc: string,
    sku: string,
    type: ProductTypeEnum,
    name: string,
    slug: string,
    excerpt?: string | null,
    mediaId: string,
    description?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    status?: ProductStatusEnum | null,
    price?: number | null,
    deposit?: number | null,
    cost?: number | null,
    dimensions?:  {
      __typename: "Dimensions",
      height?: number | null,
      width?: number | null,
      weight?: number | null,
      length?: number | null,
    } | null,
    qtyOnHand: number,
    qtyAvailable: number,
    qtyReserved: number,
    createdAt: string,
    updatedAt: string,
    version: number,
    settings?:  {
      __typename: "ModelSettingConnection",
      items?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    bundleProducts?:  {
      __typename: "ModelBundleProductConnection",
      items?:  Array< {
        __typename: "BundleProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    features?:  {
      __typename: "ModelFeatureConnection",
      items?:  Array< {
        __typename: "Feature",
        company: string,
        id: string,
        parentId: string,
        categoryId?: string | null,
        text: string,
        description?: string | null,
        imageUrl?: string | null,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelStockItemConnection",
      items?:  Array< {
        __typename: "StockItem",
        company: string,
        id: string,
        location: string,
        serialNumber: string,
        status?: StockItemStatusEnum | null,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    categories?:  {
      __typename: "ModelProductCategoryConnection",
      items?:  Array< {
        __typename: "ProductCategory",
        company: string,
        id: string,
        categoryId: string,
        productId: string,
        seq: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    upsellProducts?:  {
      __typename: "ModelUpsellProductConnection",
      items?:  Array< {
        __typename: "UpsellProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    crossSellProducts?:  {
      __typename: "ModelCrossSellProductConnection",
      items?:  Array< {
        __typename: "CrossSellProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    image?:  {
      __typename: "Media",
      company: string,
      id: string,
      url: string,
      name?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    media?:  {
      __typename: "ModelMediaItemConnection",
      items?:  Array< {
        __typename: "MediaItem",
        company: string,
        id: string,
        mediaId: string,
        parentId: string,
        default?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    customPrice?:  {
      __typename: "ModelProductPriceConnection",
      items?:  Array< {
        __typename: "ProductPrice",
        company: string,
        id: string,
        productId: string,
        startTime?: string | null,
        endTime?: string | null,
        price?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateProductSubscription = {
  onUpdateProduct?:  {
    __typename: "Product",
    company: string,
    id: string,
    comloc: string,
    sku: string,
    type: ProductTypeEnum,
    name: string,
    slug: string,
    excerpt?: string | null,
    mediaId: string,
    description?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    status?: ProductStatusEnum | null,
    price?: number | null,
    deposit?: number | null,
    cost?: number | null,
    dimensions?:  {
      __typename: "Dimensions",
      height?: number | null,
      width?: number | null,
      weight?: number | null,
      length?: number | null,
    } | null,
    qtyOnHand: number,
    qtyAvailable: number,
    qtyReserved: number,
    createdAt: string,
    updatedAt: string,
    version: number,
    settings?:  {
      __typename: "ModelSettingConnection",
      items?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    bundleProducts?:  {
      __typename: "ModelBundleProductConnection",
      items?:  Array< {
        __typename: "BundleProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    features?:  {
      __typename: "ModelFeatureConnection",
      items?:  Array< {
        __typename: "Feature",
        company: string,
        id: string,
        parentId: string,
        categoryId?: string | null,
        text: string,
        description?: string | null,
        imageUrl?: string | null,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelStockItemConnection",
      items?:  Array< {
        __typename: "StockItem",
        company: string,
        id: string,
        location: string,
        serialNumber: string,
        status?: StockItemStatusEnum | null,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    categories?:  {
      __typename: "ModelProductCategoryConnection",
      items?:  Array< {
        __typename: "ProductCategory",
        company: string,
        id: string,
        categoryId: string,
        productId: string,
        seq: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    upsellProducts?:  {
      __typename: "ModelUpsellProductConnection",
      items?:  Array< {
        __typename: "UpsellProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    crossSellProducts?:  {
      __typename: "ModelCrossSellProductConnection",
      items?:  Array< {
        __typename: "CrossSellProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    image?:  {
      __typename: "Media",
      company: string,
      id: string,
      url: string,
      name?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    media?:  {
      __typename: "ModelMediaItemConnection",
      items?:  Array< {
        __typename: "MediaItem",
        company: string,
        id: string,
        mediaId: string,
        parentId: string,
        default?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    customPrice?:  {
      __typename: "ModelProductPriceConnection",
      items?:  Array< {
        __typename: "ProductPrice",
        company: string,
        id: string,
        productId: string,
        startTime?: string | null,
        endTime?: string | null,
        price?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteProductSubscription = {
  onDeleteProduct?:  {
    __typename: "Product",
    company: string,
    id: string,
    comloc: string,
    sku: string,
    type: ProductTypeEnum,
    name: string,
    slug: string,
    excerpt?: string | null,
    mediaId: string,
    description?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    status?: ProductStatusEnum | null,
    price?: number | null,
    deposit?: number | null,
    cost?: number | null,
    dimensions?:  {
      __typename: "Dimensions",
      height?: number | null,
      width?: number | null,
      weight?: number | null,
      length?: number | null,
    } | null,
    qtyOnHand: number,
    qtyAvailable: number,
    qtyReserved: number,
    createdAt: string,
    updatedAt: string,
    version: number,
    settings?:  {
      __typename: "ModelSettingConnection",
      items?:  Array< {
        __typename: "Setting",
        company: string,
        parentId: string,
        settingId: string,
        value?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    bundleProducts?:  {
      __typename: "ModelBundleProductConnection",
      items?:  Array< {
        __typename: "BundleProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    features?:  {
      __typename: "ModelFeatureConnection",
      items?:  Array< {
        __typename: "Feature",
        company: string,
        id: string,
        parentId: string,
        categoryId?: string | null,
        text: string,
        description?: string | null,
        imageUrl?: string | null,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    stockItems?:  {
      __typename: "ModelStockItemConnection",
      items?:  Array< {
        __typename: "StockItem",
        company: string,
        id: string,
        location: string,
        serialNumber: string,
        status?: StockItemStatusEnum | null,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    categories?:  {
      __typename: "ModelProductCategoryConnection",
      items?:  Array< {
        __typename: "ProductCategory",
        company: string,
        id: string,
        categoryId: string,
        productId: string,
        seq: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    upsellProducts?:  {
      __typename: "ModelUpsellProductConnection",
      items?:  Array< {
        __typename: "UpsellProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    crossSellProducts?:  {
      __typename: "ModelCrossSellProductConnection",
      items?:  Array< {
        __typename: "CrossSellProduct",
        company: string,
        id: string,
        parentId: string,
        productId: string,
        seq?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    image?:  {
      __typename: "Media",
      company: string,
      id: string,
      url: string,
      name?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    media?:  {
      __typename: "ModelMediaItemConnection",
      items?:  Array< {
        __typename: "MediaItem",
        company: string,
        id: string,
        mediaId: string,
        parentId: string,
        default?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    customPrice?:  {
      __typename: "ModelProductPriceConnection",
      items?:  Array< {
        __typename: "ProductPrice",
        company: string,
        id: string,
        productId: string,
        startTime?: string | null,
        endTime?: string | null,
        price?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateBundleProductSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateBundleProductSubscription = {
  onCreateBundleProduct?:  {
    __typename: "BundleProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateBundleProductSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateBundleProductSubscription = {
  onUpdateBundleProduct?:  {
    __typename: "BundleProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteBundleProductSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteBundleProductSubscription = {
  onDeleteBundleProduct?:  {
    __typename: "BundleProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateFeatureSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateFeatureSubscription = {
  onCreateFeature?:  {
    __typename: "Feature",
    company: string,
    id: string,
    parentId: string,
    categoryId?: string | null,
    text: string,
    description?: string | null,
    imageUrl?: string | null,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateFeatureSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateFeatureSubscription = {
  onUpdateFeature?:  {
    __typename: "Feature",
    company: string,
    id: string,
    parentId: string,
    categoryId?: string | null,
    text: string,
    description?: string | null,
    imageUrl?: string | null,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteFeatureSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteFeatureSubscription = {
  onDeleteFeature?:  {
    __typename: "Feature",
    company: string,
    id: string,
    parentId: string,
    categoryId?: string | null,
    text: string,
    description?: string | null,
    imageUrl?: string | null,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCouponSubscription = {
  onCreateCoupon?:  {
    __typename: "Coupon",
    company: string,
    id: string,
    description?: string | null,
    type: CouponTypeEnum,
    status: CouponStatusEnum,
    expireAt: string,
    startTime: string,
    value: number,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    qtyAvailable: number,
    qtyReserved: number,
    qtyUsed: number,
    minSpend?: number | null,
    maxSpend?: number | null,
    createdAt: string,
    updatedAt: string,
    version: number,
    products?:  {
      __typename: "ModelCouponProductConnection",
      items?:  Array< {
        __typename: "CouponProduct",
        company: string,
        id: string,
        couponId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateCouponSubscription = {
  onUpdateCoupon?:  {
    __typename: "Coupon",
    company: string,
    id: string,
    description?: string | null,
    type: CouponTypeEnum,
    status: CouponStatusEnum,
    expireAt: string,
    startTime: string,
    value: number,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    qtyAvailable: number,
    qtyReserved: number,
    qtyUsed: number,
    minSpend?: number | null,
    maxSpend?: number | null,
    createdAt: string,
    updatedAt: string,
    version: number,
    products?:  {
      __typename: "ModelCouponProductConnection",
      items?:  Array< {
        __typename: "CouponProduct",
        company: string,
        id: string,
        couponId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteCouponSubscription = {
  onDeleteCoupon?:  {
    __typename: "Coupon",
    company: string,
    id: string,
    description?: string | null,
    type: CouponTypeEnum,
    status: CouponStatusEnum,
    expireAt: string,
    startTime: string,
    value: number,
    settings?:  Array< {
      __typename: "Setting",
      company: string,
      parentId: string,
      settingId: string,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
    qtyAvailable: number,
    qtyReserved: number,
    qtyUsed: number,
    minSpend?: number | null,
    maxSpend?: number | null,
    createdAt: string,
    updatedAt: string,
    version: number,
    products?:  {
      __typename: "ModelCouponProductConnection",
      items?:  Array< {
        __typename: "CouponProduct",
        company: string,
        id: string,
        couponId: string,
        productId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateCouponProductSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateCouponProductSubscription = {
  onCreateCouponProduct?:  {
    __typename: "CouponProduct",
    company: string,
    id: string,
    couponId: string,
    productId: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCouponProductSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateCouponProductSubscription = {
  onUpdateCouponProduct?:  {
    __typename: "CouponProduct",
    company: string,
    id: string,
    couponId: string,
    productId: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCouponProductSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteCouponProductSubscription = {
  onDeleteCouponProduct?:  {
    __typename: "CouponProduct",
    company: string,
    id: string,
    couponId: string,
    productId: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateStockItemSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateStockItemSubscription = {
  onCreateStockItem?:  {
    __typename: "StockItem",
    company: string,
    id: string,
    location: string,
    serialNumber: string,
    status?: StockItemStatusEnum | null,
    productId: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateStockItemSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateStockItemSubscription = {
  onUpdateStockItem?:  {
    __typename: "StockItem",
    company: string,
    id: string,
    location: string,
    serialNumber: string,
    status?: StockItemStatusEnum | null,
    productId: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteStockItemSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteStockItemSubscription = {
  onDeleteStockItem?:  {
    __typename: "StockItem",
    company: string,
    id: string,
    location: string,
    serialNumber: string,
    status?: StockItemStatusEnum | null,
    productId: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateProductCategorySubscriptionVariables = {
  company?: string | null,
};

export type OnCreateProductCategorySubscription = {
  onCreateProductCategory?:  {
    __typename: "ProductCategory",
    company: string,
    id: string,
    categoryId: string,
    productId: string,
    seq: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    category?:  {
      __typename: "Category",
      company: string,
      id: string,
      name: string,
      description?: string | null,
      slug?: string | null,
      imageUrl?: string | null,
      parentId?: string | null,
      seq?: number | null,
      hidden?: boolean | null,
      createdAt: string,
      updatedAt: string,
      products?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      children?:  {
        __typename: "ModelCategoryConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateProductCategorySubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateProductCategorySubscription = {
  onUpdateProductCategory?:  {
    __typename: "ProductCategory",
    company: string,
    id: string,
    categoryId: string,
    productId: string,
    seq: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    category?:  {
      __typename: "Category",
      company: string,
      id: string,
      name: string,
      description?: string | null,
      slug?: string | null,
      imageUrl?: string | null,
      parentId?: string | null,
      seq?: number | null,
      hidden?: boolean | null,
      createdAt: string,
      updatedAt: string,
      products?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      children?:  {
        __typename: "ModelCategoryConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteProductCategorySubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteProductCategorySubscription = {
  onDeleteProductCategory?:  {
    __typename: "ProductCategory",
    company: string,
    id: string,
    categoryId: string,
    productId: string,
    seq: string,
    createdAt: string,
    updatedAt: string,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    category?:  {
      __typename: "Category",
      company: string,
      id: string,
      name: string,
      description?: string | null,
      slug?: string | null,
      imageUrl?: string | null,
      parentId?: string | null,
      seq?: number | null,
      hidden?: boolean | null,
      createdAt: string,
      updatedAt: string,
      products?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      children?:  {
        __typename: "ModelCategoryConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateRelatedProductSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateRelatedProductSubscription = {
  onCreateRelatedProduct?:  {
    __typename: "RelatedProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateRelatedProductSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateRelatedProductSubscription = {
  onUpdateRelatedProduct?:  {
    __typename: "RelatedProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteRelatedProductSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteRelatedProductSubscription = {
  onDeleteRelatedProduct?:  {
    __typename: "RelatedProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateUpsellProductSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateUpsellProductSubscription = {
  onCreateUpsellProduct?:  {
    __typename: "UpsellProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateUpsellProductSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateUpsellProductSubscription = {
  onUpdateUpsellProduct?:  {
    __typename: "UpsellProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteUpsellProductSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteUpsellProductSubscription = {
  onDeleteUpsellProduct?:  {
    __typename: "UpsellProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateCrossSellProductSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateCrossSellProductSubscription = {
  onCreateCrossSellProduct?:  {
    __typename: "CrossSellProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateCrossSellProductSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateCrossSellProductSubscription = {
  onUpdateCrossSellProduct?:  {
    __typename: "CrossSellProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteCrossSellProductSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteCrossSellProductSubscription = {
  onDeleteCrossSellProduct?:  {
    __typename: "CrossSellProduct",
    company: string,
    id: string,
    parentId: string,
    productId: string,
    seq?: number | null,
    createdAt: string,
    updatedAt: string,
    parent?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
    product?:  {
      __typename: "Product",
      company: string,
      id: string,
      comloc: string,
      sku: string,
      type: ProductTypeEnum,
      name: string,
      slug: string,
      excerpt?: string | null,
      mediaId: string,
      description?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      status?: ProductStatusEnum | null,
      price?: number | null,
      deposit?: number | null,
      cost?: number | null,
      dimensions?:  {
        __typename: "Dimensions",
        height?: number | null,
        width?: number | null,
        weight?: number | null,
        length?: number | null,
      } | null,
      qtyOnHand: number,
      qtyAvailable: number,
      qtyReserved: number,
      createdAt: string,
      updatedAt: string,
      version: number,
      settings?:  {
        __typename: "ModelSettingConnection",
        nextToken?: string | null,
      } | null,
      bundleProducts?:  {
        __typename: "ModelBundleProductConnection",
        nextToken?: string | null,
      } | null,
      features?:  {
        __typename: "ModelFeatureConnection",
        nextToken?: string | null,
      } | null,
      stockItems?:  {
        __typename: "ModelStockItemConnection",
        nextToken?: string | null,
      } | null,
      categories?:  {
        __typename: "ModelProductCategoryConnection",
        nextToken?: string | null,
      } | null,
      upsellProducts?:  {
        __typename: "ModelUpsellProductConnection",
        nextToken?: string | null,
      } | null,
      crossSellProducts?:  {
        __typename: "ModelCrossSellProductConnection",
        nextToken?: string | null,
      } | null,
      image?:  {
        __typename: "Media",
        company: string,
        id: string,
        url: string,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      media?:  {
        __typename: "ModelMediaItemConnection",
        nextToken?: string | null,
      } | null,
      customPrice?:  {
        __typename: "ModelProductPriceConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateCategorySubscriptionVariables = {
  company?: string | null,
};

export type OnCreateCategorySubscription = {
  onCreateCategory?:  {
    __typename: "Category",
    company: string,
    id: string,
    name: string,
    description?: string | null,
    slug?: string | null,
    imageUrl?: string | null,
    parentId?: string | null,
    seq?: number | null,
    hidden?: boolean | null,
    createdAt: string,
    updatedAt: string,
    products?:  {
      __typename: "ModelProductCategoryConnection",
      items?:  Array< {
        __typename: "ProductCategory",
        company: string,
        id: string,
        categoryId: string,
        productId: string,
        seq: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    children?:  {
      __typename: "ModelCategoryConnection",
      items?:  Array< {
        __typename: "Category",
        company: string,
        id: string,
        name: string,
        description?: string | null,
        slug?: string | null,
        imageUrl?: string | null,
        parentId?: string | null,
        seq?: number | null,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateCategorySubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateCategorySubscription = {
  onUpdateCategory?:  {
    __typename: "Category",
    company: string,
    id: string,
    name: string,
    description?: string | null,
    slug?: string | null,
    imageUrl?: string | null,
    parentId?: string | null,
    seq?: number | null,
    hidden?: boolean | null,
    createdAt: string,
    updatedAt: string,
    products?:  {
      __typename: "ModelProductCategoryConnection",
      items?:  Array< {
        __typename: "ProductCategory",
        company: string,
        id: string,
        categoryId: string,
        productId: string,
        seq: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    children?:  {
      __typename: "ModelCategoryConnection",
      items?:  Array< {
        __typename: "Category",
        company: string,
        id: string,
        name: string,
        description?: string | null,
        slug?: string | null,
        imageUrl?: string | null,
        parentId?: string | null,
        seq?: number | null,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteCategorySubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteCategorySubscription = {
  onDeleteCategory?:  {
    __typename: "Category",
    company: string,
    id: string,
    name: string,
    description?: string | null,
    slug?: string | null,
    imageUrl?: string | null,
    parentId?: string | null,
    seq?: number | null,
    hidden?: boolean | null,
    createdAt: string,
    updatedAt: string,
    products?:  {
      __typename: "ModelProductCategoryConnection",
      items?:  Array< {
        __typename: "ProductCategory",
        company: string,
        id: string,
        categoryId: string,
        productId: string,
        seq: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    children?:  {
      __typename: "ModelCategoryConnection",
      items?:  Array< {
        __typename: "Category",
        company: string,
        id: string,
        name: string,
        description?: string | null,
        slug?: string | null,
        imageUrl?: string | null,
        parentId?: string | null,
        seq?: number | null,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateMediaSubscription = {
  onCreateMedia?:  {
    __typename: "Media",
    company: string,
    id: string,
    url: string,
    name?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMediaSubscription = {
  onUpdateMedia?:  {
    __typename: "Media",
    company: string,
    id: string,
    url: string,
    name?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMediaSubscription = {
  onDeleteMedia?:  {
    __typename: "Media",
    company: string,
    id: string,
    url: string,
    name?: string | null,
    attributes?:  Array< {
      __typename: "Attribute",
      name?: string | null,
      type?: string | null,
      value?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMediaItemSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateMediaItemSubscription = {
  onCreateMediaItem?:  {
    __typename: "MediaItem",
    company: string,
    id: string,
    mediaId: string,
    parentId: string,
    default?: boolean | null,
    createdAt: string,
    updatedAt: string,
    media?:  {
      __typename: "Media",
      company: string,
      id: string,
      url: string,
      name?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnUpdateMediaItemSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateMediaItemSubscription = {
  onUpdateMediaItem?:  {
    __typename: "MediaItem",
    company: string,
    id: string,
    mediaId: string,
    parentId: string,
    default?: boolean | null,
    createdAt: string,
    updatedAt: string,
    media?:  {
      __typename: "Media",
      company: string,
      id: string,
      url: string,
      name?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnDeleteMediaItemSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteMediaItemSubscription = {
  onDeleteMediaItem?:  {
    __typename: "MediaItem",
    company: string,
    id: string,
    mediaId: string,
    parentId: string,
    default?: boolean | null,
    createdAt: string,
    updatedAt: string,
    media?:  {
      __typename: "Media",
      company: string,
      id: string,
      url: string,
      name?: string | null,
      attributes?:  Array< {
        __typename: "Attribute",
        name?: string | null,
        type?: string | null,
        value?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnCreateShippingZoneSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateShippingZoneSubscription = {
  onCreateShippingZone?:  {
    __typename: "ShippingZone",
    company: string,
    id: string,
    name: string,
    regions?: string | null,
    createdAt: string,
    updatedAt: string,
    shippingRegions?:  {
      __typename: "ModelShippingRegionConnection",
      items?:  Array< {
        __typename: "ShippingRegion",
        company: string,
        id: string,
        zoneId: string,
        description?: string | null,
        type?: ShippingRegionTypeEnum | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    shippingMethods?:  {
      __typename: "ModelZoneShippingMethodConnection",
      items?:  Array< {
        __typename: "ZoneShippingMethod",
        company: string,
        id: string,
        zoneId: string,
        shippingMethodId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateShippingZoneSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateShippingZoneSubscription = {
  onUpdateShippingZone?:  {
    __typename: "ShippingZone",
    company: string,
    id: string,
    name: string,
    regions?: string | null,
    createdAt: string,
    updatedAt: string,
    shippingRegions?:  {
      __typename: "ModelShippingRegionConnection",
      items?:  Array< {
        __typename: "ShippingRegion",
        company: string,
        id: string,
        zoneId: string,
        description?: string | null,
        type?: ShippingRegionTypeEnum | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    shippingMethods?:  {
      __typename: "ModelZoneShippingMethodConnection",
      items?:  Array< {
        __typename: "ZoneShippingMethod",
        company: string,
        id: string,
        zoneId: string,
        shippingMethodId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteShippingZoneSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteShippingZoneSubscription = {
  onDeleteShippingZone?:  {
    __typename: "ShippingZone",
    company: string,
    id: string,
    name: string,
    regions?: string | null,
    createdAt: string,
    updatedAt: string,
    shippingRegions?:  {
      __typename: "ModelShippingRegionConnection",
      items?:  Array< {
        __typename: "ShippingRegion",
        company: string,
        id: string,
        zoneId: string,
        description?: string | null,
        type?: ShippingRegionTypeEnum | null,
        data?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
    shippingMethods?:  {
      __typename: "ModelZoneShippingMethodConnection",
      items?:  Array< {
        __typename: "ZoneShippingMethod",
        company: string,
        id: string,
        zoneId: string,
        shippingMethodId: string,
        createdAt: string,
        updatedAt: string,
      } | null > | null,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateShippingRegionSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateShippingRegionSubscription = {
  onCreateShippingRegion?:  {
    __typename: "ShippingRegion",
    company: string,
    id: string,
    zoneId: string,
    description?: string | null,
    type?: ShippingRegionTypeEnum | null,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
    shippingZone?:  {
      __typename: "ShippingZone",
      company: string,
      id: string,
      name: string,
      regions?: string | null,
      createdAt: string,
      updatedAt: string,
      shippingRegions?:  {
        __typename: "ModelShippingRegionConnection",
        nextToken?: string | null,
      } | null,
      shippingMethods?:  {
        __typename: "ModelZoneShippingMethodConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateShippingRegionSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateShippingRegionSubscription = {
  onUpdateShippingRegion?:  {
    __typename: "ShippingRegion",
    company: string,
    id: string,
    zoneId: string,
    description?: string | null,
    type?: ShippingRegionTypeEnum | null,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
    shippingZone?:  {
      __typename: "ShippingZone",
      company: string,
      id: string,
      name: string,
      regions?: string | null,
      createdAt: string,
      updatedAt: string,
      shippingRegions?:  {
        __typename: "ModelShippingRegionConnection",
        nextToken?: string | null,
      } | null,
      shippingMethods?:  {
        __typename: "ModelZoneShippingMethodConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteShippingRegionSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteShippingRegionSubscription = {
  onDeleteShippingRegion?:  {
    __typename: "ShippingRegion",
    company: string,
    id: string,
    zoneId: string,
    description?: string | null,
    type?: ShippingRegionTypeEnum | null,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
    shippingZone?:  {
      __typename: "ShippingZone",
      company: string,
      id: string,
      name: string,
      regions?: string | null,
      createdAt: string,
      updatedAt: string,
      shippingRegions?:  {
        __typename: "ModelShippingRegionConnection",
        nextToken?: string | null,
      } | null,
      shippingMethods?:  {
        __typename: "ModelZoneShippingMethodConnection",
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateShippingMethodSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateShippingMethodSubscription = {
  onCreateShippingMethod?:  {
    __typename: "ShippingMethod",
    company: string,
    id: string,
    type: DeliveryTypeEnum,
    name: string,
    cost: number,
    address?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateShippingMethodSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateShippingMethodSubscription = {
  onUpdateShippingMethod?:  {
    __typename: "ShippingMethod",
    company: string,
    id: string,
    type: DeliveryTypeEnum,
    name: string,
    cost: number,
    address?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteShippingMethodSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteShippingMethodSubscription = {
  onDeleteShippingMethod?:  {
    __typename: "ShippingMethod",
    company: string,
    id: string,
    type: DeliveryTypeEnum,
    name: string,
    cost: number,
    address?:  {
      __typename: "PhysicalAddress",
      text?: string | null,
      name?: string | null,
      address1?: string | null,
      address2?: string | null,
      address3?: string | null,
      zip?: string | null,
      city?: string | null,
      region?: string | null,
      country?: string | null,
      coordinates?:  {
        __typename: "Coordinates",
        lat: number,
        lon: number,
      } | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateZoneShippingMethodSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateZoneShippingMethodSubscription = {
  onCreateZoneShippingMethod?:  {
    __typename: "ZoneShippingMethod",
    company: string,
    id: string,
    zoneId: string,
    shippingMethodId: string,
    createdAt: string,
    updatedAt: string,
    shippingMethod?:  {
      __typename: "ShippingMethod",
      company: string,
      id: string,
      type: DeliveryTypeEnum,
      name: string,
      cost: number,
      address?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnUpdateZoneShippingMethodSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateZoneShippingMethodSubscription = {
  onUpdateZoneShippingMethod?:  {
    __typename: "ZoneShippingMethod",
    company: string,
    id: string,
    zoneId: string,
    shippingMethodId: string,
    createdAt: string,
    updatedAt: string,
    shippingMethod?:  {
      __typename: "ShippingMethod",
      company: string,
      id: string,
      type: DeliveryTypeEnum,
      name: string,
      cost: number,
      address?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnDeleteZoneShippingMethodSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteZoneShippingMethodSubscription = {
  onDeleteZoneShippingMethod?:  {
    __typename: "ZoneShippingMethod",
    company: string,
    id: string,
    zoneId: string,
    shippingMethodId: string,
    createdAt: string,
    updatedAt: string,
    shippingMethod?:  {
      __typename: "ShippingMethod",
      company: string,
      id: string,
      type: DeliveryTypeEnum,
      name: string,
      cost: number,
      address?:  {
        __typename: "PhysicalAddress",
        text?: string | null,
        name?: string | null,
        address1?: string | null,
        address2?: string | null,
        address3?: string | null,
        zip?: string | null,
        city?: string | null,
        region?: string | null,
        country?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnCreateProductPriceSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateProductPriceSubscription = {
  onCreateProductPrice?:  {
    __typename: "ProductPrice",
    company: string,
    id: string,
    productId: string,
    startTime?: string | null,
    endTime?: string | null,
    price?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateProductPriceSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateProductPriceSubscription = {
  onUpdateProductPrice?:  {
    __typename: "ProductPrice",
    company: string,
    id: string,
    productId: string,
    startTime?: string | null,
    endTime?: string | null,
    price?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteProductPriceSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteProductPriceSubscription = {
  onDeleteProductPrice?:  {
    __typename: "ProductPrice",
    company: string,
    id: string,
    productId: string,
    startTime?: string | null,
    endTime?: string | null,
    price?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateDiscountSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateDiscountSubscription = {
  onCreateDiscount?:  {
    __typename: "Discount",
    company: string,
    id: string,
    name: string,
    rules?:  Array< {
      __typename: "DiscountRule",
      conditionScope: DiscountScopeEnum,
      condition:  {
        __typename: "DiscountRuleCondition",
        ne?: number | null,
        eq?: number | null,
        le?: number | null,
        lt?: number | null,
        ge?: number | null,
        gt?: number | null,
        between?: Array< number | null > | null,
      },
      discountScope: DiscountScopeEnum,
      type: DiscountRuleTypeEnum,
      value: number,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateDiscountSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateDiscountSubscription = {
  onUpdateDiscount?:  {
    __typename: "Discount",
    company: string,
    id: string,
    name: string,
    rules?:  Array< {
      __typename: "DiscountRule",
      conditionScope: DiscountScopeEnum,
      condition:  {
        __typename: "DiscountRuleCondition",
        ne?: number | null,
        eq?: number | null,
        le?: number | null,
        lt?: number | null,
        ge?: number | null,
        gt?: number | null,
        between?: Array< number | null > | null,
      },
      discountScope: DiscountScopeEnum,
      type: DiscountRuleTypeEnum,
      value: number,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteDiscountSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteDiscountSubscription = {
  onDeleteDiscount?:  {
    __typename: "Discount",
    company: string,
    id: string,
    name: string,
    rules?:  Array< {
      __typename: "DiscountRule",
      conditionScope: DiscountScopeEnum,
      condition:  {
        __typename: "DiscountRuleCondition",
        ne?: number | null,
        eq?: number | null,
        le?: number | null,
        lt?: number | null,
        ge?: number | null,
        gt?: number | null,
        between?: Array< number | null > | null,
      },
      discountScope: DiscountScopeEnum,
      type: DiscountRuleTypeEnum,
      value: number,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLogSubscriptionVariables = {
  company?: string | null,
};

export type OnCreateLogSubscription = {
  onCreateLog?:  {
    __typename: "Log",
    company: string,
    id: string,
    parentId: string,
    event: string,
    source?: string | null,
    destination?: string | null,
    description?: string | null,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLogSubscriptionVariables = {
  company?: string | null,
};

export type OnUpdateLogSubscription = {
  onUpdateLog?:  {
    __typename: "Log",
    company: string,
    id: string,
    parentId: string,
    event: string,
    source?: string | null,
    destination?: string | null,
    description?: string | null,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLogSubscriptionVariables = {
  company?: string | null,
};

export type OnDeleteLogSubscription = {
  onDeleteLog?:  {
    __typename: "Log",
    company: string,
    id: string,
    parentId: string,
    event: string,
    source?: string | null,
    destination?: string | null,
    description?: string | null,
    data?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};
